// Ressource complète de traduction française canadienne
export const languageResourceFrCa = {
  translation: {
    language: 'fr_ca',
    NomLogiciel: 'OpenCash',
    total: 'Totaux',
    DescriptionLogiciel:
      'Communication bancaire, moyens de paiements, gestion de trésorerie...',
    pdfViewer: {
      Title: 'Aperçu avant impression',
    },
    label_title_liste: 'Liste des Labels',
    ListSmartTags: 'Liste des SmartTags',
    find_smart_tags: 'Recherche un SmartTag par code',
    ListBanque: 'Liste des Banques',
    find_banque: 'Rechercher une banque par code, nom ...',
    find_label: 'Rechercher un label par valeur de rubrique...',
    lecture_seule: ' (Lecture seule)',
    'List of companies': 'Liste des sociétés',
    State: 'Etat',
    None: 'Aucun',
    Name: 'Nom',
    Code: 'Code',
    vue_simple: 'Vue simple',
    vue_detail: 'Vue détaillée',
    expired_session:
      "Session expirée. Votre token d'authentification n'est plus valide. Veuillez vous reconnecter pour continuer.",
    update_timestamp: 'Date de modification',
    Edit: 'Éditer',
    Delete: 'Supprimer',
    Initialise: 'Initialiser',
    aSupprimer: 'A supprimer',
    Enter: 'Détail',
    Admin: 'Administrer',
    Import: 'Importer',
    Export: 'Exporter',
    New: 'Nouveau ',
    Element: 'élément',
    Elements: 'éléments',
    View: 'Voir',
    visu: 'Visualiser',
    error_required: '* Ce champ est obligatoire.',
    error_maxLength:
      '* Le nombre des caractères maximal autorisés est {{max}}.',
    error_minLength:
      '* Le nombre des caractères minimal autorisés est {{min}}.',
    Json_params: 'Visualiser paramètre json',
    Json: 'Visualiser json',
    Json_return: 'Visualiser réponse json',
    down_Json_params: 'Télécharger paramètre json',
    down_Json_return: 'Télécharger réponse json',
    History: 'Historique',
    Statement: 'Relevé',
    Back: 'Annuler',
    Selection: 'Sélection',
    next: 'Suivant',
    prev: 'Précédent',
    Ok: 'Ok',
    Print: 'Imprimer',
    Entity: 'Entité',
    refresh: 'Rafraîchir',
    'New company': 'Nouvelle société',
    'Fax number': 'N* Fax',
    'Phone number': 'N* Téléphone',
    'Legal informations': 'Informations légales',
    Address: 'Adresse',
    Administraion: 'Administraion',
    'Country code': 'Pays',
    'Closing date': 'Date de clôture',
    Duplicate: 'Dupliquer',
    Download: 'Télécharger',
    Restart: 'Relancer',
    Unlock: 'Declôturer',
    'Upload image': 'Télécharger une image',
    'Update company successfully': 'Mettre à jour la société avec succès',
    'Update company failed': 'Échec de la mise à jour de la société',
    Save: 'Enregistrer',
    'Company detail': 'Détail de la société',
    '4Eyes State': '4Eyes etat',
    'Liste des lots': 'Gestion des lots',
    Emetteur: 'Emetteur',
    'N remise': '# remise',
    Montant: 'Montant',
    Comment: 'Commentaire',
    Devise: 'Devise',
    pour1: 'Pour 1',
    Taux: 'Taux',
    Add: 'Ajouter',
    Reissue: 'Réemettre',
    Origine: 'Origine',
    Statut: 'Statut',
    Confirmation: 'Confirmation',
    Action_validation: "Validation de l'action",
    yes: 'Oui',
    no: 'Non',
    date_validation: "Date de l'action",
    Message_validation: "Voulez-vous valider l'action : ",
    remplace_document: 'Voulez-vous remplacer le document ? ',
    Valider: 'Valider',
    'Valider-New': 'Valider et nouveau',
    nextinvoicebutton: 'Remises suivantes',
    ValidDelete: 'Valider suppression',
    Fermer: 'Fermer',
    'Recherche grp tiers': 'Rechercher un groupe de tiers par code, nom ..',
    'Groupe de tiers': 'groupe de tiers',
    details: 'détails',
    Suppression: 'Voulez-vous supprimer ',
    Refuser: 'Désirez-vous refuser ce message ',
    Signer: 'Désirez-vous signer ce message ',
    Confirmer: 'Confirmer',
    Annuler: 'Annuler',
    Creer: 'Créer',
    RechercherSociete: 'Rechercher une société par code, nom ...',
    ComboEtat: '- Etat -',
    ComboFlux: '- Flux -',
    ComboFichier: '- Type Fichier -',
    ComboOrigine: '- Origine -',
    ComboStatut: '- Statut -',
    ComboGrpTiers: '- Groupe de tiers -',
    Signature: 'Signature',
    'Nb Operations': 'Nb',
    Rappro: 'Rapprochement',
    RechercheLot: 'Recherche un lot par numéro de lot, numéro de devise ...',
    RechercheTiers:
      'Rechercher un tiers par code, nom, numéro de compte, SIREN ..',
    Groupe: 'Groupe',
    'New tiers': "Création d'un nouveau tiers",
    'Details tiers': 'Fiche du tiers',
    General: 'Général',
    IBAN: 'Coordonnées bancaires',
    'Adresse tiers': 'Adresse du tiers',
    'Banque inter': 'Banque intermédiaire',
    Expand: 'Etendre',
    Nom: 'Nom',
    Prenom: 'Prénom',
    Naissance: 'Date de naissance',
    PNaissance: 'Pays de naissance',
    VNaissance: 'Ville de naissance',
    Company: 'Société',
    Rules: 'Règles',
    NCompte: 'N° de compte',
    AutoEmetteur: 'Autorisé compte émetteur',
    AutoTiers: 'Autorisé compte tiers',
    'Fiche du compte': 'Fiche du compte',
    'Informations complémentaires': 'Informations complémentaires',
    Collapse: 'Réduire',
    Action: 'Actions',
    NoData: 'Pas de données disponibles',
    Loading: 'Chargement en cours',
    'n° mobile': 'N° mobile',
    prenom: 'Prénom',
    nom: 'Nom',
    etat_user: 'Etat user',
    Etat_user_entite: 'User entity state',
    'N° demande': '#',
    'Type de demande': 'Type de demande',
    'Validation date': 'Validation / Refus',
    'Request type': 'type de demande',
    'Short name': 'nom (court)',
    valideur: 'validator',
    'Request date': 'date demande',
    Applicant: 'demandeur',
    titleChange: 'Changement de Filiale ou de Périmètre',
    AdminChange: 'Changement de Clients',
    listUserClientDispo: 'Client',
    listUserAdminDispo: 'Admin',
    Perim: 'Rechercher un périmètre',
    Fil: 'Rechercher une filiale',
    scope: 'Périmètre',
    entity: 'Filiale',
    copied: 'Copier',
    coller: 'Coller',
    search_user: "Rechercher un nom d'utilisateur",
    account_management: {
      account_list: 'Liste des comptes bancaires',
      search_txt:
        'Rechercher un compte par code, nom, numéro de compte, code société, nom société...',
      account_detail: 'Visualisation du relevé de compte',
      operation: 'opérations',
      search_detail:
        'Rechercher une opération par reférence , code , libellé ...',
    },
    bool: {
      yes: 'Oui',
      no: 'Non',
    },
    calendar: {
      today: "Aujourd'hui",
      yesterday: 'Hier',
      tomorrow: 'Demain',
      last7Days: '7 derniers jours',
      week: 'Cette semaine',
      mounth: 'Ce mois-ci',
      lastMonth: 'Mois dernier',
      last30days: '30 derniers jours',
      year: 'Cette année',
      lastYear: 'Année dernière',
      mon: 'Lun',
      tue: 'Mar',
      we: 'Mer',
      thu: 'Jeu',
      fri: 'Ven',
      sa: 'Sam',
      sun: 'Dim',
      formatdate: 'JJ/MM/AAAA',
      clear: 'Enlever',
      last_tree_mounth: 'Dernier trimestre',
      current_tree_mounth: 'Trimestre en cours',
      first_quarter: 'T1',
      second_quarter: 'T2',
      third_quarter: 'T3',
      fourth_quarter: 'T4',
      first_semestre: 'S1',
      second_semestre: 'S2',
      placeholder: 'JJ/MM/AAAA - JJ/MM/AAAA',
      placeholder_dateMonth: 'JJ/MM',
      placeholder_yearOnly: 'AAAA - AAAA',
      fullCalendarTitle: 'Calendrier Complet',
      month: 'Mois',
      day: 'Jour',
      addEvent: 'Ajouter un Événement',
      editEvent: "Modifier l'Événement",
      saveEvent: "Enregistrer l'Événement",
      updateEvent: "Mettre à jour l'Événement",
      eventTitle: "Titre de l'Événement",
      eventDescription: "Description de l'Événement",
      eventTitlePlaceholder: "Saisir le titre de l'événement...",
      eventDescriptionPlaceholder:
        "Saisir la description de l'événement (optionnel)...",
      confirmDelete:
        'Êtes-vous sûr de vouloir supprimer l\'événement "{{title}}" ?',
      back: 'Retour',
      january: 'Jan',
      february: 'Fév',
      march: 'Mar',
      april: 'Avr',
      may: 'Mai',
      june: 'Juin',
      july: 'Jul',
      august: 'Août',
      september: 'Sept',
      october: 'Oct',
      november: 'Nov',
      december: 'Déc',
    },
    treepicker: {
      placeholder: 'Recherche',
    },
    data_grid: {
      start: 'Min',
      end: 'Max',
      noDataToExport: 'Aucune donnée à exporter',
      pagination: 'Résultats par page',
      indexpagination: 'sur',
      showpagination: 'Afficher',
      diff_showpagination: 'Showing',
      diffindex: 'of',
    },
    Pays: 'Pays',
    login: {
      hometitle: 'OpenCash | Authentification',
      login: 'Login',
      forgotpassword: 'Mot de passe perdu ? ',
      reset: 'Réinitialiser',
      saveCredentials: 'Mémoriser',
      loginFailed: 'Identification erronée. Merci de réessayer',
      signin: 'Connexion',
      username_required: 'Email obligatoire',
      password_required: 'Mot de passe obligatoire',
      language: 'Préférence de langue',
      enter_email: 'Saisissez votre email',
      reset_password: 'Mot de passe',
      confirm_password: 'Confirmation de mot de passe',
      pwd: 'Mot de passe',
      back_to: 'Retour au',
      confirm_error: 'Le mot de passe ne correspondent pas',
      reset_password_label: 'Réinitialiser mot de passe',
      update_pwd_label: 'Mise à jour mot de passe',
      info_pwd_label:
        'Votre mot de passe est expiré, vous devez saisir un nouveau mot de passe',
      current_pwd: 'Mot de passe actuel',
      new_pwd: 'Nouveau mot de passe',
      confirm_new_pwd: 'Confirmer le nouveau mot de passe',
      send_mail: 'Envoyer un e-mail',
      update: 'Changer le mot de passe',
      current_password_required: 'Le mot de passe actuel est requis',
      password_min_length:
        'Le mot de passe doit contenir au moins 8 caractères',
      password_must_match: 'Les mots de passe ne correspondent pas',
      password_updated_success:
        'Votre mot de passe a été mis à jour avec succès',
      generic_error: 'Une erreur est survenue, veuillez réessayer',
      updating: 'Mise à jour en cours...',
    },
    creation_date: 'Date de création',
    execution_date: "Date d'éxécution",
    composant_document: {
      add_title: "Création d'un nouveau document",
      edit_title: 'Fiche document',
      txt_errorfile: 'Tous les champs sont obligatoires sauf la date de fin',
    },
    notification: {
      title: 'Notifications',
      empty: 'Notifications vide',
      show_not_seen: 'Afficher uniquement les non lues',
      mark_as_read: 'Marquer comme lu',
      clear_all: 'Effacer tout',
    },
    dashboard: {
      widget: {
        users: {
          title: 'Utilisateur(s)',
          header_title: 'Actifs',
          left_title: 'Signataires seul',
          middle_title: 'Signataires double',
          right_title: 'Mobiles',
          other_title: '',
        },
        jobs: {
          title: 'Jobs',
          header_title: "Aujourd'hui",
          left_title: 'ToDo',
          middle_title: 'Done',
          right_title: 'Failed',
          other_title: '',
        },
        deleted_batches: {
          title: 'Liste des lots refusés ou supprimés',
          numlot: 'N° Lot',
          compte: 'Compte',
          montant: 'Montant',
          devise: 'Devise',
          status: 'Statut',
          date: 'Date de refus',
          date_execution: "Date d'exécution",
          user: 'Login',
        },
        treasury_reconciliation: {
          title: 'Rapprochement de trésorerie',
          header_title: "Mouvements bancaires reçus aujourd'hui",
          left_title: 'Mouvements non rapprochés',
          middle_title: 'Prévisions échues',
          right_title: 'Prévisions temporaires',
        },
        treasury_account_control: {
          title: 'Contrôle comptes de trésorerie',
          header_title: 'Comptes gérés en trésorerie',
          left_title: 'Comptes Ok',
          middle_title: 'Comptes KO',
          right_title: 'Solde en valeur OK',
          other_title: 'Solde en valeur KO',
        },
        statistic_statements: {
          title: 'Relevés de compte',
          header_title: 'Comptes gérés',
          left_title: 'Comptes OK',
          middle_title: 'Bloqués',
          right_title: 'Comptes KO',
          other_title: '',
          tabs: {
            releves_compte: 'Relevés de compte',
            comptes_erreur: 'Comptes en erreur',
          },
          datagrid: {
            code: 'Code',
            solde: 'Solde',
            devise: 'Devise',
            date: 'Date de solde',
            status: 'Status',
            fault: 'Blocage',
            compte: 'Nom du Compte',
            banque: 'Banque',
          },
        },
        current_account: {
          treasury: {
            title: 'Compte courants de trésorerie',
          },
          associate: {
            title: "Compte courants d'associés",
          },
          central: {
            title: 'Compte courants centralisateur',
          },
          tabs: {
            graph: 'Graphique',
            list: 'Liste',
            total: 'Total',
          },
          datagrid: {
            nom: 'Nom',
            date: 'Date',
            montant: 'Montant',
            currency: 'Devise',
          },
        },
        received_files: {
          header_title: 'Fichiers reçus',
          datagrid: {
            flow: 'Flux',
            bank: 'Banque',
            file_format: 'File Format',
            date: 'Date de réception',
          },
        },
        maps_flows: {
          title: 'Répartition des flux',
          filters: {
            placeholder: 'Type de filtre',
            country: 'Pays',
            currency: 'Devise',
          },
          currency: {
            placeholder: "Choix d'une devise",
          },
        },
        statistics_flows: {
          title: 'Statistiques des flux',
        },
        comparative_flows: {
          title: 'Evolution des flux',
        },
        currencyRate: {
          titleRate: 'Taux',
          titleCurrency: 'Cours des devises',
          favori: 'Favoris',
          all: 'Toutes',
          column: {
            name: 'Nom',
            date: 'Date',
            currency: 'Cours',
          },
        },
        repository: {
          title: 'Référentiel',
          header_title: '',
          left_title: 'Sociétés',
          middle_title: 'Comptes',
          right_title: 'Tiers',
          other_title: '',
        },
        '4eyes': {
          title: 'Validation 4 Yeux',
          header_title: 'validation(s)',
          left_title: 'tiers',
          middle_title: 'référentiel',
          right_title: 'utilisateur(s)',
          other_title: 'profil(s)',
        },
        accounting_export: {
          title: 'Export Comptable',
        },
        active_signatory: {
          title: 'Liste Signataires Actifs',
          name: 'Nom',
        },
        active_users: {
          title: 'Liste Users Actifs',
        },
        events: {
          title: 'Journal des Evènements',
        },
        treasury_report: {
          title: 'Impression Etat',
          print: 'Imprimer',
          etat: 'Report',
        },
        treasury_zoom_report: {
          title: 'Impression Etat Zoom',
        },
        treasury_transaction_balance: {
          title: 'Trésorerie - Solde par opération',
          affiche: 'Afficher',
          devise: 'Devise',
          label: 'Libellé',
        },
        workflow: {
          title: 'Gestion des lots',
          header_title: 'Lot(s)',
          left_title: 'Non attribué(s)',
          middle_title: 'Fraud Monitor',
          right_title: 'Parapheur 1',
          other_title: 'Parapheur 2',
        },
        signatory_book: {
          title: 'Mon Parapheur',
          header_title: 'Lots',
          all_signed: 'Pas de lots à signer',
        },
        management: {
          onglet: 'Onglet',
          save: 'Enregistrer le dashboard',
          modify: 'Déverrouiller le dashboard',
          list: 'Séléction de widget',
          tab_error: ' (Onglet en erreur)',
          modal: {
            title: 'Liste des widgets',
            add: 'Ajouter',
            delete: 'Supprimer',
          },
        },
        error: {
          errorWidget: 'Erreur de chargement',
          text: 'Une erreur est survenue lors de chargement',
          delete: 'Vous ne pouvez pas supprimer un onglet ouvert',
        },
        groupPosition: {
          title: 'Analyse Groupes',
          column: {
            group: 'Groupe',
            forecast: 'Prévisions',
            balance: 'Soldes',
            liquid_investment: 'Placements Liquides',
            current_account: 'Comptes Courants',
            proper_treasury: 'Trésorerie propre',
            illiquid_investment: 'Placements Non Liquides',
            internal_lending: 'Prêt interco',
            external_lending: 'Prêt Externe',
            net_treasury: 'Trésorerie nette',
          },
        },
        accountStatements: {
          byCompany: {
            title: 'Relevés de compte par société',
            column: {
              societe: 'Société',
              montant: 'Montant',
              devise: 'Devise',
              date: 'Date',
            },
          },
          byBank: {
            title: 'Relevés de compte par banque',
          },
          byCurrency: {
            title: 'Relevés de compte par devise',
          },
        },
        treasury_object: {
          '30_days': '30J',
          '60_days': '60J',
          '90_days': '90J',
          label: 'Tombant dans :',
          investments: 'Echéanciers Placements',
          debts: 'Echéanciers Dettes',
          column: {
            name: 'Référence',
            due_date: 'Date Echéance',
            amount: 'Montant',
            currency: 'Devise',
          },
        },
        certificate: {
          title: 'Echéances certificats',
          column: {
            user_id: 'UserID',
            connector: 'Connecteur',
            signature_date: 'Date Echéance Autosignés',
            signature_date_3skey: 'Date Echéance Signature',
          },
        },
        rules_statements_alert: {
          title: 'Alerte sur relevés de compte',
          columns: {
            code_compte: 'Code compte',
            montant: 'Montant',
            devise: 'Devise',
            category: 'Catégorie',
            label: 'Libellé',
            op_date: 'Date Opé.',
            rule_code: 'Code règle',
            update_timestamp: 'Date de modification',
          },
        },
        balance: {
          balance_value_on_date: 'Soldes en valeur au {{date}} ',
          solde: 'Solde',
          solde_operation: 'Soldes et Prévisions',
          prevision: 'Prévisions',
          affiche: 'Afficher',
        },
      },
    },
    component_document: {
      titleImportfile: 'Document',
      importfile: 'Import fichier ...',
      btnNameEdit: 'Fiche Document',
      btnNameAdd: 'Document',
      docName: 'Nom document',
      docType: 'Type de document',
      docEtat: ' Etat',
      dateEnd: 'Date de fin',
      dateStart: 'Date de début',
      erroValidationChamp:
        'Tous les champs sont obligatoires sauf la date de fin',
      errorFormatfile: 'Veuillez importer un fichier pdf',
      titleError: 'Erreur',
      placeholderDocName: '- Si vide nom chargé automatiquement -',
      nbFileAccepted: 'Un fichier PDF accepté',
      other_file_type: 'Veuillez insérer un fichier de type pdf',
    },
    idleModal: {
      title: "Votre session est sur le point d'expirer",
      expiration:
        "Votre session est sur le point d'expirer. Vous serez automatiquement déconnecté.",
      question: 'Souhaitez-vous rester connecté ?',
      remaining: 'Vous avez {{remainingTime}} secondes pour rester connecté',
      button: 'Rester connecté',
    },
    datagrid: {
      pageText: 'Page',
      ofText: ' sur ',
      perPageText: 'Résultat par page',
      showingText: 'Afficher ',
      clearAll: 'Supprimer tous les filtres',
      clear: 'Supprimer le filtre',
      showFilteringRow: 'Afficher les filtres',
      hideFilteringRow: 'Ne pas afficher les filtres',
      enable: 'Activé',
      disable: 'Désactivé',
      sortAsc: 'Tri ascendant',
      sortDesc: 'Tri descendant',
      unsort: 'Pas de tri',
      group: 'Grouper',
      ungroup: 'Dégrouper',
      lockStart: 'Figer au début',
      lockEnd: 'Figer à la fin',
      unlock: 'Ne pas figer',
      columns: 'Colonnes',
      autoresizeThisColumn: 'Redimensionner cette colonne',
      autoresizeAllColumns: 'Redimensionner toutes les colonnes',
      autoSizeToFit: 'Adapter automatiquement',
      contains: 'Contient',
      startsWith: 'Commence par',
      endsWith: 'Finit par',
      notContains: 'Ne contient pas',
      inlist: 'Est dans la liste',
      notinlist: "N'est pas dans la liste",
      neq: 'Différent de',
      inrange: 'Dans la plage',
      notinrange: "N'est pas dans la plage",
      eq: 'Egal à',
      notEmpty: 'Non vide',
      empty: 'Est vide',
      lt: 'Inférieur à',
      lte: 'Inférieur ou égal à',
      gt: 'Supérieur à',
      gte: 'Supérieur ou égal à',
      before: 'Inférieur à',
      beforeOrOn: 'Inférieur ou égal à',
      afterOrOn: 'Supérieur ou égal à',
      after: 'Supérieur à',
      start: 'De',
      end: 'A',
      dragHeaderToGroup: 'Faites glisser ici pour grouper',
      noRecords: 'string',
      calendartodayButtonText: "Aujourd'hui",
      calendarclearButtonText: 'Effacer',
      calendarokButtonText: 'Valider',
      calendarcancelButtonText: 'Annuler',
    },
    valid: 'Valider',
    selection: '- Sélectionner -',
    success: 'Succès',
    error: 'Erreur',
    message_error_rib:
      'Veuillez joindre un document de type RIB pour le nouveau compte',
    code_society: 'Société',
    backOffice: {
      title: 'Back Office',
      user: {
        title: 'Liste des utilisateurs Back Office',
        column: {
          state: 'Etat',
          login: 'Login',
          name: 'Nom',
          firstName: 'Prénom',
          email: 'Email',
          dateConn: 'Date de Connexion',
        },
        fiche: {
          title: 'Fiche utilisateur',
          title_pwd: 'Mot de passe',
          title_pwd_edit: 'Modification de mot de passe',
          state: 'Etat',
          mail: 'Email',
          login: 'Login',
          firstName: 'Prénom',
          name: 'Nom',
          profil_user: 'Profil utilisateur',
          password: 'Mot de passe',
          passwordConfirm: 'Confirmation de mot de passe',
          errormail: "Votre email n'est pas valide",
          errorPasswrd: 'Le mot de pass est obligatoire',
          errorConfirmPass:
            'La confirmation du mot de passe est obligatoire et doit être valide',
        },
      },
      groupUser: {
        title: "Liste des groupes d'administrateurs",
        column: {
          state: 'Etat',
          code: 'Code',
          name: 'Nom',
          dateModif: 'Date de modification',
        },
      },
      profil: {
        fiche: {
          title:
            "Fiche du groupe d'administrateurs Groupe Super Administrateurs",
          titleModal: 'Ajouter un utilisateur',
          addProfile: {
            title: 'Accès Client',
            admin_account: 'Profil administrateur ',
            groupModal: 'Group :',
            userModal: 'Utilisateur',
            column: {
              client_name: 'Nom client',
              login: 'Login',
              mail: 'Mail',
              dateModif: 'Date de modification',
              dateCreation: 'Date de création',
            },
          },
        },
      },
      gestionGroup: {
        title: 'Liste des entités',
        column: {},
        fiche: {
          title: {
            creation: "Création d'un groupe",
            edit: 'Fiche du groupe {{code}}',
            label_module: 'Listes des modules',
            module: 'Module',
            placeholder_modul: '- Module -',
            to_prod_btn: 'Passer en prod',
          },
          modal_module: {
            title: 'Sélection Format',
            title_table: 'Liste des Modules',
            title_modale_add: "Ajout d'un module",
            title_modale_edit: "Modification d'un module",
            column: {
              module: 'Module',
              nb: 'Nombre',
              date: 'Date Création',
              user: 'User Backoffice',
            },
          },
        },
        administer: {
          title: 'Administration du groupe {{name}}',
          title_card: 'Contrôle de soldes en valeur',
          button_solde_value: 'Recalcul solde Valeur comptes sélectionnés',
          button_verification_value: 'Vérification Valeur',
          control_remise: 'Contrôle des Remises',
          control_valeur: 'Contrôle de solde en valeur',
          column: {
            state: 'Etat',
            code: 'Code',
            name: 'Nom',
            dateOP: 'Date Opération',
            soldeOP: 'Solde Opération',
            dateValue: 'Date Valeur',
            soldeValue: 'Solde Valeur',
          },
        },
        initialiser: {
          title: 'Initialisation du groupe {{name}}',
          title_filiale: 'Filiale',
          code: 'Code',
          name: 'Nom',
          list: 'Liste',
          first_title: 'Filiale',
          title_initialise: 'Initialisation des tables',
          label_initialise:
            'Création du Profil SuperAdministrator/Double Admin/Labels/4 Yeux/Catégorie',
          button_create: 'Création',
          title_create_format: 'Création Formats',
          title_import: 'Import Sociétés/Comptes',
          import_societe: 'Import Sociétés',
          import_compte: 'Import Comptes',
          title_imp_bank: 'Import Banques',
          title_beneficiaire: 'Import Bénéficiaires',
          title_mandant: 'Import Mandant',
          title_releve: 'Import relevé de compte',
          title_imp_treso: 'Import Plan Tréso',
          title_cpt_courant: 'Import Compte Courant',
          title_mvt: 'Import Mouvements de Comptes Courant',
          title_compta: 'Import Comptes Comptables',
          title_soc_tiers_compte:
            'Intégration Cubicus Script 1(Sociétés/Comptes/Users/Profils)',
          title_delete_tiers_compte:
            'Intégration Cubicus Script 2(Tiers/Groupe de Tiers)',
          title_tiers: 'Intégration Cubicus Script 3(Historique des lots)',
          title_histo: 'Import Historique',
          delete_script: 'Supprimer intégration Script 1',
          import_users: 'Import Utilisateurs',
          title_exodon: 'Intégration exodon',
          btn: {
            validate_btn: 'Valider',
            create_btn: 'Créer',
            import_btn: 'Importer',
          },
          modal_format: {
            title: 'Sélection Format',
            title_select: 'Groupe',
          },
        },
      },
      adminGenerale: {
        title: {
          admin: 'Administration Générale',
          controleBd: 'Contrôle BDD',
          controleAcces: 'Contrôle des Accès',
          controleLabs: 'Contrôle des Labels',
          controleWidgets: 'Contrôle des Widgets',
          controleChamp: 'Contrôle des Champs',
          integrationCubus: 'Intégration Cubicus',
          ebam: 'eBAM',
          selectGroup: 'Selectionner un groupe',
          renew_cert: 'Renouvellement Certificat HPB',
          select_hostId: 'Sélectionner le HOSTID',
          date: 'Date et heure de lancement',
        },
        btn: {
          admin: 'Administration',
          controleBd: 'Vérification BDD',
          controleAcces: 'Contrôle  Accès',
          controleLabs: 'Contrôle  Labels',
          controleWidgets: 'Contrôle Widgets',
          controleChamp: 'Contrôle Champs',
          ebam: 'eBAM',
          create_job: 'Créér le job',
        },
      },
      currency: {
        table: {
          title: 'Liste des Devises',
          DeviseISO: 'DeviseISO',
          label: 'Libellé',
          nb_decimal: 'Nombre décimal',
          code_cdf: 'Code BDF',
        },
        fiche: {
          title: 'Fiche Devise',
          currency: 'Devise',
          label: 'Nom',
        },
      },
      pays: {
        title: 'Liste des Pays Back Office',
        column: {
          name: 'Nom',
          dansSepa: 'DansSepa',
          dansFrance: 'DansFrance',
          iban: 'IBAN',
          devise: 'Devise',
          ssid: 'SISIDControl',
          codeP: 'Code pays',
        },
        fiche: {
          ficheTitle: 'Fiche du Pays',
          name: 'Nom',
          devise: 'Devise',
          dans_sepa: 'DansSepa',
          dans_france: 'DansFrance',
          iban: 'IBAN',
          SISIDControl: 'SISIDControl',
          code_pays: 'Pays Code',
          bbanRegex: 'Regex forme BBAN',
          bbanExample: 'Exemple BBAN',
          bbanRegexiban: 'Regex forme IBAN',
          bbanExampleiban: 'Exemple IBAN',
        },
      },
      codeOperation: {
        title: 'Liste des code opération Back Office',
        table: {
          column: {
            name: "Libellé d'origine",
            sense: 'Sense',
          },
        },
        fiche: {
          title: "Fiche d'un code Opération",
          code: 'Code',
          label: "Libellé d'origine",
          sense: 'Sense',
        },
      },
      audit: {
        title: 'Audit actions users',
        table_list: '- Table -',
        label_or_key: '- Label -',
        table: {
          column: {
            name: 'Nom de la table',
            key: 'Clé',
            date: 'Date',
            label: 'Libellé',
            login: 'Login',
          },
        },
        fiche: {
          title: 'Fiche code opération',
          code: 'Code',
          label: "Libellé d'origine",
          sense: 'Sense',
        },
      },
      releve_compte: {
        title: 'Relevés de compte',
        placeholder: '- Groupe -',
        detail_title: 'Détails relevés de compte {{name}}',
      },
    },
    cash: {
      flux: {
        audit: 'Audit',
        attribution: 'Attribution',
        signer: 'Signer',
        comment: {
          title: 'Commentaire du lot {{batchId}}',
          columns: {
            date: 'Date',
            comment: 'Commentaire',
            type: 'Type',
            login: 'Login',
          },
          add: 'Ajouter un commentaire',
        },
        validate: 'Valider le contrôle',
        relaunch: 'Relancer le fraud monitor',
        print: 'Imprimer',
        send: 'Envoyer',
        slip: 'Bordereau',
        edit: 'Etes-vous sûr de vouloir éditer les opérations de ce lot et le remettre en saisie',
        remettre: 'Remettre en Saisie',
        visualiserPDF: 'Justificatif',
        unauthorize_view:
          "La visualisation du détail n'est pas autorisée sur ce type de flux",
        detail: {
          title: {
            remittance: 'Détail de la remise {{remittance_number}}',
            facture: 'Détail des facture {{remittance_number}}',
            operation: 'Opération',
          },
          columns: {
            beneficiary_name: 'Bénéficiaire',
            reference_label: 'Référence/Libellé',
            print: 'Visualiser',
            number: 'N°',
            amount: 'Montant',
            currency: 'Devise',
            ara: 'ARA',
            reject: 'Rejet',
            rules: 'Règles',
            fraud_monitor: 'Fraud monitor',
            choice: 'Choix',
            delete: 'Suppression',
            vsr: 'Statut VSR',
          },
          buttons: {
            tracking: 'Tracker',
            invoice: 'Factures',
            print: 'Imprimer Avis',
            back: 'Retour',
            validate: 'Confirmer le contrôle',
            validateChoice: 'Valider le choix',
            refuse: 'Rejeter le lot',
          },
          champ_titles: {
            societe: 'Société',
            compte: 'Compte',
            ibanBban: 'IBAN/BBAN',
            lot_number: 'N° Lot',
            origine: 'Origine',
            author: 'Login',
            state: 'Etat',
            flow: 'Flux',
            creation_date: 'Création le',
            execution_date: 'Exécution le',
            emitter: 'Emetteur',
            operation_number: 'Nb',
            amount: 'Montant remise',
            status: 'Statut',
            reason: 'Motif',
            label: 'Libelle',
            origin_amount: 'Montant Origine',
            fee: 'Frais',
            fee_type: 'Type de frais',
            tracker_number: 'N° tracker',
            confirmation_date: 'Date confirmée',
            amount_credited: 'Montant Crédité',
            send: 'Envoyé le',
          },
          tracking_status: {
            ACSC: "Confirmation de débit, preuve de l'initiation du paiement.",
            G001: "Règlement en cours. Paiement transféré à un agent non gpi ou à un MI (système d'échange interbancaire local) non pris en charge.",
            G005: 'Règlement en cours. Livré à la banque bénéficiaire en tant que gpi.',
            G006: 'Règlement en cours. Livré à la banque bénéficiaire en tant que non gpi.',
            Gxxx: 'Règlement en cours.',
            ACCC: 'Le créancier a été crédité.',
            RJCT: 'Rejeté',
            PDNG: 'En cours',
          },
          process: {
            treated: 'Traité',
            waiting: 'En attente',
            credited: 'Crédité',
          },
          copy: 'Copier le lien.',
          copied: 'Copié !',
          coller: 'Coller !',
          invoice: {
            champ_titles: {
              IBAN: 'IBAN',
              ibanBban: 'IBAN/BBAN',
              reference: 'Référence',
              label: 'Libellé',
              montant: 'Montant',
              devise: 'Devise',
              tiers: 'Tiers',
            },
            columns: {
              client_reference: 'Référence Client',
              supplier_reference: 'Référence Fournisseur',
              invoice_number: 'N° Facture',
              date_fact: 'Date Facture',
            },
          },
        },
        ModalSendMessage: {
          title: 'Envoi email',
          template_email: 'Template email',
          email: 'email',
        },
        EditRemise: 'Modification de la date d’exécution de la remise {{id}}',
        EditRemiseMultiple: 'Modification de la date d’exécution des remises',
        operation: 'Editer les opérations',
        FraudMonitor: {
          fiche: {},
          table: {
            title: 'Liste des lots en contrôle',
            buttons: {
              audit: 'Audit',
              validate: 'Valider le contrôle',
              print: 'Imprimer',
            },
            columns: {
              batche_number: 'N° lot',
              remittance_number: 'N° remise',
              flow: 'Flux',
              state: 'Etat',
              transmitter: 'Compte',
              login: 'Login',
              date: 'Date',
              operation_number: 'Nb',
              amount: 'Montant',
              currency: 'Devise',
              origin: 'Origine',
              status: 'Statut',
            },
            modal: {
              title: {
                audit: 'Audit du lot n° {{batche_number}}',
              },
              columns: {
                date: 'Date',
                login: 'Login',
                action: 'Action',
              },
              buttons: {
                buttons: 'Fermer',
              },
            },
          },
        },
        Cheque: {
          fiche: {},
          table: {
            title: 'Liste des lots de chèques à imprimer',
            columns: {
              batche_number: 'N° lot',
              remittance_number: 'N° remise',
              flow: 'Flux',
              state: 'Etat',
              transmitter: 'Compte',
              login: 'Login',
              date: 'Date',
              operation_number: 'Nb',
              amount: 'Montant',
              currency: 'Devise',
              origin: 'Origine',
              status: 'Statut',
              check_print: 'Imprimer chèques',
            },
            apercu: {
              title: 'Apercu des chèques à imprimer',
              button: 'Valider impression',
            },
            range: {
              title: 'Plage de numéro chèques',
              next: 'Prochain numéro',
              last: 'Dernier numéro',
              first_op: 'N° première opération',
              last_op: 'N° dernière opération',
              account_divider: 'Paramétrage de compte',
              update: 'Modifier la plage de chèque',
              error:
                'La plage saisie est supérieure à la plage autorisée.\nVeillez augmenter la plage de votre compte.',
              button: 'Plage',
            },
            modal: {
              title: {
                audit: 'Audit du lot n° {{batche_number}}',
              },
              columns: {
                date: 'Date',
                login: 'Login',
                action: 'Action',
              },
              buttons: {
                buttons: 'Fermer',
              },
            },
            message:
              'Avez-vous bien imprimé le(s) chèque(s) ? Après validation vous ne pourez plus imprimer le(s) chèque(s).',
          },
        },
        Integration: {
          table: {
            title: 'Import manuel de fichiers',
            addfile: 'Ajouter',
            labelmodel: "Modèle d'import",
            choosefile: 'Sélection de fichiers',
            import_placeholder: 'Aucun',
            smartag: 'SmartTags',
          },
        },
        GestionLots: {
          header: {
            title: 'Gestion des lots',
          },
          columns: {
            flow: 'Flux',
            state: 'Etat',
            account: 'Compte',
            login: 'Login',
            date: 'Date',
            count: 'Nb opérations',
            montant: 'Montant',
            devise: 'Devise',
            origin: 'Origine',
            status: 'Statut',
            pdf_files: 'PDF',
            comment: 'Com.',
            signing: 'Signature',
            lot_number: 'N° lot',
            remittance_number: 'N° remise',
            amount_max: 'Max',
            amount_min: 'Min',
            smarttag: 'SmartTags',
            source_file_name: 'Nom du fichier',
            date_transmission: 'Date Transmission',
          },
          modal: {
            title: 'Détails de la remise {{remittance_num}}',
            audit: 'Audit du lot n° {{batche_number}}',
            titleDelete:
              'Commentaire pour suppression du lot n° {{batche_number}}',
            buttonDelete: 'Supprimer',
          },
          attributionModal: {
            message_infos_type_pdf: 'Seuls les fichiers PDF sont autorisés',
            title: 'Attribution des signataires du lot n° {{num_attribution}}',
            title_document_validation: 'Attribution des signataires',
            state_signature: 'Etat signature',
            flux: 'Flux',
            created_date: 'Date de création',
            operationNumber: "Nb d'opération",
            amount: 'Montant',
            currency: 'Devise',
            name: 'Nom',
            one_signature: 'Signature 1',
            college: 'Collège',
            niveau: 'Niveaux',
            two_signature: 'Signature 2',
            justificated_piece: 'Pièce justificative',
            attributed: 'Attribuer',
            alert_file:
              'Vous ne pouvez sélectionner que 3 fichiers au maximum.',
            columns: {
              level: 'Niveau',
              signataire1: 'Signataire 1',
              signataire2: 'Signataire 2',
              signataire: 'Signataire {{nb}}',
              college1: 'Collège 1',
              college2: 'Collège 2',
            },
          },
        },
        HistoriqueLots: {
          actions: {
            writing_generate: 'Génération des écritures comptables',
            message: 'Voulez-vous renvoyer le lot à la banque ',
          },
          header: {
            title: 'Historique des lots',
            advance_search_button: 'Recherche avancée',
            launch_search: 'Lancer la recherche',
            recherche_suppl: '- Recherche spécifiques -',
            advanced_title: 'Recherche avancée sur les opérations',
            search: 'Recherche des lots par tiers, motif, référence ...',
            transmission_date: 'Date Envoi',
            exec_date: 'Date Exécution',
            recherche_signature: '- Signataires -',
          },
          columns: {
            pdf_files: 'PDF',
            lot_number: 'N° lot',
            remise_number: 'N° remise',
            flow: 'Flux',
            state: 'Etat',
            emetteur: 'Compte',
            login: 'Login',
            date: 'Date',
            operation_number: 'Nb',
            montant: 'Montant',
            devise: 'Devise',
            origine: 'Origine',
            status: 'Statut',
            ack: 'ACK',
            delivrance: 'Délivrance',
            psr: 'PSR protocolaire',
            ara1: 'ARA 1',
            transaction_ref: 'Référence de transaction',
            account_number: 'N° compte',
            third_party: 'Tiers',
            montant_lot: 'Montant lot',
            code_countrie: 'Code pays',
            ara_operation: 'ARA Opération',
            valid_1: 'Valideur 1',
            valid_2: 'Valideur 2',
            sign_1: 'Signataire 1',
            sign_2: 'Signataire 2',
            reject_reason: 'Rejet',
            road_name: 'Nom rue',
            road_number: 'Numéro rue',
            city: 'Ville',
            postal_code: 'Code postal',
            town: 'Ville',
            bp: 'BP',
            district: 'District',
            region: 'Région',
            reference: 'Référence',
            reason: 'Libellé',
          },
        },
        Intégration: {
          fiche: {},
          table: {},
        },
        Signature: {
          header: {
            title: 'Mon parapheur de signature',
          },
          fiche: {},
          table: {
            sign: 'Signer',
            reject: 'Refuser',
          },
          modal: {
            commentTitle: 'Commentaire pour le refus du lot {{name}}',
            refusTitle: 'Refuser',
            titleOTP: 'Signature OTP',
            titleEbics: 'Signature Ebics TS',
            sendOTP: 'Signer le lot',
            sendEbics: 'Signer électroniquement',
            cancel: 'Annuler',
            champOTP: 'Saisir le code reçu par SMS ou le code à usage unique',
            champEbics: 'Saisir le mot de passe de la clé',
            validate: 'Valider la signature',
            decline: 'Refuser',
            comment: 'Commentaire',
            message_confirm_signin: 'Voulez-vous signer ce lot',
            lot_selec: 'Nombre de lots :  ',
            total: 'Somme arithmétique : ',
            mobile_action:
              'Avez-vous validé la signature dans votre application mobile Swift "Digital ID" ?',
            verif_code:
              'Veuillez confirmer le code de vérification suivant dans votre application mobile :',
            progression:
              'Progression signature de lot: {{signedNb}}/{{totalNb}}',
          },
        },
        Saisie: {
          fiche: {
            title: {
              new_title: 'Nouveau lot de {{code}}',
              edit_title: 'Modification du lot n° {{id}} de {{code}}',
              operation: 'Liste des opérations',
              timeline: 'Sélection date Echéance',
            },
            champ_titles: {
              account: 'Compte émetteur',
              currency: 'Devise des opérations',
              execution_date: "Date d'exécution",
            },
            buttons: {
              save: 'Créer le lot',
              back: 'Annuler',
              send_to_validate: 'Envoyer en validation',
              timeline: 'Échéancier',
              by_list: 'Saisie par liste',
            },
            columns: {
              thirdparty: 'Tiers',
              account: 'N° compte',
              amount: 'Montant',
              currency: 'Devise',
              reference: 'Référence',
            },
            modal: {
              title: 'Saisie par liste',
              columns: {
                code: 'Code',
                name: 'Nom',
                account: 'N° compte',
                amount: 'Montant',
                currency: 'Devise',
                note: 'Note',
              },
              champ_titles: {
                reference: 'Référence commune',
                reason: 'Motif commun',
              },
            },
          },
          table: {
            title: 'Liste des lots en cours de saisie',
            columns: {
              batch_number: 'N° lot',
              flow: 'Flux',
              account: 'Compte',
              operation_number: 'Nb',
              amount: 'Montant',
              currency: 'Devise',
              execution_date: 'Date exécution',
              creation_date: 'Date de création',
              update_date: 'Date de modification',
            },
            buttons: {
              new: 'Nouveau Lot',
              delete: 'Confirmez-vous la suppression',
            },
          },
          timeline: {
            title: {
              general: 'Liste des échéanciers',
              operations_list: 'Liste des opérations',
            },
            columns: {
              rum: 'RUM',
              debtor_code: 'Code débiteur',
              debtor_name: 'Nom du débiteur',
              next_due_date: 'Prochaine échéance',
              type: 'Type',
              sequence: 'Séquence',
              reason: 'Motif',
              reference: 'Référence',
              amount: 'Montant',
            },
            champ_titles: {
              date: 'Date de règlement',
              sample_number: 'Nombre du prélèvement du portefeuille',
              amount: 'Somme du portefeuille',
              reason: 'Motif',
              reference: 'Référence',
            },
            buttons: {
              addTo: 'Ajouter au lot',
              validate: 'Va ider',
            },
          },
          operation: {
            title: {
              new_title: "Ajout d'une opération",
              edit_title: 'Opération {{name}}',
              address_thirdparty: 'Adresse du tiers',
              informations: 'Informations complémentaires',
              bank: 'Coordonnées bancaires',
              intermediary_bank: 'Banque intermédiaire',
              fournisseur_bank: 'Adresse fournisseur',
              fournisseur_structure_bank: 'Adresse structurée fournisseur',
            },
            champ_titles: {
              reference: 'Référence',
              amount: 'Montant',
              name: 'Nom',
              reason: 'Motif',
              country: 'Pays',
              account_number: 'N° de compte',
              bank_name: 'Domiciliation',
              bic: 'BIC',
              address: 'Adresse',
              clearing: 'Clearing',
              clearing_id: 'Clearing code / Bank code',
              type: 'Type',
            },
            buttons: {
              save: 'Valider',
              back: 'Annuler',
              search: 'Rechercher',
              import_amount: 'Charger les montants',
              excel_export: 'Export Excel',
            },
            placeholder: {
              search: "Recherche d'un tiers par code, nom, IBAN",
            },
            modal: {
              title: 'Sélection de tiers',
              buttons: {
                add: 'Valider',
                close: 'Annuler',
              },
              columns: {
                group: 'Groupe',
                type: 'Type',
                code: 'Code',
                name: 'Nom',
                account: 'N° compte',
                bic: 'BIC',
                code_pays: 'Code Pays',
                code_pays_tiers: 'Code Pays Tiers',
                thirdparty: 'Tiers',
                rum: 'RUM',
                reference: 'Référence',
                analysis_note: 'Note Analyse Tiers',
              },
            },
          },
        },
        Analyse: {
          search: {
            state: '- Etat -',
            scope: '- Scope - ',
            company: '- Société -',
            bank: '- Banque -',
            pays: '- Pays -',
            devise: '- Devise -',
            flux: '- Flux - ',
            category: '- Catégorie - ',
          },
          graph: {
            societe: 'Répartition des flux par société',
            banque: 'Répartition des flux par banque',
            type: 'Répartition des flux  par type',
          },
          table: {
            title: 'Analyse Flux',
          },
          onglet: {
            graphe: 'Graphe flux',
            analyse: 'Analyse flux',
          },
        },
      },
      statement: {
        RelevesCompte: {
          tab: {
            graphTitle: 'Graphe Relevés',
            releverTitle: 'Analyse Relevés',
          },
          header: {
            title: 'Liste des comptes bancaires',
            buttons: {
              export: 'Exporter',
              import: 'Importer',
              releve_inco: 'Relevé inconnu',
            },
          },
          filters: {
            state: '-Etat-',
            scope: '-Scope-',
            companies: '-Société-',
            bank: '-Banque-',
            country: '-Pays-',
            devise: '-Devise-',
            format: '-Format-',
            services: "<Sélection du service pour l'intégration par job>",
          },
          searchInput: {
            caption:
              'Rechercher un compte par code, nom, numéro de compte, code société, nom de société ...',
          },
          modal: {
            titles: {
              import: "Import d'un relevé manuellement",
              export: 'Export de relevés de compte',
            },
            buttons: {
              export: 'Exporter',
              drag_file: 'Appuyer ou déposer des fichiers ici',
              drag_one_file: 'Appuyer ou déposer un fichier ici',
              send: 'Envoyer',
            },
            champ_titles: {
              job: 'Intégration par Job',
            },
          },
          columns: {
            state: 'Etat',
            code: 'Code',
            name: 'Nom',
            iban: 'IBAN',
            company: 'Société',
            bank: 'Banque',
            solde: 'Solde',
            devise: 'Devise',
            date: 'Date de solde',
            operation_number: 'Nb mouvements',
            intraday_number: 'Nb Intraday',
            alternative_account: 'Compte Alternatif',
            solde_consolide: 'Solde devise consolidé',
            devise_consolide: 'Devise de consolidation',
            pays_compte: 'Pays Banque',
            pays_soc: 'Pays Société',
            domiciliation: 'Domiciliation',
          },
          search_advanced_releve: {
            category_search: 'Catégorie',
            label_search: "Recherche d'un libellé",
          },
        },
        unknowAccount: {
          header: {
            title: 'Liste des Relevé inconnu',
          },
          columns: {
            state: 'Etat',
            unknow_account: 'Compte inconnu',
            solde: 'Solde',
            devise: 'Devise',
            date_solde: 'Date de solde',
            nb_mvt: 'Nb mouvements',
          },
          label: {
            delete: 'Supprimer les mouvements temporaires',
            black_liste: 'Ignorer le relevé de ce compte',
            search: 'Rechercher les comptes bancaires',
            unknow: 'Retirer de la liste noire',
            delete_account: 'Voulez-vous supprimer les mouvements temporaires',
            search_id: 'Voulez-vous rechercher les comptes bancaires',
            add_blackList: 'Voulez-vous ignorer le relevé de ce compte',
            add_unknow: 'Voulez-vous retirer de la liste noire',
          },
        },
        DetailRelevesCompte: {
          header: {
            title: 'Visualisation du relevé de compte {{code}} - {{iban}}',
            print: 'Imprimer',
            relever_electro: 'Relevés électronique',
            generation: 'Géneration Ecritures',
            calendar: 'Dernier jour ouvré',
            search: 'Rechercher ...',
          },
          filters: {
            state: '-Etat-',
            scope: '-Scope-',
            companies: '-Société-',
            bank: '-Banque-',
            country: '-Pays-',
            devise: '-Devise-',
          },
          searchInput: {
            caption:
              'Rechercher un compte par code, nom, numéro de compte, code société, nom de société ...',
          },
          columns: {
            label: 'Libellé',
            complementary_label: 'Libellé complémentaire',
            reference: 'Référence',
            tiers: 'Tiers',
            document_number: 'N° Pièce',
            category: 'Catégorie',
            transaction_code: 'Code',
            devise: 'Devise',
            operation_date: "Date d'opération",
            value_date: 'Date de valeur',
            debit: 'Débit',
            credit: 'Crédit',
            currency: 'Devise',
            payer_name: 'Nom du payeur',
            beneficiary_name: 'Nom du bénéficiaire',
            exempted: 'Exo',
          },
          columns_electro_relever: {
            title: 'Liste des relevés de compte électroniques',
            num_doc: 'N ° document',
            date: 'Date de début',
            date_fin: 'Date de fin',
            date_add: "Date d'ajout",
          },
          modal: {
            title: "Détail de l'operation",
          },
        },
        FraisBancaire: {
          table: {
            title: 'Frais bancaires',
            bankList_placeholder: '- Banque -',
            group_compte_list: '- Groupe de compte -',
            search: 'Rechercher',
            society_List_placeholder: '- Société -',
          },
          columns: {
            frais: 'Libellé',
            nb_op: 'Nb opération',
            verif: 'Tarification',
            balance: 'Assiette/Somme',
            currency: 'Devise',
            amount: 'Frais',
            total: 'Total',
          },
          columns_detail_assiette: {
            code_compte: 'Code compte',
            date_operation: 'Date opération',
            label_complet: 'Libellé complet',
            code_category: 'Code catégorie',
            code_opération: '\tCode opération',
            code_nature_present: 'Code nature',
            montant: 'Montant ',
            devise: 'Devise ',
            date_opération: "Date d'opération",
          },
        },
        alert_account: {
          table: {
            header: {
              title: 'Liste des alertes relevés de compte',
              load_search: 'Lancer la recherche',
            },
            columns: {
              label: 'Libellé',
              state: 'Etat',
              account: 'Compte',
              reference: 'Référence',
              nature: 'Nature',
              category: 'Catégorie',
              op_date: 'Date opé.',
              value_date: 'Date Valeur',
              amount: 'Montant',
              currency: 'Devise',
              type: 'Type',
              entry_number: 'Num Ecriture',
              nature_code: 'Code Nature',
              integration_date: "Date d'intégration",
              ics: 'ICS',
              rum: 'RUM',
              transaction_code: 'Code opération',
              rule_code: 'Code Règle',
              company: 'Société',
              exempted: 'Exo',
              debit: 'Débit',
              credit: 'Crédit',
            },
          },
        },
        analyse: {
          title: 'Soldes bancaires',
          entity: 'Société',
          benefBank: 'Banque',
          location: 'Pays',
          currency: 'Devise',
          consolidation: 'Consolidation',
        },
        agios: {
          column: {
            state: 'Etat',
            code: 'Code',
            name: 'Nom',
            banque: 'Banque',
            company: 'Société',
            iban: 'IBAN',
            devise: 'Devise',
            taux_debit: 'Taux débit',
            taux_credit: 'Taux crédit',
          },
          drawer: {
            titleDrawer: 'Résultat de calcul des agios',
            titleCalcul: 'Calcul Agios',
            compte: 'Comptes',
            periode: 'Période',
            titleResult: 'Résultat',
            assiete: 'Assiette Débiteur',
            int: 'Intérêts Débiteur',
            assiCredit: 'Assiette Créditeur',
            intCredit: 'Intérets Créditeur',
            titleDetail: 'Détail Calcul',
            accountNbr: 'Nb de comptes :',
            imp: 'Imprimer',
            column: {
              date: 'Date',
              nbJ: 'Nb jours',
              position: 'Position',
              tauxDeb: 'Taux débiteur',
              int_deb: 'Intérêts débiteur',
              tauxCred: 'Taux créditeur',
              intCredit: 'Intérêts créditeur',
            },
          },
          calcul: 'Lancer le calcul',
          title: 'Calcul des Agios',
        },
        mobileBank: {
          title: 'Liste des mobilités bancaire',
          titleVisu: 'Liste des opérations',
          action: {
            misAJourTiers: 'Mise à jour Tiers',
            exported: 'Exporter',
            stateTraiter: 'Passer en état « Traité »',
            stateNonTraiter: 'Passer en état « Non Traité »',
          },
          column: {
            state: 'Etat',
            majTiers: 'Maj Tiers',
            export: 'Export',
            userTraitement: 'User traitement',
            date: 'Date',
            dateMandat: 'Date mandat',
            nameOrigin: 'Nom origine',
            ibanOrigine: 'IBAN origine',
            nouvNom: 'Nouveau Nom',
            nouvIban: 'Nouvel IBAN',
            bicOrigin: 'BIC origine',
            nouvBic: 'Nouveau BIC',
            visualisation: 'Visualisation',
            timestamp_creation: 'Date création',
          },
          columnVisu: {
            type: 'Type',
            end_to_end_id: 'EndToEndId',
            reason: 'Motif',
            ics: 'I.C.S',
            rum: 'RUM',
          },
          modal_confirm: {
            maj_tiers: 'Voulez-vous mettre à jour les Tiers ',
            export: 'Voulez-vous exporter les mobilités ',
            traite: 'Voulez-vous passer les mobilités en état "Traité" ',
            no_traite: 'Voulez-vous passer les mobilités en état "Non Traité" ',
          },
        },
        anaysePlacement: {
          titleFinanciers: 'Placement par établissement financiers',
          titleTYpe: 'Répartition par type',
          societe: 'Placements par société',
          addPlacement: 'Ajouter les relevés',
          title: 'Analyse placement',
        },
        retourFichier: {
          title: 'Details de fichier retour',
          table: {
            title: 'Liste des fichiers Retour',
            column: {
              nId: 'N° ID',
              flux: 'Flux / Code-Nom compte',
              nomFIle: 'Nom de fichier / IBAN',
              banque: 'Banque / Nb opérations',
              fileFormat: 'Format du fichier / Montant',
              receptions: 'Réception / Remise',
            },
          },
          fiche: {
            flux: 'Flux',
            emmetteur: 'Emetteur',
            reference: 'Références',
            data_r: 'Date Réception',
            date_remise: 'Date Remise',
            nb: 'Nb',
            montantRemise: 'Montant remise',
            table: {
              num: 'N°',
              tier: 'Tiers',
              ultimateT: 'Ultimate Tiers',
              code: 'Codes',
              ref: 'Référence/Libellé',
              montant: 'Montant',
              devise: 'Devise',
            },
          },
        },
      },
      referentiel: {
        Comptes: {
          fiche: {
            titles: {
              edit_title: 'Fiche du compte {{code}} - {{iban}}',
              new_title: "Création d'un nouveau compte",
              view_title: 'Fiche du compte',
              bank_infos: 'Coordonnées bancaires',
              settings: 'Paramétrage',
              plus_infos: 'Informations complémentaires',
              accounting_zone: 'Zones comptables',
            },
            buttons: {
              back: 'Annuler',
              save: 'Valider',
              create: 'Créer',
              history: 'Historique',
              close: 'Fermer',
            },
            tabs: {
              flow: 'Flux',
              check: 'Chèque',
              account: 'Compta',
              contacts_agence: 'Contacts agence',
            },
            champ_titles: {
              company: 'Société',
              code: 'Code',
              state: 'Etat',
              name: 'Nom',
              country: 'Pays',
              account_num: 'N° de compte',
              bic: 'BIC',
              bank: 'Banque',
              devise: 'Devise',
              domiciliation: 'Domiciliation',
              emetteur: 'Autorisé compte émetteur',
              tiers: 'Autorisé compte tiers',
              custom: {
                custom_1: 'Custom1',
                custom_2: 'Custom2',
                custom_3: 'Custom3',
                custom_4: 'Custom4',
                custom_5: 'Custom5',
              },
              balance_continuity_check: 'Continuité date de solde',
              alternative_account: 'N° compte alternatif',
              sender_code: 'N° émetteur',
              sender_code_vcom: 'N° émetteur VCOM',
              fileformat: 'FileFormat relevé de compte',
              number_next: 'Prochain N° chèque',
              number_end: 'Dernier N° chèque',
              cmc7_1: 'Ligne CMC7 1',
              cmc7_2: 'Ligne CMC7 2',
              account_info: 'Information compte',
              zone_payable: 'Zone "Payable" du chèque',
              accounting: 'Compte Comptable',
              journal: 'Code Journal',
              auxiliary: 'Compte Auxiliaire',
              customize1: 'Custom1',
              customize2: 'Custom2',
              customize3: 'Custom3',
              customize4: 'Custom4',
              customize5: 'Custom5',
              customize6: 'Custom6',
              customize7: 'Custom7',
              customize8: 'Custom8',
              customize9: 'Custom9',
              customize10: 'Custom10',
              default_placeholder: '<Contact agence principal par défaut>',
              contact_agence: 'Contact Agence',
              contactFlux: 'Contact Flux',
              contactPouvoir: 'Contact Pouvoir',
              autorise_operation: 'Autorisé Opération de change',
            },
          },
          table: {
            header: {
              title: 'Liste des comptes',
              new_account: 'Nouveau',
            },
            filters: {
              state: '-Etat-',
            },
            searchInput: {
              caption: 'Rechercher un compte par code, nom ou société',
            },
            buttons: {
              rib_print: 'Imprimer RIB',
            },
            columns: {
              state: 'Etat',
              code: 'Code',
              name: 'Nom',
              bank: 'Banque',
              iban: 'IBAN',
              company: 'Société',
              pays: 'Pays Banque',
              devise: 'Devise',
              date: 'Date de modification',
            },
          },
        },
        Echéancier: {
          fiche: {
            title: {
              edit_title: 'Fiche du format {{code}}',
              view_title: "Fiche d'un échénacier",
              new_title: "Création d'un nouvel échéancier",
              date_manage: 'Gestion Date',
              mandate: 'Mandat',
              flow_custom: 'Champs de flux customisé',
            },
            buttons: {
              back: 'Annuler',
              save: 'Valider',
              create: 'Créer',
            },
            champ_titles: {
              mandate: 'Mandat',
              flow: 'Flux',
              value_date: 'Date de valeur',
            },
          },
          table: {
            header: {
              title: 'Liste des échéanciers',
              new_timeline: 'Nouveau',
            },
            columns: {
              state: 'Etat',
              company_rum: 'Société/RUM',
              code_tiers: 'Tiers débiteur',
              nom_tiers: 'Nom tiers débiteur',
              amount: 'Montant',
              reason: 'Motif',
              expiry_date: 'Date 1ere échéance',
              next_expiry_date: 'Date prochaine échéance',
              last_expiry_date: 'Date dernière échéance',
              periodicity: 'Périodicité',
              flow: 'Flux',
            },
          },
        },
        GroupesTiers: {
          fiche: {
            title: {
              edit_title: 'Fiche du groupe',
              view_title: 'Fiche du groupe {{code}}',
              new_title: "Création d'un nouveau groupe",
            },
            buttons: {
              back: 'Annuler',
              save: 'Valider',
              create: 'Créer',
            },
            champ_titles: {
              name: 'Nom',
              code: 'Code',
            },
          },
          table: {
            header: {
              title: 'Liste des groupes de tiers',
              new_thirdpartygroup: 'Nouveau',
            },
            columns: {
              code: 'Code',
              name: 'Nom',
              date: 'Date de modification',
            },
          },
        },
        Mandats: {
          fiche: {
            title: {
              edit_title: 'Fiche du mandat {{variable}}',
              view_title: 'Fiche du mandat {{variable}}',
              new_title: "Création d'un nouveau mandat",
              contact: 'Contact',
              amendments: 'Amendements',
              doc: 'Documents',
              history: 'Historique',
            },
            buttons: {
              back: 'Annuler',
              save: 'Valider',
              new: 'Nouveau',
              create: 'Créer',
            },
            modal: {
              title: {
                doc: 'Document',
              },
              buttons: {
                join: 'Joindre',
                cancel: 'Annuler',
              },
              champ_titles: {
                doc_type: 'Type de document',
                doc_name: 'Nom document',
                state: 'Etat',
                start_date: 'Date de début',
                end_date: 'Date de fin',
                pdf_doc: 'Document',
                type: 'Type',
              },
              pdf_file_message:
                'Merci de sélectionner un fichier justificatif au format pdf',
              doc_type: 'Vous devez renseigner le type du document.',
              doc_name: 'Vous devez renseigner le nom du document.',
            },
            columns: {
              status: 'Statut',
              state: 'Etat',
              withdrawal_date: 'Date prélèvement',
              unpaid_date: 'Date impayés',
              reason: 'Motif',
              representation: 'Représentation',
              amount: 'Montant',
              reference: 'Reférence',
              start_date: 'Date Début',
              end_date: 'Date Fin',
              date: 'Date',
              doc_name: 'Nom Document',
              doc_type: 'Type Document',
              visualisation: 'Visualisation',
            },
            champ_titles: {
              company: 'Société',
              internal_code: 'Code interne',
              descrip: 'Description du contrat',
              interne: 'Référence interne',
              state: 'Etat',
              rum: 'Référence Unique du Mandat (RUM)',
              payment: 'Paiement',
              NumContrat: 'N° contrat',
              email: 'Email',
              fax: 'Fax',
              name: 'Nom',
              first_name: 'Prénom',
              payment_type: 'Type de paiement',
              mandate_type: 'Type de mandat',
              sequence_type: 'Type de séquence',
              creation_date: 'Date de création',
              closing_date: 'Date de fermeture',
              signature_date: 'Date de signature',
              third_party_code: 'Code tiers débiteur',
              third_party_name: 'Nom tiers débiteur',
              prev_rum: 'Ancien RUM',
              updated_state: 'Etat Mandat modifié',
            },
          },
          table: {
            header: {
              title: 'Liste des mandats',
              new_mandat: 'Nouveau',
            },
            columns: {
              state: 'Etat',
              company_rum: 'Société/RUM',
              type: 'Type',
              sequence: 'Séquence',
              signing: 'Signature',
              code_tiers: 'Tiers débiteur',
              nom_tiers: 'Nom tiers débiteur',
              code: 'Code',
            },
          },
        },
        Scopes: {
          fiche: {
            title: {
              edit_title: 'Fiche du scope {{name}}',
              view_title: 'Fiche du scope {{name}}',
              new_title: "Création d'un nouveau scope",
              user_member_list: 'Liste des utilisateurs membres',
              companies_member_list: 'Liste des sociétés membres',
              accounts_member_list: 'Liste des comptes membres',
              tiersGrp_member_list: 'Liste des groupes de tiers membres',
              list_flux: 'Liste des flux',
            },
            modal: {
              user_list: "Sélection d'utilisateurs",
              company_list: 'Sélection de sociétés',
              account_list: 'Sélection de comptes',
              third_party_group_list: 'Sélection de groupe de tiers',
              flux_list: 'Sélection de flux',
            },
            buttons: {
              back: 'Annuler',
              save: 'Valider',
              create: 'Créer',
              add: 'Ajouter',
              close: 'Annuler',
              history: 'Historique',
            },
            champ_titles: {
              code: 'Code',
              name: 'Nom',
              first_name: 'Prénom',
              state: 'Etat',
              new: 'Nouveau',
              iban: 'IBAN',
            },
          },
          table: {
            header: {
              title: 'Liste des scopes',
              new_scope: 'Nouveau',
            },
            columns: {
              state: 'Etat',
              code: 'Code',
              name: 'Nom',
              date: 'Date de modification',
              flux: 'Flux',
              devise: 'Devise',
            },
          },
        },
        Societes: {
          fiche: {
            title: {
              edit_title: 'Fiche de la société {{name}}',
              new_title: "Création d'une nouvelle société",
            },
            buttons: {
              back: 'Annuler',
              save: 'Valider',
              create: 'Créer',
              history: 'Historique',
            },
            champ_titles: {
              title_adress: 'Adresse de la société',
              title_infos_complet: 'Informations complèmentaires',
              button_charge_adress_structure: 'Charger adresse structurée',
              title_adress_structure: 'Adresse structurée de la société',
              name: 'Nom',
              code: 'Code',
              fax_num: 'N° Fax',
              tel_num: 'N° Téléphone',
              legal_infos: 'Informations légales',
              state: 'Etat',
              adresse: 'Adresse',
              country: 'Pays',
              cloture_date: 'Date de clôture',
              logo: 'Logo',
              date: 'Date de modification',
              capital: 'Capital',
              capital_currency: 'Devise Capital',
              title_list_mandant: 'Liste des mandants',
              ordre: 'Ordre',
              type_mandat: 'Type Lien Mandant',
              mandat_name: 'Nom Mandant',
              fonction: 'Fonction',
              date_start: 'Date début',
              date_end: 'Date fin',
              long_name: 'Nom Long',
              tva: 'N° TVA',
              form_legacy: 'Forme Juridique',
            },
            columns: {
              state: 'Etat',
            },
            modal_mandant: {
              title: 'Fiche Mandant',
              ordre: 'Ordre',
              type_mandat: 'Type Lien Mandant',
              mandat_name: 'Mandant',
              nomination: 'Nomination',
              comment: 'Commentaire',
              date_start: 'Date début',
              date_end: 'Date fin',
              type_mandant: 'Type mandant',
              function: 'Fonction',
              modal_add_user: {
                title: "Sélection d'un utilisateur",
                state: 'Etat',
                login: 'Login',
                name: 'Nom',
                last_name: 'Prénom',
              },
              modal_add_society: {
                title: "Sélection d'un société",
                state: 'Etat',
                name: 'Nom',
                code: 'Code',
                society: 'Société',
              },
            },
          },
          drawer: {
            title: 'Gestion',
            gestion_fx: 'Gestion FX',
            companyb2b: 'Société B2B',
            holdingb2b: 'Holding B2B',
          },
          table: {
            header: {
              title: 'Liste des sociétés',
              new_company: 'Nouveau',
            },
            columns: {
              state: 'Etat',
              code: 'Code',
              name: 'Nom',
              date: 'Date de modification',
              ics: 'ICS',
              country: 'Pays',
            },
          },
        },
        Tiers: {
          fiche: {
            title: {
              title_adress: 'Adresse banque',
              title_adress_structure_banque: 'Adresse structurée banque',
              title_adress_tiers: 'Adresse tiers',
              title_adress_structure_tiers: 'Adresse structurée tiers',
              title_adress_bank_intermediaire: 'Adresse banque intermediaire',
              title_adress_structure_bank_intermediare:
                'Adresse structurée banque intermediaire',
              edit_title: 'Fiche du tiers',
              view_title: 'Fiche du tiers {{lastname}}',
              new_title: "Création d'un nouveau tiers",
              bank_infos: 'Coordonnées bancaires',
              third_address: 'Adresse du tiers',
              intermediate_bank: 'Banque intermédiaire',
              text_lecture_seule:
                'Lecture seule - Modification 4Yeux en attente',
            },
            buttons: {
              back: 'Annuler',
              save: 'Valider',
              create: 'Créer',
              checkAccount: 'Vérifier le compte',
              checkBic: 'Vérifier le Bic',
            },
            champ_titles: {
              grp: 'Groupe',
              state: 'Etat',
              type: 'Type',
              code: 'Code',
              name: 'Nom',
              siret: 'SIRET',
              tva: 'TVA',
              country: 'Pays',
              account_num: 'N° de compte',
              devise: 'Devise',
              clearing: 'Clearing',
              clearing_id: 'Clearing code / Bank code',
              domiciliation: 'Domiciliation',
              adresse: 'Adresse',
              country_code: 'Code Pays',
              prenom: 'Prénom',
              birth_date: 'Date de naissance',
              country_birth: 'Pays de naissance',
              city_birth: 'Ville de naissance',
              mail: 'Email',
              tiersType: 'Type de paiement tiers',
            },
            list_operation: {
              title: 'Liste des opérations',
              button_title: 'Activités',
              montant: 'Montant',
              currency: 'Devise',
              date: "Date d'opération",
              label: 'Libellé',
              lot_number: 'N° lot',
              remittance_number: 'N° remise',
              flow: 'Flux',
              onglet_operation: 'Opération',
              onglet_mandat: 'Mandat',
              onglet_timeline: 'Echéancier',
              onglet_analyse: 'Analyse',
              button_contre_appel: 'Contre-appel',
              title_commentaire_panel: 'Commentaire',
              confirm_message:
                'Confirmez-vous avoir effectué le contre-appel de ce Tiers ?',
            },
          },
          table: {
            header: {
              title: 'Liste des tiers',
              new_third: 'Nouveau',
            },
            columns: {
              state: 'Etat',
              type: 'Type',
              code: 'Code',
              name: 'Nom',
              account_num: 'N° de compte',
              devise: 'Devise',
              grp: 'Groupe',
              country: 'Pays',
              date: 'Date de modification',
              control: 'Contrôle',
              thirdparty_country_code: 'Pays Tiers',
              siret: 'SIRET',
              tva: 'TVA',
              type_payement: 'Type de paiement',
            },
          },
        },
        validation4Yeux: {
          title: 'Sélection des valideurs 4 Yeux',
          alert: 'Merci de sélectionner un valideur 4Yeux',
          columns: {
            login: 'Login',
            last_name: 'Nom',
            first_name: 'Prénom',
          },
        },
        Bank: {
          invalidIBAN:
            'IBAN non valide .Format : {{default_form}}, Exemple: {{example}}',
          invalidBIC: 'Le champ doit contenir 8 ou 11 caractères',
          invalidBBAN:
            'BBAN non valide. Format : {{default_form}}, Exemple: {{example}}',
          bbanInfos: ' Format : {{default_form}}, Exemple: {{example}}',
          invalidIBAN_simple: 'IBAN non valide',
          invalidBBAN_simple: 'BBAN non valide',
        },
      },
      settings: {
        filialeusers: {
          modal: {
            title: "Sélection d'un utilisateur",
          },
          fiche: {
            title: {
              edit_title: "Fiche de l'utilisateur {{name}}",
              new_title: "Création d'un nouvel utilisateur",
              view_title:
                "Fiche du profil d'utilisateur {{name}} (Lecture seul - Modification 4Yeux en attente)",
              group_users: 'Membre de',
            },
            buttons: {
              back: 'Annuler',
              save: 'Valider',
              history: 'Historique',
              reinitialise: 'Réinitialiser TOTP',
              reinitialise_pwd: 'Réinitialiser Mot de passe',
              message_confirm_pwd: 'Voulez-vous réinitialiser le mot de Passe',
            },
            placeholder: "Sélection d'un utilisateur",
            login: 'Login',
            email: 'Email',
            name: 'Nom',
            prenom: 'Prénom',
            langue: 'Langue',
            smart: 'Smart-tags',
            nPhone: 'Téléphone',
            nFax: 'Fax',
            nMobile: 'Mobile',
          },
          table: {
            header: {
              title: 'Liste des utilisateurs',
              new_user: 'Nouveau',
              list_pouvoir: 'Liste pouvoir utilisateur',
              detail_pouvoir: 'Liste détaillée pouvoir',
              title_button: 'Impression Synthèse Pouvoirs',
            },
            columns: {
              user_entity_state: 'Etat user entité',
              user_state: 'Etat',
              login: 'Login',
              name: 'Nom',
              prenom: 'Prénom',
              email: 'Email',
              nMobile: 'N° Mobile',
              date: 'Date de modification',
            },
          },
        },
        groupusers: {
          fiche: {
            title: {
              edit_title: 'Fiche du profil utilisateur {{name}}',
              new_title: "Création d'un profil utilisateur",
              view_title:
                "Fiche du profil d'utilisateur {{name}} (Lecture seul - Modification 4Yeux en attente)",
              members: 'Membres',
              authorizations: 'Autorisations',
              flow: 'Flux',
              accounting: 'Comptabilité',
              accounting_export: 'Export comptable',
              setting: 'Paramétrage',
            },
            buttons: {
              back: 'Annuler',
              save: 'Valider',
              history: 'Historique',
              create: 'Créer',
            },
            champ_titles: {
              code: 'Code',
              state: 'Etat',
              name: 'Nom',
              users: 'Utilisateurs',
              users_grp: "Profils d'utilisateurs",
              smart_tag: 'SmartTags',
            },
            columns: {
              login: 'Login',
              name: 'Nom',
              first_name: 'Prénom',
              state: 'Etat',
              flow: 'Flux',
              readings: 'Relevés',
              repository: 'Référentiel',
              settings: 'Paramétrage',
              treatments: 'Traitements',
              accounting: 'Comptabilité',
              accounting_export: 'Export comptable',
              rates_and_currencies: 'Taux et Devises',
            },
          },
          modal: {
            title: 'Sélectionner un utilisateur',
            buttons: {
              add: 'Ajouter',
              close: 'Annuler',
            },
          },
          table: {
            header: {
              title: "Liste des profils d'utilisateurs",
              new_groupuser: 'Nouveau',
              synthesis: 'Synthèse profils utilisateurs',
              export_droit: 'Export Excel des droits',
            },
            columns: {
              state: 'Etat',
              code: 'Code',
              name: 'Nom',
              date: 'Date de modification',
            },
          },
        },
        SmartTags: {
          fiche: {
            title: {
              edit_title: 'Fiche du Smart Tag {{code}}',
              create: "Création d'un nouveau Smart Tag",
            },
            buttons: {
              back: 'Annuler',
              save: 'Valider',
              archive: 'Archiver',
            },
            champ_titles: {
              users: 'Utilisateurs',
              users_grp: "Profils d'utilisateurs",
            },
          },
          table: {
            header: {
              title: 'Liste des SmartTags',
            },
            columns: {
              code: 'Code',
            },
          },
        },
        FourYeux: {
          fiche: {
            title: {
              default: 'Demande validée',
              creation: 'Demande de création',
              modification: 'Demande de modification',
              suppression: 'Demande de suppression',
              revoke: 'Annuler la demande',
            },
            buttons: {
              back: 'Annuler',
              save: 'Valider la demande',
              refuse: 'Refuser la demande',
              create: 'Créer',
              revoke: 'Annuler la demande',
              alert: 'Veuillez visualiser le document RIB avant de valider',
            },
            champ_titles: {
              initiale: 'Fiche initiale',
              demande: 'Fiche modifiée',
            },
          },
          table: {
            header: {
              title: '4Yeux validation',
            },
            columns: {
              code: 'Code',
              state: 'Etat',
              libelle: 'Libellé',
              date: 'Date de modification',
              demand_number: '#',
              denomination: 'Dénomination',
              demand_type: 'Type de demande',
              short_name: 'Nom (long)',
              demandeur: 'Demandeur',
              demand_date: 'Date de demande',
              validator: 'Validateur',
              validation_date: 'Validation / Refus',
            },
          },
        },
        pouvoirSignature: {
          table: {
            header: {
              title: 'Liste des pouvoirs de signature',
              synthese: 'Synthèse des pouvoirs',
            },
          },
          fiche: {
            title_form: 'Fiche du pouvoir',
            title_create: "Création d'un nouveau pouvoir de signataire",
            code: 'Code',
            code_placeholder: 'Code du pouvoir de signature',
            name: 'Nom',
            name_placeholder: 'Nom du pouvoir de signature',
            type: 'Type',
            etat: 'Etat',
            flux: 'Flux',
            devise: 'Devise',
            titleTab1: 'Collège de signataires',
            titleTab2: 'Liste des sociétés membres',
            titleTab3: 'Liste des comptes membres',
            signatoryType: 'Type Signataire',
            table_colleg_signature: {
              pouvoir_descr: 'Description',
              coll1: 'Collège 1',
              coll2: 'Collège 2',
              niveau: 'Niveau',
              type: 'Type de seuil',
              seuil: 'Seuil inf',
              seuil_sup: 'Seuil sup.',
              ordre: 'Ordre',
            },
            table_societe_member: {
              code: 'Code',
              name: 'Nom',
              state: 'Etat',
            },
            table_compte_member: {
              code: 'Code',
              name: 'Nom',
              iban: 'IBAN',
              state: 'Etat',
            },
            modalSignature: {
              title: 'Ajouter des collèges de signataires',
              add: 'Ajouter',
              cancel: 'Annuler',
              pouvoir_descr: 'Descriptions de pouvoir',
              niv_signature: 'Niveau de signature',
              college_1: 'Collège 1',
              college_2: 'Collège 2',
              college: 'Collège {{nb}}',
              ordre: 'Ordre',
              type_seuil: 'Type de seuil',
              seuil_inf: 'Seuil inférieur',
              seuil_supp: 'Seuil supérieur',
              error_colleg1: 'Veuillez choisir un collège 1',
              error_threshold: 'Valeur(s) de seuil incorrecte(s)',
            },
            modal_company_member: {
              title: 'Sélection de sociétés',
            },
            modal_compte_member: {
              title: 'Sélection de comptes bancaires',
            },
            buttons: {
              back: 'Annuler',
            },
          },
        },
        college: {
          table: {
            header: {
              title: 'Liste des collèges de signataire',
              synthese: 'Synthèse des collèges',
            },
            columns: {
              state: 'Etat',
              code: 'Code',
              name: 'Nom',
              electronic_signature: 'Signature éléctronique',
              date: 'Date de modification',
            },
          },
          fiche: {
            title: {
              edit_title: 'Fiche du collège {{code}}',
              new_title: "Création d'un nouveau collège de signataire",
              signatories: 'Signataires',
            },
            buttons: {
              back: 'Annuler',
              save: 'Valider',
              history: 'Historique',
            },
            champ_titles: {
              code: 'Code',
              name: 'Nom',
              state: 'Etat',
              signature: 'Signature',
            },
            columns: {
              state: 'Etat',
              first_name: 'Prénom',
              name: 'Nom',
              login: 'Login',
            },
          },
          modal: {
            title: 'Sélectionner un utilisateur',
            buttons: {
              add: 'Ajouter',
              close: 'Annuler',
            },
          },
          history: {
            title: {
              edit_title: 'Historique des modifications de la fiche : {{time}}',
            },
            columns: {
              state: 'Etat 4Yeux',
              timestamp_creation: 'Date création',
              update_timestamp: 'Date validation',
              login_creation: 'Création',
              login_validation: 'Validation',
            },
            buttons: {
              back: 'Annuler',
            },
          },
        },
      },
      treatment: {
        jobs: {
          message: 'Voulez-vous relancer le job',
          change_failed: 'Voulez-vous passer le job en Failed',
          change_failed_placeholder: 'Passage en Failed',
          relance_placeholder: 'Relancer',
          header: {
            title: 'Liste des Jobs',
          },
          columns: {
            job_number: 'N° de Job',
            status: 'Statut',
            type: 'Type',
            priority: 'Priorité',
            recursive: 'Récurrent',
            date: 'Date de création',
            programmation_date: 'Programmé le',
            start_date: 'Début de traitement',
            end_date: 'Fin de traitement',
            error_code: "Code d'erreur",
            server: 'Serveur',
            description: 'Description',
          },
        },
        controle: {
          header: {
            title: 'Liste des demandes de contrôle',
            add: 'Contrôle de tiers',
          },
          columns: {
            etat: 'Etat',
            date_envoye: "Date d'envoi",
            type: 'Type',
            libelle: 'Libelle',
            login: 'Login',
            nb: 'Nb',
            ok: 'Ok',
            di: 'Diam.',
            nok: 'NOK',
            vis: 'Visualisation',
            nb_verif: 'Nb Vérifié',
            nb_risk: 'Nb Risqué',
            nb_high_risk: 'Nb Très Risqué',
            nb_no_verif: 'Nb Non Vérifié',
          },
          newSSid: {
            thirdG: 'Groupe de tiers',
            thirdP: 'Tiers unitaire',
            placeholder:
              'Renseigner les 3 premières lettres du tiers recherché',
          },
        },
        details: {
          title: 'Liste des demandes de controle',
          fermer: 'Fermer',
          titleDrawer: 'Reason',
          columns: {
            state: 'Etat',
            code: 'Code',
            name: 'Nom',
            nCompte: 'N° Compte',
            idEnv: 'SIRET / TVA',
            typeT: 'Type tiers',
            codeP: 'Code pays',
            noteP: 'Note Analyse',
            reason: 'Reason',
            date_analyse: 'Date Demande',
          },
        },
      },
      accounting: {
        writing: {
          fiche: {
            title: {
              edit_title: "Fiche de l'écriture {{libelle}}",
              view_title: "Fiche de l'écriture",
              new_title: "Création d'une nouvelle écriture",
              caracteristic: 'Caractéristiques',
              accounting_caracteristic: 'Caractéristiques Comptabilité',
              reconciliation: 'Rapprochement comptable',
            },
            buttons: {
              back: 'Annuler',
              save: 'Valider',
            },
            champ_titles: {
              account: 'Compte',
              placeholder_account: 'Select le Code compte',
              libelle: 'Libellé',
              operation_date: 'Date Opération',
              writing_number: 'Num. Ecriture',
              category: 'Catégorie',
              state: 'Etat',
              amount: 'Montant',
              writing_type: 'Type Ecriture',
              code_sens: 'Code Sens',
            },
            placeholder: {
              amount: "Montant de l'opération",
              category: 'Saisir le Code Catégorie',
              writing_number: 'Numéro écriture',
            },
          },
          table: {
            header: {
              title: 'Liste des écritures',
              error_selected: 'Erreur',
              txt_error: "Les écritures sélectionnées n'ont pas le même état",
              visualisation: 'Visualisation session ',
            },
            filters: {
              state: '-Etat-',
              scope: '- Scope -',
              title: 'Modification de masse des écritures',
              operationDate: 'Date opération',
              category: '-  Catégorie -',
              title_import: 'Import des écritures',
              selected_file: 'Selectionner les fichiers',
              aucun_file: 'Aucun fichier sélectionner',
            },
            columns: {
              state: 'Etat',
              libelle: 'Libellé',
              montant: 'Montant',
              devise: 'Devise',
              categorie: 'Catégorie',
              operation_date: 'Date opération',
              reference: 'N° écriture',
              account: 'Compte',
              company: 'Société',
              code_sens: 'Sens',
              writing_type: 'Type écriture',
              modif: 'Modification',
              user: 'User',
              opening_balance: 'Solde début',
              ending_balance: 'Solde fin',
              session_entries_id: 'IDSession',
            },
          },
          visu_session: {
            title: 'Liste des sessions',
            columns: {
              id: 'ID',
              account: 'Compte',
              date: 'Date',
              opening_balance: 'Solde début',
              ending_balance: 'Solde fin',
              devise: 'Devise',
              state: 'Etat',
            },
            activate: 'Passer en actif',
            confirm_validation_msg:
              "Voulez-vous passer en « Actif » la session d'ecritures",
          },
          action: {
            title: 'Action',
            edit_masse: 'Modification masse',
            print: 'Imprimer',
            importer: 'Importer',
          },
        },
        rules: {
          fiche: {
            title: {
              edit_title: 'Fiche de la règle {{code}}',
              view_title: 'Fiche de la règle {{code}}',
              new_title: "Création d'une nouvelle Règle",
              rapprochement_criteria: 'Critères de Rapprochement',
              operation_linked: 'Liste des codes opérations liés',
              members: 'Liste des membres',
              rappro: 'Rapprochement par montant',
              modal_title: 'Liste des sociétés',
            },
            buttons: {
              back: 'Annuler',
              save: 'Valider',
              new: 'Nouveau',
              create: 'Créer',
            },
            champ_titles: {
              state: 'Etat',
              code: 'Code',
              name: 'Nom',
              order: 'Ordre',
              category: 'Catégorie',
              mode: 'Mode',
              rapprochement_by_date: 'Rapprochement par date',
              rapprochement_by_label: 'Rapprochement par libellé',
              rapprochement_by_ref: 'Rapprochement par référence',
              date_difference: 'Ecart Date',
              detail_flux: 'Détail flux brouillard',
              placeholder_detail_flux: 'Détail',
              download_model: 'Télécharger modèle excel',
            },
            error_critere:
              'Veuillez sélectionner au moins un critère de rapprochement pour valider cette règle',
            columns: {
              code: 'Code',
              name: 'Nom',
            },
          },
          table: {
            header: {
              title: 'Liste des règles',
              new_rule: 'Nouveau',
            },
            columns: {
              state: 'Etat',
              code: 'Code',
              name: 'Nom',
              date: 'Date de modification',
              automanuel: 'Auto Manuel',
              order: 'Ordre',
            },
          },
        },
        historique: {
          title: 'Historique de rapprochement',
          show_details: 'Visualisation Détail',
          session_selection: 'Sélection Session',
          deraprochement: 'Dérapprochement Session',
          scope: 'Scope',
          company: 'Société',
          code: 'Saisir le code compte',
          mvt_bancaire: 'Mouvements bancaire rapprochés',
          ecriture_rapprochement: 'Ecritures comptables rapprochées',
          message: 'Voulez-vous renvoyer le lot à la banque ?',
          category: 'Catégorie',
          writing_date: 'Date Ecriture',
          rappro_date: 'Date Rappro',
          columns: {
            account: 'Compte',
            category: 'Cat.',
            date: 'Date Ope.',
            label: 'Libellé',
            amount: 'Montant',
          },
          modal: {
            title: {
              session_list: 'Liste des sessions',
            },
            buttons: {
              visualize: 'Visualiser',
            },
            columns: {
              date_num: 'Date/Num.',
              user: 'User',
              mvt_number: 'Nb Mvts',
              wrt_number: 'Nb Ecr',
              nb_mvt: 'Nb mouvement',
              nb_prevision: 'Nb prévision',
            },
          },
          detail: {
            columns: {
              account: 'Compte',
              amount: 'Montant',
              label: 'Libellé',
              date: 'Date Valeur',
              op_date: 'Date Opé.',
              category: 'Catégorie',
              gap: 'Ecart',
              state: 'Etat',
              sel: 'Sél.',
              referency: 'N° écriture',
            },
            buttons: {
              validate: 'Derapprocher',
              save: 'Valider',
              back: 'Retour',
            },
            titles: {
              general: 'Rapprochement - Detail',
              movement: 'Mouvements bancaires rapprochés',
              detail: 'Rapprochement',
              writing: 'Ecritures comptables rapprochées',
            },
            champ_titles: {
              number: 'Nb',
              movement_total: 'Total Mouvements',
              gap: 'Ecart',
              writtingTotal: 'Total Écritures',
            },
          },
        },
        rapprochement: {
          header: {
            title: 'Rapprochement',
            manuel: 'Regle manuelle',
            montant: 'Montant 1/1',
            montantNN: 'Montant N/N',
            rapprocher: 'Rapprocher',
            comment: 'Commentaires',
            eclatement: 'Eclatement',
            date_cloture: 'Date clôture',
            title_rappro: 'Rapprochement - Détail',
            total_movements: 'Total Mouvements',
            gap: 'Ecart',
            total_entries: 'Total écritures',
            number: 'Nb',
            nodata: 'Pas de données',
            message_validation:
              "Attention tous les comptes n'ont pas la même date de clôture. La plus petite date a été sélectionnée.",
          },
          modal: {
            titles: {
              burst: "Eclatement de l'écriture",
              comment: 'Commentaires du mouvement',
            },
            comment: 'Commentaire',
            new: 'Nouveau',
            total: 'Total Saisie',
            rest: 'Reste a eclaté',
          },
          cards: {
            closed_banking_infos: 'Mouvements bancaires à rapprocher',
            closed_writing: 'Ecritures à rapprocher',
          },
          columns: {
            title: {
              account: 'Compte',
              cat: 'Cat',
              currency: 'Dev.',
              account_id: 'Code Opé.',
              op_date: 'Date Opé.',
              label: 'Libellé',
              date: 'Date',
              hour: 'Heure',
              comment: 'Comentaire',
              referency: 'N° écriture',
              entry_type: 'Type écriture',
              creation_timestamp: 'Date création',
              login: 'Login',
              amount: 'Montant',
              ref: 'Référence',
              direction: 'Sens',
              reconcil_number: 'N piece',
              com: 'Com.',
              company: '- Société -',
              account_code: '- Code Compte -',
              category: '- Categorie -',
              complementary_label: 'Libellé complémentaire',
              group_compte: '- Groupe Compte -',
            },
          },
          footer: {
            total_forecasts: 'Total Ecritures',
          },
          detail: {
            table_mvt: {
              sel: 'Sél.',
              cat: 'Catégorie',
              op_date: 'Date Opé.',
              amount: 'Montant',
              ref: 'Référence',
              dat: 'Date Opé.',
            },
            table_rappro: {
              account: 'Compte',
              diff: 'Ecart',
              state: 'Etat',
            },
          },
        },
        consultation: {
          table: {
            header: {
              title: {
                general: 'Consultation des soldes comptables',
                selecte_date: 'Sélection date',
              },
              champ_titles: {
                scope: 'Scope',
                company: 'Société',
                start_date: 'Date Début',
                end_date: 'Date Fin',
              },
              select: {
                account: '- Compte -',
                company: '- Société -',
                scope: '- Scope -',
              },
            },
            buttons: {
              init: 'Initialiser',
              close: 'Fermer',
              add: 'valider',
              print: 'Imprimer',
              print1: 'Mouvements non rapprochés',
              print2: 'Écriture non rapprochés',
              print3: 'Écritures période',
            },
            columns: {
              history: {
                bank_balance: 'Solde bancaire',
                movement_number: 'Nbs mvts',
                amount: 'Total mouvements non rapprochés',
                number_writing: 'Nb écrit',
                sum_amount: 'Total écriture non rapprochées',
                accounting_balance: 'Solde comptable',
                currency: 'Devise',
                current_date: 'Date Solde en cours',
                imp: 'Etat de clôture',
              },
              table: {
                account_code: 'Code',
                name: 'Nom',
                society_code: 'Société',
                balance_date: 'Date Cloture',
                book_balance: 'Solde Cloture',
                valid_closing_date: 'Dernier Date Cloture validé',
                valid_closing_balance: 'Dernier Solde Cloture validé',
              },
            },
          },
          detail: {
            title: {
              init: 'Initialisation du solde comptable',
              info: 'Sélection des informations de clôture',
              mouvement: 'Sélection des mouvements non rapprochés',
              writing: 'Création des écritures comptables non rapprochés',
              sub_info:
                'Veuillez sélectionner les mouvements bancaires non rapprochés',
              sub_info_writing:
                'Veuillez créer les écritures comptables non rapprochées',
              bank_balance: 'Solde bancaire au {{date}}',
              accounting_balance: 'Solde Comptable au {{date}}',
              validation: "Validation de l'initialisation comptable",
              element_selected:
                'Mouvements bancaires non rapprochés sélectionnés : ( {{nbr}} éléments ) ',
              tooltip: 'Voir les éléments sélectionnés',
            },
            buttons: {
              next: 'Suivant',
              add: 'Ajouter',
              save: 'Valider',
              print: 'Afficher',
            },
            error: {
              date: 'La date d’opération ne doit pas être supérieure à la date choisie',
            },
            columns: {
              category: 'Catégorie',
              date: 'Date Opération',
              label: 'Libellé',
              amount: 'Montant',
              operation_date: 'Date opé.',
              currency: 'Devise',
              modification: 'Modification',
            },
            champ_titles: {
              balance_date: 'Date Solde',
              balance_accounting: 'Solde comptable',
              account: 'Code compte',
              total: 'Total mouvements non rapprochés',
              number: 'Nb',
              total_writing: 'Total écriture non rapprochés',
              operation_date: 'Date Opération',
              label: 'Libellé',
              category: 'Catégorie',
              amount: 'Montant',
              total_movement_not_reconciled: 'Total Mouvements non rapprochés',
              number_movement_not_reconciled:
                'Nb de mouvements  non rapprochés',
              total_writing_not_reconciled: 'Total Ecritures non rapprochés',
              number_writing_not_reconciled: "Nb d'écritures non rapprochés",
              difference_balance: 'Ecart avec solde saisie',
            },
          },
        },
        closure: {
          select: {
            account: '- Compte -',
            company: '- Société -',
            scope: '- Scope -',
          },
          table: {
            title: 'Clôture comptable',
            closing: 'Clôturer',
            state: 'Etat',
            code: 'Code',
            bank_balance: 'Solde bancaire',
            operation_number: 'Nb opérations',
            sum_operation_non_reconcil: 'Total mouvements non rapprochés',
            entry_number: 'Nb écritures',
            sum_entry_non_reconcil: 'Total écritures non rapprochées',
            accounting_balance: 'Solde comptable',
            currency: 'Devise',
            current_date: 'Date solde en cours',
            closing_state: 'Etat de clôture',
            modal: {
              title: 'Clôture de compte',
              confirm_closing: 'Voulez-vous clôturer ce(s) compte(s) ?',
              next_date: 'Prochaine date de clôture',
            },
          },
          history: {
            bank_balance: 'Solde Bancaire',
            movement_number: 'Nbs mvts',
            non_reconcil_movement: 'Total mouvements non rapprochés',
            accounting_entries_number: 'Nb écrit',
            non_reconcil_entries: 'Total écritures non rapprochées',
            accounting_balance: 'Solde comptable',
            currency: 'Devise',
            current_balance_date: 'Date Clôture',
            cancel_closing: 'Déclôturer',
            state: 'Etat de cloture',
            confirm_closing:
              'Vous allez annuler cette clôture et revenir à la session de rapprochement précédente. Désirez-vous continuer',
            last_closing: 'Dernière clôture',
            user: 'Utilisateur',
          },
          error: "Les comptes sélectionnées n'ont pas la même date de clôture",
          unselected_error: 'Vous devez sélectionner au moins un compte',
          action: 'Action',
          export_excl: 'Exporter Détails',
          imprime_detail: 'Imprimer détail',
        },
        movement: {
          title: 'Liste des mouvements non rapprochés',
        },
      },
      accounting_export: {
        rules: {
          fiche: {
            title: {
              edit_title: 'Fiche de la génération règle {{code}}',
              view_title: 'Fiche de la génération règle',
              new_title: "Création d'une nouvelle règle",
              treso_criteria: 'Critère Trésorerie',
              releve_criteria: 'Critère Relevé',
              flow_criteria: 'Critère Flux',
              filter_condition_imputation: 'Condition filtre et imputation',
            },
            buttons: {
              back: 'Annuler',
              save: 'Valider',
              add: 'Ajouter',
            },
            champ_titles: {
              state: 'Etat',
              code: 'Code',
              name: 'Nom',
              mode: 'Génération du brouillard',
              validation: 'Validation du brouillard',
              type: 'Type',
              interface_generation: 'Interface génération',
              export_interface: 'Interface export',
              event: 'Evènement',
              category: 'Catégorie',
              direction_type: 'Type Sens',
              direction: 'Sens',
              flow: 'Flux',
              sub_type: 'Sous-Type',
              all_wording: 'Tous les libellés (Par défaut)',
              find_wording: 'Libellé recherché',
              accounting_account: 'Cpt comptable',
              grouping: 'Regroupement',
            },
          },
          table: {
            header: {
              title: 'Listes des Règles',
              new_groupuser: 'Nouveau',
            },
            filters: {
              state: '-Etat-',
              interface_generation: '-Interface génération-',
            },
            columns: {
              title: {
                state: 'Etat',
                code: 'Code',
                name: 'Nom',
                date: 'Date de modification',
                interface_generation: 'Interface génération',
                export_interface: 'Interface export',
                category_flux: 'Catégorie/Flux',
                auto_manuel: 'Auto/Manuel',
              },
            },
          },
        },
        brouillards: {
          table: {
            header: {
              title: 'Listes des générations brouillards',
              show: 'Visualiser',
            },
            modal: {
              title: 'Liste des sessions',
              buttons: {
                show: 'Visualiser',
                close: 'Annuler',
              },
            },
          },
          alert: 'Merci de sélectionner une règle pour la visualisation',
          detail: {
            Number: 'Numéro',
            title: 'Génération Visualisation',
            Back: 'Retour',
            fog_validate: 'Valider Brouillard',
            getting_file: 'Récupération fichier',
            session: 'Modification de masse',
          },
          columns: {
            generation_interface: 'Génération interface',
            rule: 'Règle',
            event_type: 'Type Évènement',
            event_subtype: 'Sous type Évènement',
            category_flux: 'Catégorie/Flux',
            company: 'Société',
            account: 'Compte',
            amount_value: 'Montant',
            currency: 'Devise',
            accounting_date: 'Date comptable',
            creating_date: 'Date création',
            title_modal: 'Modifier un écriture',
          },
        },
        interfaces: {
          fiche: {
            title: {
              new_title: "Création d'une nouvelle interface de génération",
              edit_title:
                "Fiche de l'interface de génération du format {{code}}",
              general: 'Generale',
              company: 'Liste des sociétés membres',
              account: 'Liste des comptes membres',
            },
            buttons: {
              back: 'Annuler',
              save: 'Valider',
              add: 'Ajouter',
              close: 'Fermer',
            },
            modal: {
              title: {
                info: 'Liste des mots-clés',
                company: 'Sélection de sociétés',
                account: 'Sélection de comptes bancaires',
              },
              information: {
                now: 'Date du jour format AAMMJJ',
                year: 'Année sur 2 caractères suivi du quantième',
                hour1: 'Heure au format HHMMSS',
                hour2: 'Heure au format HHMMSSCCC',
                bank_name: 'Nom de la banque',
                interface_code: "Code de l'interface",
              },
            },
            champ_titles: {
              state: 'Etat',
              code: 'Code',
              name: 'Nom',
              connector: 'Connecteur',
              file_format: 'Format de fichier',
              naming: 'Nommage',
              mode_generation: 'Génération mode',
            },
          },
          table: {
            header: {
              title: 'Liste des interfaces de génération',
            },
            columns: {
              code: 'Code',
              name: 'Nom',
              format: 'Format',
              connector: 'Connecteur',
              state: 'Etat',
              update_timestamp: 'Date modification',
            },
          },
        },
      },
      ratecurrency: {
        currency: {
          currencyTitle: 'Fiche de la devise {{name}}',
          detailsColumns: {
            cours: 'Cours',
            last_update: 'Dernière mise à jour',
            update_timestamp: 'Date',
          },
          header: {
            title: 'Liste des devises',
          },
          columns: {
            cours: 'Cours',
            name: 'Nom',
            favorite: 'Favoris',
            update_timestamp: 'Dernière mise à jour',
            code: 'Code',
          },
          modal: {
            message: 'Voulez-vous mettre comme favori',
            message_unfav: 'Vous ne voulez plus comme favori',
          },
        },
        rates: {
          rateTitle: 'Fiche du taux directeur {{name}}',
          detailsColumns: {
            cours: 'Cours',
            last_update: 'Dernière mise à jour',
            update_timestamp: 'Date',
          },
          header: {
            title: 'Liste des taux directeurs',
          },
          columns: {
            cours: 'Cours',
            name: 'Nom',
            favorite: 'Favoris',
            update_timestamp: 'Dernière mise à jour',
          },
          modal: {
            message_fav: 'Voulez-vous mettre comme favori',
            message_unfav: 'Vous ne voulez plus comme favori',
          },
        },
        placeholder: {
          add_favory: 'Mettre en favori',
          remove_favory: 'Retirer des favoris',
        },
      },
    },
    administration: {
      communication: {
        chiffrement: {
          table: {
            title: ' Liste des chiffrements',
            delete_msg: 'Voulez vous supprimer ',
            headerTitle: {
              code: 'Code',
              encrypt_type: 'Type Chiffrement',
              start_date: 'Date Début',
              end_date: 'Date Echéance',
            },
          },
          fiche: {
            title: "Création d'un nouveau chiffrement",
            edit: 'Fiche du chiffrement {{code}}',
            code: 'Code',
            error: 'Erreur',
            error_msg: 'Champ obligatoire',
            type_chiffrement: 'Type Chiffrement',
            placeholder_type: '- Type -',
            extension: 'Extension GPG',
            cle_chiffrement: 'Key-ID GPG',
            pass_phrase: 'Passphrase GPG',
            type_naming: 'Type Nommage',
          },
          widget_chiffrement: {
            title: 'Echéances chiffrement GPG',
            table: {
              code: 'Code',
              date_start: 'Date Début',
              date_end: 'Date Echéance',
              groupe: 'Groupe',
            },
          },
        },
        fichiers_teletransmis: {
          modal: {
            title: {
              visualisation: 'Visualisation du fichier companion',
            },
            buttons: {
              close: 'Fermé',
            },
            columns: {
              tag: 'Balise',
              value: 'Valeur',
            },
          },
          table: {
            header: {
              title: 'Liste des fichiers télétransmis',
            },
            filters: {
              search: {
                place_holder: 'Rechercher un fichier par contenu ...',
              },
              flow: 'Flux',
            },
            columns: {
              flux: 'Flux',
              file_name: 'Nom de fichier',
              banque: 'Banque',
              file_format: 'Format du fichier',
              reference: 'Référence',
              date_transmission: 'Date de transmission',
              size: 'Taille',
            },
          },
        },
        post_traitement: {
          table: {
            header: {
              title: 'Liste des Post-Traitements',
            },
            columns: {
              code: 'Code',
              name: 'Nom',
              update_timestamp: 'Date de modification',
              posttraitement_action: 'Action',
            },
          },
          fiche: {
            title: {
              new_title: "Création d'un nouveau post-traitement",
              edit_title: 'Fiche du post-traitement {{code}}',
              ftp: 'Envoi FTP',
              file_import: 'Import fichiers',
              services: 'Services',
            },
            modal: {
              title: {
                services: 'Sélection de services',
                member: 'Sélection de membres',
                info: 'Liste des mot-clés',
              },
              information: {
                now: 'Date du jour format AAMMJJ',
                year: 'Année sur 2 caractères suivi du quantième',
                hour1: 'Heure au format HHMMSS',
                hour2: 'Heure au format HHMMSSCCC',
                bank_name: 'Nom de la banque',
                interface_code: "Code de l'interface",
                flux_code: 'Code du flux',
                fileformat: 'FileFormat du fichier reçu',
                filename: 'Nom du fichier reçu',
              },
            },
            buttons: {
              back: 'Annuler',
              save: 'Valider',
              add: 'Ajouter',
              close: 'Fermer',
            },
            placeholder: {
              naming: 'Nommage de fichier distant',
              connector: 'Connecteur',
              import_interface: "Interface d'import",
              record_size: 'Taille des enregitrements (cas des lignes fixes)',
            },
            champ_titles: {
              code: 'Code',
              name: 'Nom',
              file_format: 'FileFormat',
              retraitement: 'Retraitement',
              record_size: 'Taille des enregistrements',
              connector: 'Connecteur',
              naming: 'Nommage',
              import_interface: "Interface d'import",
              filter: 'Filtre',
              select: 'Séléction',
              noeud: 'Nœud XML',
              balise: 'Balise enregistrement fichier plat',
              position: 'Position information compte',
              longuer: 'Longueur information compte',
              member: 'Membres',
            },
            columns: {
              bank: 'Banque',
              flow: 'Flux',
              code: 'Code',
              name: 'Nom',
              file_format: 'FileFormat',
            },
          },
        },
        fraud_monitor: {
          table: {
            title: 'Liste des règles de Fraud Monitor',
            columns: {
              state: 'Etat',
              type: 'Type',
              code: 'Code',
              name: 'Nom',
              flow: 'Flux',
              update_timestamp: 'Date de modification',
            },
          },
          fiche: {
            title: {
              new_fraud_monitor:
                "Création d'une nouvelle règle de contrôle de Fraud Monitor",
              edit_fraud_monitor: 'Fiche du fraud monitor {{code}}',
              detail: 'Detail',
              filtre: 'Filtre',
            },
            buttons: {
              back: 'Annuler',
              save: 'Valider',
              add: 'Ajouter',
            },
            placeholder: {
              currency: 'Devise',
              country: 'Pays',
              flow: 'Selectioner un Flux',
              selectFiliale: 'Toutes les entités',
              selectSociete: 'Tous les sociétés',
              selectBanque: 'Tous les banques',
              selectFlux: 'Tous les flux',
              selectPays: 'Tous les pays',
              selectDevise: 'Toutes les devises',
            },
            champ_titles: {
              code: 'Code',
              name: 'Nom',
              flow: 'Flux',
              state: 'Etat',
              rule_type: 'Type de règle',
              period: 'Période en cours',
              approval: 'Approbation',
              filiale: 'Entité',
              societe: 'Societe',
              banque: 'Banque',
              pays: 'Pays',
              devise: 'Devise',
              origin: 'Origin',
              inclus: 'Inclus',
              exclus: 'Exclus',
              tiers_name: 'Nom Liste Tiers',
            },
          },
        },
        connector: {
          table: {
            title: 'Liste des connecteurs',
            services: 'Liste des services',
            columns: {
              code: 'Code',
              state: 'Etat',
              mode: 'Mode',
              name: 'Nom',
              partner: 'Partenaire',
              bank: 'Banque',
              type: 'Type',
              update_timestamp: 'Date de modification',
              planning_status: 'Etat planning',
              recurrency: 'Récurrence',
              frequence: 'Fréquence',
            },
            test_ftp: {
              test: 'Tester la connexion',
              path: 'Chemin',
            },
          },
          fiche: {
            title: {
              edit: 'Fiche du connecteur {{code}}',
              new: "Création d'un nouveau connecteur",
              services: 'Services',
              ebics: 'Ebics',
              ftp: 'FTP',
              swift_net: 'SwiftNet',
              bureau: 'Service Bureau',
              user_id: 'UserID',
              certificat: 'Certificats',
            },
            buttons: {
              add: 'Ajouter',
              validate: 'Valider',
              export: 'Exporter',
              import: 'Importer',
              close: 'Annuler',
              generate_SSH: 'Générer paire de clés SSH',
              migrate: 'Mapping BTF',
            },
            champ_titles: {
              state: 'Etat',
              code: 'Code',
              mode: 'Mode',
              name: 'Nom',
              proxy: 'Proxy',
              protocol: 'Protocole',
              partner: 'Partenaire',
              bank: 'Banque',
              subsidiary: 'Filiale (optionnel)',
              host_id: 'HostID',
              partner_id: 'PartnerID',
              order_id: 'OrderID',
              url: 'URL',
              urlauth: "URL d'authentification",
              version: 'Version',
              login: 'Login',
              password: 'Mot de passe',
              host: 'Hôte',
              ftp_protocole: 'Protocole',
              transmit: 'Emission',
              reception: 'Réception',
              emergency_host: 'Hôte de secours',
              port: 'Port',
              transfer_mode: 'Mode de transfert',
              encryption: 'Chiffrement FTP',
              component: 'Composant FTP',
              encryption_gpg: 'Chiffrement GPG Emission',
              encryption_gpg_reception: 'Chiffrement GPG Réception',
              responder_dn: 'Responder DN',
              responder_bic: 'Responder BIC',
              requestor_dn: 'Requestor DN',
              requestor_bic: 'Requestor BIC',
              service_name: 'Service Name',
              file_info: 'FileInfo',
              ack_responder: 'Ack Responder',
              compression: 'Compression',
              delivery_notification: 'Delivery Notification',
              connector: 'Connecteur',
              bulk_payment_pricing: 'Bulk Payment Pricing',
              bulk_paument_plafond: 'Bulk Payment Plafond',
              payload: 'Payload',
              payload_ext: 'Extension payload',
              passphrase_lau: 'Passphrase LAU',
              companion_file: 'Companion file',
              extension: 'Extension',
              authentification: 'Authentification',
              ssh_key: 'Clé SSH',
              api_method: 'Méthode API',
              api_body: 'Paramètre API',
              api_username: "Nom d'utilisateur",
              api_authorization_type: 'Autorisation',
              api_header: 'En-tête',
              domain: 'Domaine',
              grantype: 'Autorisation Grant Type',
              url_auth: "URL d'authentification",
              ssh_type: 'Type de clé SSH',
              AuthAPIType: 'Authentification Type',
              AuthAPIBody: 'Authentification Body',
            },
            columns: {
              flow: 'Flux',
              code: 'Code',
              name: 'Nom',
              electronic_signature: 'Signature électronique',
              file_format: 'FileFormat',
              file_type: 'FileType',
              beginning_hour: 'Heure début',
              end_time: 'Heure de fin',
              user_id: 'UserId',
              login: 'Login',
              alias: 'Alias',
              serial_number: 'N° série',
              expiration_date: 'Date Exp. AutoSignés',
              expiration_date_signature: 'Date Exp. Signature',
              ini: 'INI',
              hia: 'HIA',
              hpb: 'HPB',
            },
            placeholder: {
              encryption_none: 'Aucun chiffrement',
            },
            modal: {
              title: {
                newService: "Ajout d'un service",
                editService: "Modification d'un service",
                newUserId: "Ajout d'un UserID",
                editUserId: "Modification d'un UserID",
                newCertificat: "Ajout d'un Certificat",
                editCertificat: "Modification d'un Certificat",
                loading: 'chargement...',
                import: 'Importation de certificats',
                gestionEbics: 'Gestion Ebics',
              },
              tabs: {
                general: 'Général',
                planning: 'Planification',
                immediate_execution: 'Exécution immédiate',
              },
              buttons: {
                certificateBackup: 'Récupération du certificat SConnect',
              },
              champ_titles: {
                flow: 'Flux',
                code: 'Code',
                name: 'Nom',
                electronic_signature: 'Signature électronique',
                file_format: 'FileFormat / Request Type',
                messaging: 'Messagerie',
                file_type: 'FileType',
                FileLogicalName: 'File Logical Name',
                meaning: 'Sens',
                user_id: 'UserId',
                login: 'Login',
                certificate: 'Certificat',
                certificate_base_64: 'Certificat Base 64',
                password: 'Mot de passe des certificats importés',
                certificateA: 'Certificat A00',
                certificateE: 'Certificat E00',
                certificateX: 'Certificat X00',
                planning_status: 'Etat de la planification',
                beginning_hour: 'Heure de début',
                end_time: 'Heure de fin',
                recurring: 'Récurrent',
                frequency: 'Fréquence (min)',
                ebics_msg_namevalue: 'Message Name Value',
                ebics_service_container: 'Service container',
                ebics_service_name: 'Service Name',
                ebics_service_option: 'Service Option',
                ebics_service_scope: 'Service Scope',
                ebics_msg_name_variant: 'Message Name Variant',
                ebics_msg_name_version: 'Message Name Version',
                ebics_format: 'Format',
                beginning_date: 'Date début',
                end_date: 'Date fin',
              },
              columns: {
                CERT: 'Génération des certificats auto-signés',
                HEV: 'Récupération de la version du serveur Ebics',
                INI: 'Envoi de la clé de signature A00',
                HIA: "Envoi des clés de chiffrement et d'authentification",
                Impression: "Impression des lettres d'initialisation Ebics",
                HPB: "Récupération des certificats de chiffrement et d'authentification du partenaire",
                HCA: 'Renouvellement Certificats Autosignés',
                HCS: 'Renouvellement Certificats Autosignés et Certificats clé',
              },
              HCS: {
                next: 'Suivant',
                previous: 'Précédent',
                step: 'Etape',
                wait: 'Renouvellement des certificats en cours ...',
                nextStep:
                  'Maintenant insérez votre ancienne clé et tapez votre mot de passe puis cliquez sur Suivant pour continuer.',
                step1: {
                  txt1: "Vous etes sur le point de renouvellement vos certificats auto-signés. Vous devez le faire trois mois avant la date l'échéance des certificats.",
                  txt2: "Attention ! Toutes les banques ne gèrent pas ce mode de renouvellement. Si c'est le cas, vous devez réinitialiser les certificats manuellement.",
                  txt3: 'Insérez votre nouvelle clé puis cliquez sur Suivant pour continuer',
                },
              },
            },
          },
        },
      },
      interfaces: {
        imports: {
          table: {
            title: "Liste des interfaces d'import",
            title_modal_import: "Ajout interface d'export",
            message_modal_confirm:
              'Le flux existe déjà. Voulez-vous modifier les éléments de ce flux ',
            columns: {
              state: 'Etat',
              code: 'Code',
              name: 'Nom',
              type: 'Type',
              flow: 'Flux',
              format: 'Format',
              import_type: "Type d'import",
              entity_selection: 'Sélection entité',
              updated_date: 'Date de modification',
            },
          },
          fiche: {
            title: {
              edit_import: "Fiche de l'interface d'import {{code}}",
              new_import: "Création d'une nouvelle interface d'import",
              entity_list: 'Liste des entités',
              general: 'Général',
            },
            buttons: {
              back: 'Annuler',
              save: 'Valider',
              add: 'Ajouter',
              close: 'Fermer',
            },
            modal: {
              title: "Sélection d'entités",
            },
            champ_titles: {
              code: 'Code',
              description: 'Description',
              type: 'Type',
              flow: 'Flux',
              import_type: 'Type import',
              state: 'Etat',
              file_format: 'Format de fichier',
              encryption: 'Chiffrement',
              entity_selection: 'Sélection entité',
              no_encryption: 'Aucun chiffrement',
              email_rules: "Emails d'erreur",
              duplicate: 'Contrôle de doublons',
            },
            columns: {
              state: 'Etat',
              code: 'Code',
              name: 'Name',
            },
          },
          detail: {
            table: {
              title: "Liste des enregistrements de l'interface",
              buttons: {
                back: 'Retour',
              },
              columns: {
                database_field: 'Champ database',
                registration: 'Enregistrement',
                heading: 'Rubrique',
                default_value: 'Valeur par défaut',
                method: 'Méthode',
                update_timestamp: 'Date de modification',
              },
            },
            fiche: {
              title: {
                edit: "Fiche de l'enregistrement",
                new: "Création d'un nouvel enregistrement",
              },
              champ_titles: {
                database_field: 'Champ database',
                heading: 'Rubrique',
                method: 'Méthode',
                correspondence: 'Correspondance',
                default_value: 'Valeur par défaut',
                order: 'Ordre',
              },
              buttons: {
                back: 'Annuler',
                save: 'Valider',
              },
            },
          },
        },
        exports: {
          table: {
            title: "Liste des interfaces d'export",
            title_modal_import: "Ajout interface d'export",
            message_modal_confirm:
              ' L’interface export existe déjà. Voulez-vous modifier les éléments de cette interface',
            columns: {
              code: 'Code',
              name: 'Nom',
              format: 'Format',
              updated_date: 'Date de modification',
            },
          },
          fiche: {
            title: {
              edit_export: "Fiche de l'interface d'export {{code}}",
              new_export: "Création d'une nouvelle interface d'export",
            },
            buttons: {
              back: 'Annuler',
              save: 'Valider',
            },
            champ_titles: {
              code: 'Code',
              description: 'Description',
              type: 'Type',
              file_format: 'Format de fichier',
              formatting: 'Mise en forme',
            },
          },
          detail: {
            table: {
              title: "Liste des enregistrements de l'interface",
              buttons: {
                back: 'Retour',
              },
              columns: {
                database_field: 'Champ database',
                registration: 'Enregistrement',
                heading: 'Rubrique',
                default_value: 'Valeur par défaut',
                method: 'Méthode',
                update_timestamp: 'Date de modification',
                comment: 'Commentaire',
              },
            },
            fiche: {
              title: {
                edit: "Fiche de l'enregistrement",
                new: "Création d'un nouvel enregistrement",
              },
              champ_titles: {
                database_field: 'Champ database',
                heading: 'Rubrique',
                method: 'Méthode',
                correspondence: 'Correspondance',
                default_value: 'Valeur par défaut',
                order: 'Ordre',
              },
              buttons: {
                back: 'Annuler',
                save: 'Valider',
              },
            },
          },
          detailIsPdf: {
            table: {
              title: "Création d'un nouvel enregistrement",
              buttons: {
                back: 'Retour',
              },
              columns: {
                champs: 'Champ',
                heading: 'Rubrique',
                database: 'Database',
                chp_dtb1: 'Champ 1',
                chp_dtb2: 'Champ 2',
                chp_dtb3: 'Champ 3',
                chp_dtb4: 'Champ 4',
                chp_dtb5: 'Champ 5',
                chp_dtb6: 'Champ 6',
                chp_dtb7: 'Champ 7',
                chp_dtb8: 'Champ 8',
                method: 'Méthode',
                mask: 'Masque',
                mise_en_page: 'Surcharge de la mise en page',
                polise: 'Police',
                taille: 'Taille',
                alignement: 'Alignement',
                gras: 'Gras',
                soulign: 'Souligné',
              },
            },
          },
        },
        formats: {
          table: {
            title: 'Liste des formats de fichiers',
            columns: {
              code: 'Code',
              name: 'Nom',
              type: 'Type',
              updated_date: 'Date de modification',
              length: 'Longueur enr.',
              separator: 'Séparateur',
              comment: 'Commentaire',
            },
            buttons: {
              import: 'Importer',
            },
            modal: {
              title: "Importation d'un format",
              champ_titles: {
                upload: 'Upload',
              },
            },
          },
          fiche: {
            title: {
              edit_format: 'Fiche du format {{code}}',
              new_format: "Création d'un nouveau format",
            },
            buttons: {
              back: 'Annuler',
              save: 'Valider',
            },
            champ_titles: {
              code: 'Code',
              name: 'Nom',
              type: 'Type',
              length: 'Longueur enr.',
              separator: 'Séparateur',
              header: 'Avec Entête',
              multi: 'Multi-Chèques par page',
              offset: 'Offset',
            },
          },
          detail: {
            table: {
              title: 'Liste des enregistrements du format',
              buttons: {
                back: 'Retour',
              },
              columns: {
                order: 'Ordre',
                code: 'Code',
                type: 'Type',
                update_timestamp: 'Date de modification',
                length: 'Longueur enr.',
                separator: 'Séparateur',
              },
            },
            fiche: {
              title: {
                edit: "Fiche de l'enregistrement {{code}}",
                new: "Création d'un nouvel enregistrement",
              },
              champ_titles: {
                code: 'Code',
                type: 'Type',
                order: 'Ordre',
              },
              buttons: {
                back: 'Annuler',
                save: 'Valider',
              },
            },
          },
          heading: {
            table: {
              title: 'Liste des champs',
              buttons: {
                back: 'Retour',
              },
              columns: {
                order: 'Ordre',
                label: 'Libellé',
                type: 'Type',
                position: 'Position',
                length: 'Longueur',
                update_timestamp: 'Date de modification',
              },
            },
            fiche: {
              title: {
                edit: "Fiche de l'enregistrement",
                new: "Création d'un nouvel enregistrement",
                propriety: 'Propriétés',
                visu_export_comptable:
                  'Affichage pour visualisation Export Comptable',
              },
              champ_titles: {
                label: 'Libellé',
                type: 'Type',
                order: 'Ordre',
                mask: 'Masque',
                separator: 'Séparateur',
                line_if_item: 'Ligne si rubrique',
                position: 'Position {{cord}}',
                length: 'Longueur',
                height: 'Hauteur',
                thickness: 'Épaisseur',
                visible: 'Visible Affichage',
                field_length: 'Longueur Affichage',
              },
              buttons: {
                back: 'Annuler',
                save: 'Valider',
              },
            },
          },
        },
        import_rule: {
          table: {
            header: {
              title: "Liste des règles d'import",
            },
            modal: {
              remove: {
                title: "Voulez-vous vraiment supprimer cette règle d'import",
              },
            },
            columns: {
              state: 'Etat',
              connector: 'Connecteur',
              partner: 'Partenaire',
              import_interface: "Interface d'import",
              format: 'Format',
              condition: 'Condition',
              extension: 'Extension',
              directory: 'Repertoire',
            },
          },
          fiche: {
            title: {
              create_import_rule: "Création de nouvelles règle d'import",
              edit_import_rule: "Modification des règle d'import",
              conditions: 'Conditions',
            },
            champ_titles: {
              state: 'Etat',
              connector: 'Connecteur ERP',
              import_interface: "Interface d'import",
              type: 'Type',
              treatment_after_import: 'Traitement après import',
              file_name: 'Nom du fichier',
              directory: 'Répertoire',
              extension: 'Extension du fichier',
            },
            buttons: {
              back: 'Annuler',
              save: 'Valider',
            },
          },
        },
        export_rule: {
          table: {
            header: {
              title: "Liste des règles d'export",
            },
            modal: {
              remove: {
                title: "Voulez-vous vraiment supprimer cette règle d'export",
              },
            },
            columns: {
              state: 'Etat',
              rule_code: 'Code Règle',
              rule_name: 'Nom Règle',
              method: 'Méthode',
              periodicity: 'Périodicité',
              launch_time: 'Heure Lancement',
              last_launch: 'Dernier Lancement',
              file_name: 'Nom Fichier',
              update_timestamp: 'Date de modification',
              extension: 'Extension',
              directory: 'Repertoire',
            },
          },
          fiche: {
            title: {
              create_export_rule: "Création de nouvelles règle d'Export",
              edit_export_rule: "Modification des règle d'export {{code}}",
              conditions: 'Conditions',
              request_content: 'Contenu Requête',
            },
            champ_titles: {
              state: 'Etat',
              rule_code: 'Code  Règle',
              rule_name: 'Nom Règle',
              method: 'Méthode',
              periodicity: 'Périodicité',
              end_point: 'End Point',
              type: 'Type',
              file_name: 'Nom du fichier',
              directory: 'Répertoire',
              extension: 'Extension du fichier',
            },
            buttons: {
              back: 'Annuler',
              save: 'Valider',
            },
          },
        },
        flux: {
          table: {
            title: 'Liste des flux',
            title_modal_confirm: 'Ajout des flux',
            list_missing_champ: 'Champs manquants : ',
            headerTitle: {
              code: 'Code',
              nom: 'Nom',
              type: 'Type',
              support: 'Support',
              process_signature: 'Process de signature',
              confidential: 'Confidentialité',
              interface_export: "Interface d'export",
              date: 'Date de modification',
            },
          },
          fiche: {
            title: "Création d'un nouveau flux",
            code: 'Code',
            nom: 'Nom',
            type: 'Type',
            support: 'Support',
            creation_title_fiche: "Creation d'un nouveau flux",
            edit_tile_fiche: 'Fiche du flux {{code}}',
            flow_code_placeholder: 'Code du Flux',
            flow_nom_placeholder: 'Nom du Flux',
            sous_type: 'Sous-type',
            methodeAttribution: "Méthode d'attribution des valideurs",
            typeDoc_compte: 'Type de document compte',
            typeDoc_societe: 'Type de document société',
            caracteristique: {
              title: 'Caractéristiques',
              flux_confidentiel: 'Flux confidentiel',
              process_signature: 'Process signature',
              interface_export: "Interface d'export par défaut",
              methode_attribution: "Méthode d'attribution des signataires",
              controle_mandat: 'Contrôle Mandat',
              control_date: 'Gestion de date',
              autorisation: 'Autorisation Split du lot',
              type_doc: 'Type de document',
            },
            masque_saisie: {
              title: 'Masques saisie',
              coordonne_bank: 'Coordonnées bancaires',
              bank_intermediaire: 'Banque intermédiaire',
              type_dest: 'Type destinataire',
              saisie_liste: 'Saisie par liste',
            },
            tresorerie: {
              title: 'Trésorerie',
              prevision_emmet: 'Prévision Emetteur',
              prevision_tiers: 'Prévision Tiers',
              type_prev: 'Type de prévision',
              nature_tiers: 'Nature tiers',
              nature_emmet: 'Nature émetteur',
              categ_tiers: 'Catégorie tiers',
              categ_emmet: 'Catégorie émetteur',
              exonere: 'Virement Trésorerie',
              title_code_cature: 'Sélection du code nature',
              title_categorie: 'Sélection du catégorie',
              add: 'Ajouter',
              annuler: 'Annuler',
            },
            pays_emmet: {
              title: 'Pays émetteurs autorisés',
            },
            pays_dest: {
              title: 'Pays destinataires autorisés',
            },
            authorized_currencies: {
              title: 'Devises autorisées',
            },
            authorized_bank: {
              title: 'Banques autorisées',
            },
            interface_export: {
              title: "Interfaces d'export spécifiques par banque",
              title_Modal: "Sélection de l'interface d'export par banque",
              add: 'Ajouter',
              annuler: 'Annuler',
              bank: 'Banque',
              interf_exp: "Interface d'export",
              headerTable: {
                code: 'Code',
                interface_export: "Interface d'export",
              },
            },
            mask: {
              title_mask_remise: 'Masques remises',
              title_mask_operation: 'Masques opérations',
              title_mask_compta: 'Masques comptes comptables',
              headerTable: {
                name: 'Nom du champ',
                interface_export: "Interface d'export",
                type_champ: 'Type de champ',
                libelle: 'Libellé',
                visible: 'Visible',
                obligatoire: 'Obligatoire',
                edit: 'Modifiable en saisie',
                taille_saisie: 'Taille de saisie',
              },
              title_Modal: 'Masque de saisie',
              add: 'Ajouter',
              annuler: 'Annuler',
              name_champ: 'Nom du champ',
              maskTitle: 'Masque',
            },
            modalSetting: {
              title: 'Paramétrage',
              seuil: 'Seuil de génération',
              seuilPlaceholder:
                "Nombre d'opération au delà duquel la génération sera effectuée à l'import du fichier",
              mailBox: 'MailBox',
              flux_post: 'Flux Post Génération',
              demate_connector: 'Connecteur Demat',
              demate_connector2: 'Connecteur Demat 2',
              accepts_operation_zero: 'Autoriser montant zéro en saisie',
              control_adress_tiers: 'Contrôle Adresse Tiers en saisie',
              add_mvt: 'Ajout mouvements dans CC',
              mail_box_edit_date: 'Autorisation modification date',
              CheminDateModif: 'Chemin modification date',
            },
          },
        },
      },
      customisation: {
        listes: {
          table: {
            title: 'Liste déroulante',
            columns: {
              code: 'Code',
              name: 'Nom',
            },
          },
          fiche: {
            title: {
              edit_liste: 'Fiche de la liste {{ code }}',
              new_liste: "Création d'une nouvelle liste",
            },
            buttons: {
              back: 'Annuler',
              save: 'Valider',
            },
            champ_titles: {
              code: 'Code',
              name: 'Nom',
            },
          },
          detail: {
            table: {
              title: 'Liste des valeurs de la liste déroulante {{list_code}}',
              buttons: {
                back: 'Retour',
              },
              columns: {
                code: 'Code',
                label: 'Libellé',
              },
            },
            fiche: {
              title: {
                edit: 'Fiche du champ {{value}}',
                new: "Création d'un champ de la liste",
              },
              champ_titles: {
                value: 'Valeur',
              },
              buttons: {
                back: 'Annuler',
                save: 'Sauvegarder',
              },
            },
          },
        },
        accounting_field: {
          table: {
            title: 'Liste des customisations comptables',
            columns: {
              label: 'Libellé',
              name: 'Nom du champs',
              visible: 'Visible',
              obligatory: 'Obligatoire',
              entered_size: 'Taille de saisie',
            },
          },
          modal: {
            remove: {
              title: 'Voulez-vous vraiment supprimer ce champ',
            },
          },
          fiche: {
            title: {
              edit: 'Fiche du champ',
              new: "Création d'une nouvelle zone comptable",
            },
            buttons: {
              back: 'Annuler',
              save: 'Valider',
            },
            champ_titles: {
              mask: 'Masque',
              name: 'Nom du champs',
            },
          },
        },
        dynamic_method: {
          table: {
            title: 'Liste des méthodes dynamiques',
            title_drawer: 'Liste des interfaces',
            import_rules: 'Import',
            export_rules: 'Export',
            picto_name: 'Liaison',
            columns: {
              code: 'Code',
              name: 'Nom',
              state: 'Etat',
              update_timestamp: 'Date de modification',
            },
          },
          fiche: {
            title: {
              edit: 'Fiche de la méthode dynamique {{code}}',
              new: "Création d'une nouvelle méthode dynamique",
            },
            buttons: {
              back: 'Annuler',
              save: 'Valider',
            },
            champ_titles: {
              state: 'Etat',
              code: 'Code',
              name: 'Nom',
              syntax: 'Syntaxe',
              dynamic_code: 'Code dynamique',
              keywords: 'Mots clés',
            },
          },
        },
        fiche: {
          title: {
            edit_title: "Modification d'un fiche custom",
            view_title: 'Fiche du tiers custom',
            new_title: "Création d'un fiche custom",
            cut_off: 'Cut-Off',
          },
          buttons: {
            back: 'Annuler',
            save: 'Valider',
            create: 'Valider',
            add: 'Ajouter',
          },
          champ_titles: {
            champnom: 'Nom du champ',
            pays: 'Pays',
            masque: 'Masque',
            type_custom: 'Type de champ',
            custom_filtre: 'Custom Filtre dans Fiche en valeur',
          },
        },
        table: {
          header: {
            title: 'Liste des customisations tiers',
            new_custom: 'Nouveau',
          },
          columns: {
            name: 'Nom du champ',
            libelle: 'Libellé',
            pays: 'Pays',
            isvisible: 'Visible',
            isobligatoire: 'Obligatoire',
            taille: 'Taille de saisie',
          },
        },
        correspondance: {
          table: {
            title: 'Liste des tables de correspondance',
            title_import_correspondance: 'Ajout des correspondances',
            columns: {
              code: 'Code',
              nom: 'Nom',
            },
          },
          fiche: {
            title: {
              edit: 'Fiche de la table de correspondance {{code}}',
              new: "Création d'une table de correspondance",
            },
            champ_titles: {
              code: 'Code',
              name: 'Name',
            },
          },
          fiche_champs: {
            title: {
              edit: 'Fiche de la table de correspondance {{entry_val}}',
              new: "Création d'un détail de correspondance",
            },
            champ_titles: {
              disloq_value: "Valeur d'entrée",
              out_value: 'Valeur de sortie',
              french: 'Français',
              english: 'Anglais',
            },
          },
          table_champs: {
            title: {
              edit: 'Liste des valeurs de la table de correspondance {{entry_val}}',
              new: "Création d'un détail de correspondance",
            },
            champ_titles: {
              id: 'Id',
              entry_code: 'Code entrée',
              out_code: 'Code sortie',
              libelle: 'Libellé',
            },
          },
        },
        email_template: {
          table: {
            title: 'Liste des modèles',
            columns: {
              name: 'Nom',
              object: 'Objet',
              type: 'Type',
              update_timestamp: 'Date de modification',
            },
          },
          fiche: {
            title: {
              edit: 'Fiche du modèle {{code}}',
              new: "Création d'un modèle de notification",
              body: 'Corps du modèle',
            },
            champ_titles: {
              model_name: 'Nom du modèle',
              model_object: 'Objet du modèle',
              webhook_url: 'URL Webhook',
              notification_type: 'Type de notification',
              template_type: 'Type de template',
            },
          },
        },
        email_rule: {
          table: {
            title: 'Liste des règles de notifications',
            columns: {
              name: 'Nom',
              code: 'Code',
              flow: 'Flux',
              update_timestamp: 'Date de modification',
            },
          },
          fiche: {
            title: {
              edit: 'Modification des règles de notifications: {{code}}',
              new: 'Création de nouvelles règles de notifications',
              conditions: 'Conditions',
              smartags: 'Destinataires',
            },
            buttons: {
              back: 'Annuler',
              save: 'Valider',
            },
            champ_titles: {
              code: 'Code',
              name: 'Nom',
              flow: 'Flux',
              template: 'Template',
              batch_state: 'Etat lot',
              condition: 'Condition',
              value: 'Valeur',
              emails: 'Adresses emails',
              smartags_users: 'Smart Tags utilisateurs',
              email: "Langue d'envoi sur les emails saisis",
              smartags_grp_users: "Smart Tags groupe d'utilisateurs",
              smartags_grp_admins: "Smart Tags groupe d'administrateurs",
            },
          },
        },
        email_report_rule: {
          table: {
            title: 'Liste des tâches programmées',
            titleModal: 'Liste des valeurs',
            execute_imediat: 'Exécution immédiate',
            columns: {
              name: 'Nom',
              code: 'Code',
              heure: 'Heure de lancement',
              update_timestamp: 'Date de modification',
              type: 'Type',
              mode_envoi: 'Mode envoi',
            },
            columnsMember: {
              name: 'Nom',
              code: 'Code',
            },
          },
          fiche: {
            title: {
              edit: "Modification d'une tâche programmée : {{code}}",
              new: "Création d'une tâche programmée ",
              conditions: 'Conditions',
              smartags: 'Email',
              state: 'Tâches',
              connecteur: 'Connecteur',
              list_valeur: 'Liste des valeurs',
              titleModal_currency: 'Liste des devises',
            },
            buttons: {
              back: 'Annuler',
              save: 'Valider',
            },
            champ_titles: {
              code: 'Code',
              name: 'Nom',
              flow: 'Flux',
              template: 'Template',
              type_export: 'Type',
              placeholder_type: "- Type d'export -",
              type: 'Type',
              condition: 'Condition',
              day: 'Jours',
              treso: 'Etat trésorerie',
              interf: 'Interface',
              emails: 'Adresses emails',
              smartags_users: 'Smart Tags utilisateurs',
              email: "Langue d'envoi sur les emails saisis",
              utilisateur: 'Utilisateurs',
              smartags_grp_admins: "Smart Tags groupe d'administrateurs",
              mond: 'Lundi',
              tues: 'Mardi',
              wed: 'Mercredi',
              thur: 'Jeudi',
              fri: 'Vendredi',
              sat: 'Samedi',
              sund: 'Dimanche',
              user_reference: 'Langue',
              reference_user: 'Utilisateur réfèrent',
              heure_lance: 'Heure Lancement',
              mode_env: "Mode d'envoi",
              date: 'Date',
              user: 'Utilisateur Référent',
              last_month: 'Mois précédent',
            },
          },
        },
        custom_fields: {
          table: {
            title: 'Liste des masques de champs',
            columns: {
              code: 'Code',
              label: 'Libellé',
              liste: 'Liste',
              visible: 'Visible',
              obligatory: 'Obligatoire',
              entered_size: 'Taille de saisie',
            },
          },
          buttons: {
            new: 'Nouveau Lot',
            delete: 'Confirmez-vous la suppression',
          },
          fiche: {
            save: 'Valider',
            create: 'Valider',
            creation_title: "Création d'un nouveau masque de champ",
            edit: 'Fiche du masque de champ {{code}}',
            forme: {
              code: 'Code',
              code_label: 'Code du masque du champ',
              visible: 'Visible',
              size_forme: 'Taille de saisie',
              size_forme_label: 'Taille de saisie du champ',
              list: 'Liste',
              fr: 'Français',
              fr_label: 'Libellé du champ de saisie',
              fr_label_txt:
                "Texte d'indication du champ de la langue ci-dessus",
              type_champ: 'Type de champ',
              obligatoire: 'Obligatoire',
              edit_saisie: 'Modifiable en saisie',
              masque: 'Masque de saisie',
              en: 'English',
              el_placeholder: 'Libellé du champ de saisie',
              en_label: "Texte d'indication du champ de la langue ci-dessus",
              fr_trad: 'Français',
              en_trad: 'English',
              es_trad: 'Español',
            },
          },
        },
      },
      audit: {
        gdpr: {
          title: 'GDPR',
          journaux: 'Journaux',
          search_tiers: 'Recherche Tiers',
          search_flux: 'Recherche Flux',
          title_tiers: 'Tiers',
          title_flux: 'Liste des Flux',
          alert_title:
            'Attention ! Ce traitement est irréversible. Le tiers et tous ces flux seront anonymisés. Désirez-vous continuer',
          anonym: 'Anonymisation',
          placeholder: {
            search: "Recherche d'un tiers par code, nom, IBAN",
          },
          column_tiers: {
            type: 'Type',
            code: 'Code',
            name: 'Nom',
            num_compte: 'N° de compte',
            devise: 'Devise',
            pays: 'Pays',
            date_modif: 'Date de modification',
          },
          column_flux: {
            num_lot: 'N° lot',
            num_remise: 'N° remise',
            flux: 'Flux',
            libele: 'Libellé',
            date_operation: "Date d'opération",
            state: 'Etat',
            beneficiary_name: 'Bénéficiaire',
            date_transmission: 'Date Transmission',
          },
        },
        auditConnexion: {
          table: {
            header: {
              title: 'Audit de connexion',
            },
            columns: {
              login: 'Login-Code API',
              date: 'Date',
              auth: 'Authentification',
              ipadresse: 'Adresse IP',
              platform: 'Plateforme',
              os: 'OS',
              navigator: 'Type navigateur',
              version: 'Version',
            },
          },
        },
        auditService: {
          table: {
            header: {
              title: 'Audit des services',
            },
            columns: {
              service: 'Services',
              state: 'Status',
              date: 'Date',
              libel: 'Libellé',
            },
          },
        },
        hashFile: {
          table: {
            header: {
              title: 'Fichiers importés',
            },
            confirm_to_delete:
              "Etes-vous sûr de vouloir supprimer ce Hash ? Attention, l'action sera irréversible",
            columns: {
              state: 'Status',
              file_name: 'Nom du fichier',
              value_hash: 'Hash',
              date: 'Date',
              type_file: 'Type de fichier',
              user: 'User Création',
              user_update: 'User Modification',
              date_update: 'Date de modification',
            },
          },
        },
        histoApi: {
          table: {
            header: {
              title: 'Appel API',
              modal_title: 'Visualisation du json',
            },
            columns: {
              key: 'Clé',
              method_name: 'Méthode',
              date: 'Date',
              code_retour: 'Code Retour HTTP',
              label_retour: 'Libellé Retour',
              param_appel: 'Paramètre Appel',
              body_retour: 'Body Retour',
              duree_appel: 'Durée Appel',
            },
            modal: {
              balise: 'Balise',
              value: 'Valeur',
            },
          },
        },
        histoFile: {
          table: {
            header: {
              title: 'Ordonnancement des opérations',
            },
            columns: {
              file_name: 'Nom fichier',
              code_compte: 'Code compte',
              code_society: 'Code société',
              code_flux: 'Code flux',
              amount_total: 'Montant total',
              nb_flux: 'Nombre flux',
              date_create: 'Date création lot',
              num_lot: 'N° Lot',
              user: 'User',
              currency: 'Devise',
              placeholder_flux: '- Flux -',
              placeholder_type_flux: '- Type flux -',
              state_detail: 'Etat détail',
            },
          },
        },
        trustedThird: {
          table: {
            header: {
              title: 'Liste des tiers de confiance',
            },
            columns: {
              currency: 'Devise',
              name: 'Nom',
              iban: 'IBAN',
              uptade_date: 'Date de modification',
            },
            modal_detail: {
              title: 'Détail de tiers de confiance',
              desactive_btn: 'Désactiver',
              message_confirm: 'Voulez-vous desactiver ce tiers',
              culumn: {
                average_amount: 'Montant moyen',
                sum_amount: 'Somme des montants',
                total_amount: 'Montant total',
                month_year: 'Année Mois',
                nb_operation: "Nombre d'opérations",
                amount_max: 'Montant maximum',
              },
            },
          },
        },
      },
      parametrage: {
        Categories: {
          fiche: {
            title: {
              edit_title: 'Fiche de la catégorie',
              view_title: 'Fiche de la catégorie {{code}}',
              new_title: "Création d'une nouvelle catégorie",
              operations: 'Liste des codes opérations liés',
              flows: 'Liste des flux bancaires liés',
            },
            buttons: {
              back: 'Annuler',
              save: 'Valider',
              new: 'Nouveau',
              create: 'Créer',
              movement: 'Mise à jour des Mouvements',
            },
            champ_titles: {
              code: 'Code',
              direction: 'Sens',
              libelle: 'Libellé',
              default_category: 'Categorie Défaut',
            },
            modal: {
              update:
                'Voulez-vous appliquer la catégorie aux mouvements des codes opérations sélectionnés',
              title: 'Sélection des codes opérations',
              flow_title: 'Sélection des codes flux',
              filters: {
                type: 'Type',
              },
            },
          },
          table: {
            header: {
              title: 'Liste des catégories',
              new_category: 'Nouveau',
            },
            columns: {
              code: 'Code',
              libelle: 'Libellé',
              date: 'Date de modification',
              default_category: 'Categorie Défaut',
            },
          },
        },
        GlobalUser: {
          table: {
            error_mes: {
              text: 'Le nombre de users actifs autorisés est atteint.',
            },
            header: {
              title: 'Liste des utilisateurs groupes',
              synthese: 'Synthèse droit utilisateur',
              new: 'Nouveau',
            },
            columns: {
              login: 'Login',
              first_name: 'Prénom',
              last_name: 'Nom',
              email: 'Email',
              mobile_number: 'N° mobile',
              date: 'Date de modification',
              interrupteur: 'TOTP',
              totp: 'Type TOTP',
              is_locked: 'Bloqué',
            },
          },
          fiche: {
            title: {
              edit_title: 'Fiche utilisateur {{name}}',
              add_title: "Création d'un nouvel utilisateur",
              message_confirm_initialise:
                'Voulez-vous réinitialiser les paramètres TOTP de ce user',
            },
            champ_titles: {
              etat: 'Etat',
              email: 'Email',
              login: 'Login',
              firstname: 'Prénom',
              lastname: 'Nom',
              langue: 'Langue',
              tel: 'Téléphone',
              fax: 'Fax',
              mobile: 'Mobile',
              recepemail: 'Mail de reception',
            },
            group_user: {
              title: 'Groupes utilisateurs',
              name: 'Nom',
              code: 'Code',
              action: 'Action',
            },
            alert: {
              pdf_file: 'Veuillez importer un file en format pdf',
              file_import: 'Importation file en format pdf obligatoire',
            },
            appareil_connected: {
              title: 'Appareils connectés',
              name: 'Nom',
              date1: 'Date création',
              date2: 'Dérniere connexion',
              action: 'Action',
            },
            document: {
              title: 'Documents',
              date: 'Date',
              doc_name: 'Nom document',
              doc_type: 'Type document',
              state: 'Etat',
              date1: 'Date début',
              date2: 'Date fin',
              action: 'Action',
              confirm_delete:
                'Ce document est lié à plusieurs messages envoyés aux banques. Etes-vous sûr de vouloir supprimer le document',
            },
            errors: {
              phoneNumber:
                'Le numéro de téléphone ne doit contenir que des chiffres',
              phoneMinLen:
                'Le numéro de téléphone doit comporter au moins 10 chiffres',
              phoneMaxLen:
                'Le numéro de téléphone doit comporter au maximum 15 chiffres',
              faxError: 'Fax invalide',
              mobilError: 'Mobile invalide',
            },
          },
        },
        GroupAdmin: {
          fiche: {
            title: {
              edit_title: "Fiche du groupe d'administrateurs {{name}}",
              view_title: "Fiche du groupe d'administrateurs {{name}}",
              new_title: "Création d'un nouveau groupe d'administrateurs",
              member: 'Membres',
              autorisation: 'Autorisations',
              headerTitle: 'Fiche groupe administrateurs',
              createheaderTitle: "Création d'un nouveau groupe",
            },
            buttons: {
              back: 'Annuler',
              save: 'Valider',
              new: 'Nouveau',
              add: 'Ajouter',
            },
            champ_titles: {
              code: 'Code',
              name: 'Nom',
              state: 'Etat',
              prenom: 'Prénom',
              login: 'Login',
              flux: 'Flux',
              releve: 'Relevés',
              referentiel: 'Référentiel',
              settings: 'Paramétrage',
              treatment: 'Traitements',
              accounting: 'Comptabilité',
              accounting_export: 'Export comptable',
              smart_tags: 'Smart Tags',
            },
          },
          table: {
            header: {
              title: "Liste des groupes d'administrateurs",
              new_groupadmin: 'Nouveau',
            },
            columns: {
              nom: 'Nom',
              date: 'Date de modification',
              state: 'Etat',
              code: 'Code',
            },
          },
        },
        Label: {
          fiche: {
            title: {
              edit_title: 'Fiche du label {{label}}',
              view_title: 'Fiche du label {{label}}',
              new_title: "Création d'un nouveau label",
            },
            buttons: {
              back: 'Annuler',
              save: 'Valider',
              create: 'Créer',
            },
            champ_titles: {
              libelle: 'Libellé personnalisé',
              libelle_origine: "Libellé d'origine",
              rubrique_value: 'Valeur rubrique',
              sheet: 'Fiche',
              rubrique: 'Rubrique',
              color: 'Couleur',
              add_fiche: 'Ajouter Fiche',
              add_rubrique: 'Ajouter Rubrique',
              add_color: 'Ajouter Couleur',
            },
            error: {
              err_message: 'Erreur',
              field_message: 'Champ requis',
            },
          },
          table: {
            header: {
              title: 'Liste des labels',
              new_label: 'Nouveau',
            },
            columns: {
              label: 'Label',
              date: 'Date de modification',
              rubrique_value: 'Valeur rubrique',
              sheet: 'Fiche',
            },
          },
        },
        Perimetre: {
          fiche: {
            title: {
              edit_title: 'Fiche du périmètre {{name}}',
              view_title: 'Fiche du périmètre {{name}}',
              new_title: "Création d'un nouveau périmètre",
              member: 'Membre',
              autorisation: 'Autorisation',
              entities_list: 'Liste des entités',
            },
            buttons: {
              back: 'Annuler',
              save: 'Valider',
              new: 'Nouveau',
              create: 'Créer',
            },
            champ_titles: {
              code: 'Code',
              name: 'Nom',
              state: 'Etat',
              prenom: 'Prénom',
              login: 'Login',
              flux: 'Flux',
              releve: 'Relevés',
              referentiel: 'Référentiel',
              settings: 'Paramétrage',
              treatment: 'Traitements',
              accounting: 'Comptabilité',
              accounting_export: 'Export comptable',
            },
          },
          table: {
            header: {
              title: 'Liste des périmètres',
              new_perimetre: 'Nouveau',
            },
            columns: {
              label: 'Libellé',
              date: 'Date de modification',
              state: 'Etat',
              code: 'Code',
              first_name: 'Prénom',
            },
          },
        },
        Banques: {
          fiche: {
            title: {
              edit_title: 'Fiche de la banque {{name}}',
              view_title: 'Fiche de la banque',
              new_title: "Création d'une nouvelle banque",
              cut_off: 'Cut-Off',
              added_cutoff_title: "Ajout d'un Cut- off",
              creation_title_banque: "Creation d'une nouvelle banque",
              edit_tile_banque: 'Fiche du compte {{name}}',
              tarif: 'Tarif',
              tarif_modal: 'Sélectionner un tarif',
              add_tarif_title: " Ajout d'un Tarif",
              category: 'Catégorie',
              code: 'Code',
              placeholder_category: '- Catégorie -',
              message_category: 'Catégorie déjà existé',
            },
            buttons: {
              back: 'Annuler',
              save: 'Valider',
              create: 'Créer',
              add: 'Ajouter',
            },
            champ_titles: {
              code: 'Code',
              name: 'Nom',
              flux: 'Flux',
              hour: 'Heure',
              exec_condition: 'Condition Exécution',
              mounthly_fees: 'Tarif mensuel',
              annual_fees: 'Tarif annuel',
              month_annual_fees: 'Mois de frais annuel',
              movement_commission: 'Commission de mouvement',
              bank_fees_type: 'Type Frais bancaire',
              type: 'Type',
            },
            columns: {
              condition: 'Condition Exécution',
              hour: 'Heure',
              flow: 'Flux',
              code: 'Code',
              label: 'Libellé',
              tarif: 'Tarif',
              mois: 'Mois',
              currency: 'Devise',
            },
            columns_contact: {
              title: 'Contacts',
              name: 'Nom',
              last_name: 'Prénom',
              phone: 'Téléphone',
              mail: 'Email',
              adress: 'Adresse',
              agence: 'Agence',
              flux: 'Flux',
              pouvoir: 'Pouvoir',
              agenceName: 'Nom Agence',
            },
          },
          infos_personalise: {
            title: 'Informations personnelles ',
            birth_date: 'Date de naissance',
            birth_country: 'Pays de naissance',
            birth_place: 'Lieu de naissance',
            nationality: 'Nationalité',
            num_cin: 'Numéro CIN',
            date_validate_cin: 'Date validation CIN',
          },
          table: {
            header: {
              title: 'Liste des banques',
              new_bank: 'Nouveau',
              el_authorized: '(Nombre autorisé : {{nombre}})',
              message_ele_atteint:
                'Le nombre maximum de banques autorisé est atteint',
              el_authorized_treso:
                '(Nombre de comptes gérés en trésorerie: {{nombre}})',
              message_ele_treso:
                ' Le nombre maximum de comptes gérés en trésorerie est atteint',
            },
            columns: {
              name: 'Nom',
              code: 'Code',
            },
          },
          contact: {
            title: "Création d'un nouvel contact",
            title_edit: "Fiche d'un contact",
            last_name: 'Prénom',
            name: 'Nom',
            name_agence: 'Nom agence',
            title_civil: 'Civilité',
            mail: 'Email',
            phone: 'Téléphone',
            fax: 'Fax',
            mobile: 'Mobile',
            contact_agence: 'Contact agence',
            contact_Flux: 'Contact Flux',
            contact_pouvoir: 'Contact Pouvoir ',
            title_adress: 'Adresse',
            type_aress: 'Type adresse',
            department: 'Service',
            Sub_Departement: 'Sous-Service',
            street_name: 'Nom de la voie',
            build_number: ' Numéro de voie',
            floor: 'Etage',
            post_box: ' Boîte postale',
            room: 'Salle',
            town_location_name: 'Lieu-Dit',
            post_code: 'Code postal',
            town_name: 'Ville',
            country: 'Pays',
            districtName: ' District',
            districk_name: 'Nom du district',
            country_Sub_Division: 'Région',
            civility: 'Civilité',
            error_champ_obligatoire:
              'Veuillez compléter les champs obligatoires : Nom, Prénom, Civilité, Pays, et Ville .',
            error_champ_ville_obligatoire: 'Nom de la ville obligatoire',
          },
        },
        Filiales: {
          fiche: {
            title: {
              edit_title: 'Fiche de la filiale {{code}}',
              new_title: "Création d'une nouvelle entité",
            },
            buttons: {
              back: 'Annuler',
              save: 'Valider',
              create: 'Créer',
            },
            champ_titles: {
              code: 'Code',
              name: 'Nom',
              state: 'Etat',
            },
          },
          table: {
            header: {
              title: 'Liste des entités',
              new_filiale: 'Nouveau',
            },
            columns: {
              code: 'Code',
              state: 'Etat',
              libelle: 'Libellé',
              date: 'Date de modification',
            },
          },
        },
        smarttag: {
          fiche: {
            title: {
              edit_title: "Modification d'un smart tag",
              view_title: 'Fiche du smart tag {{code}}',
              new_title: 'Fiche du smart tag',
              add_title: "Creation d'un nouveau smart tag",
            },
            buttons: {
              back: 'Annuler',
              save: 'Valider',
              create: 'Créer',
              add: 'Ajouter',
            },
            champ_titles: {
              champcode: 'Code',
              color: 'Couleur',
            },
          },
          table: {
            header: {
              title: 'Liste des SmartTags',
              new_smart: 'Nouveau',
            },
            columns: {
              code: 'Code',
            },
          },
        },
        groupe_tresorerie: {
          fiche: {
            title: {
              edit_title: 'Fiche du groupe trésorerie {{name}}',
              view_title: 'Fiche du groupe trésorerie {{name}}',
              new_title: "Creation d'un nouveau groupe trésorerie",
              companies_member_list: 'Liste des sociétés membres',
              member_list: 'Membre',
            },
            modal: {
              user_list: "Sélection d'utilisateurs",
              company_list: 'Sélection de sociétés',
              account_list: 'Sélection de comptes',
              third_party_group_list: 'Sélection de groupe de tiers',
            },
          },
          table: {
            title: 'Liste des groupes de trésoriers',
          },
        },
        account_statement: {
          table: {
            select_cat: 'Sélection des codes opérations',
            category_code: 'Code Catégorie',
            title: 'Administration des relevés de compte',
            etat: '- Etat -',
            confirme_update_row: 'Voulez-vous valider votre modification',
            search_txt:
              'Rechercher un compte par code, nom, numéro de compte, code société, nom société...',
            headerTitle: {
              etat: 'Etat',
              code: 'Code',
              name: 'Nom',
              iban: 'IBAN',
              company: 'Société',
              solde: 'Solde',
              devise: 'Devise',
              date_solde: 'Date de solde',
              nbMvt: 'Nb mouvements',
            },
          },
          details: {
            title: 'Liste des journées du compte',
            reintegration: 'Réintégration des relevés',
            delete_temp: 'Supprimer les relevés temporaires',
            purge: 'Purge complète des relevés du compte',
            all: 'Tout',
            production: 'Production',
            temp: 'Temporaire',
            new_day: 'Nouvelle Journée',
            delete_day: 'Supprimer la journée',
            headerTitle: {
              date_debut: 'Date de début',
              solde_debut: 'Solde de début',
              date_fin: 'Date de fin',
              solde_fin: 'Solde de fin',
              prod: 'Prod',
              last_releve: 'Dernier relevé intégré',
              statements: 'Nb mouvements',
              currency: 'Devise',
              balance_diff: 'Différence solde',
              mvt_total: 'Somme des opérations',
              update_timestamp: 'Date Modification',
              create_timestamp: 'Date Création',
            },
            confirmNewday: {
              title: 'Fiche relevé',
              txt: 'Vous ne pouvez créer des journées que avant ou après les relevés déjà en production Que désirez-vous créer ?',
              before: 'Avant le',
              after: 'Après le',
              cancel: 'Annuler',
            },
          },
          new_day_time: {
            alert_date:
              'La date initiale doit être inférieure à la date finale',
            valider: 'Valider',
            cancel: 'Annuler',
            solde_initial: 'Solde initial',
            date_initial: 'Date initiale',
            solde_final: 'Solde finale',
            date_final: 'Date finale',
            remove_day_time: 'Etes-vous sûr de vouloir supprimer',
            add_operation: "Ajouter une ligne d'opération",
            purge_account:
              'Etes-vous sûr de vouloir purger les relevés de compte de production de ce compte',
            remove_temp:
              'Etes-vous sûr de vouloir purger les relevés de compte temporaire de ce compte',
            headerTitle: {
              libeller: 'Libellé',
              operation_date: 'Date Opération',
              date_valeur: 'Date Valeur',
              operation_code: 'Code Opération',
              num_ecriture: 'N Ecriture',
              exo: 'Exo',
              montant: 'Montant',
            },
            modalCode: {
              title: 'Sélection des codes opérations',
              select: 'Sélectionner',
              cancel: 'Annuler',
              headerTitle: {
                code: 'Code',
                name: 'Nom',
                sens: 'Sens',
              },
            },
          },
          modal_add_balance: {
            title: 'Initialisation balance',
            date_initiale: 'Date initiale',
            solde_initial_balance: 'Solde initiale',
          },
        },
        rules_account_statement: {
          table: {
            title: 'Liste des Règles relevés',
            columns: {
              code: 'Code',
              name: 'Nom',
              flow: 'Flux',
              category: 'Catégorie',
              type: 'Type',
              update_timestamp: 'Date de modification',
              state: 'Etat',
            },
          },
          fiche: {
            new_title: 'Fiche de la règle relevé',
            edit_title: ' Fiche de la règle relevé - {{name}}',
            company_liste: 'Liste des sociétés',
            bank_title: 'Liste des banques',
            account_groupe_title: 'Liste des groupes de comptes',
            card: {
              state: 'Etat',
              code: 'Code',
              name: 'Nom',
              category: 'Catégorie',
              type: 'Type',
              selection: 'Sélection',
              comment: 'Déscription',
              language: 'Langue',
            },
            critere: {
              title: 'Critères recherche ',
              category: 'Catégorie',
              label: 'Libellé',
              fourchette_amount: 'Fourchette montant',
              min: 'Min',
              max: 'Max',
              reference: 'IDBénéficiaire',
              rum: 'RUM',
              inclus_ref: 'Inclus de la liste',
              exclus_ref: 'Exclus de la liste',
              yes: 'Oui',
              no: 'Non',
              inclus: 'Inclus',
              exclus: 'Exclus',
              integrate: 'Intégrer',
              columns_reference: {
                reference: 'IDBénéficiaire',
                description: 'Description',
                date: 'Date',
                user: 'User',
              },
              modal_reference: {
                add_ref: "Ajout d'une Référence",
                reference: 'Référence',
                description: 'Description',
              },
              columns_rum: {
                rum: 'RUM',
                description: 'Description',
                date: 'Date',
                user: 'User',
              },
              modal_rum: {
                add_rum: 'Ajout RUM',
                rum: 'RUM',
                description: 'Description',
              },
            },
            ventilation: {
              title: 'Ventilation',
              categorie_ventilation: 'Catégorie de ventilation',
            },
            columns: {
              code: 'Code',
              name: 'Nom',
            },
          },
        },
        custom_report: {
          fiche: {
            comment: 'Commentaire',
            date: 'Date',
          },
          table: {
            title: 'Liste des commentaires',
            create_comment: 'Création  de commentaire',
            update_comment: 'Modification  de commentaire',
            columns: {
              comment: 'Commentaire',
              user: 'Utilisateur',
              date: 'Date',
              update_timestamp: 'Date de modification',
            },
          },
        },
        document_type: {
          fiche: {
            title: {
              new_title: "Création d'un nouveau type de document",
              edit_title: 'Fiche du type de document {{name}}',
            },
            champ_titles: {
              name: 'Nom',
              code: 'Code',
              table_type: 'Type de table',
            },
            table_type: 'Table',
          },
          table: {
            title: 'Liste des types de documents',
            columns: {
              code: 'Code type',
              name: 'Nom type',
              table_type: 'Type table',
            },
          },
        },
        group_widget: {
          fiche: {
            title: {
              edit_title: 'Fiche du widget group  {{code}}',
              view_title: 'Fiche du widget group',
              new_title: 'Fiche du smart tag',
              add_title: "Creation d'un nouveau widget group",
            },
            champ_titles: {
              code: 'Code',
              name: 'Nom',
              user: 'Sélection utilisateurs',
            },
          },
          table: {
            header: {
              title: 'Liste des Widgets Groupes',
            },
          },
          table_user: {
            title: 'Liste des utilisateurs',
            champ_titles: {
              champlogin: 'Login',
              champname: 'Nom',
            },
          },
          table_widget: {
            title: 'Liste des widgets',
            champ_titles: {
              champcode: 'Code',
              champname: 'Nom',
            },
          },
          modal_widget: {
            title: 'Liste des utilisateurs',
            champ_titles: {
              champlogin: 'Login',
              champname: 'Nom',
            },
          },
        },
        settings: {
          fiche: {
            title: {
              foureyes_title: 'Paramétrage4 Yeux',
              foureyes_description:
                'Paramétrage du module 4 Yeux (Tables, Champs, Historisation)',
              group_setting_title: 'Paramétrage groupe',
              group_description: 'Paramétrage groupe',
              mobile_setting_title: 'Liste des comptes membres',
              mobile_description: 'Paramétrage des authentifications groupe',
              signature_setting_title: 'Paramétrage Signature',
              signature_description: 'Paramétrage de la signature EBICS',
            },
            champ_titles_fouryeux: {
              table_name: 'Nom table',
            },
            champ_titles_group: {
              logo: 'Logo',
              session: 'Maintenir session active',
              currency: 'Devise',
              code_swift: 'Code swift',
              ai_choice: 'Choix AI',
              number_ai_calls: 'Appel AI effectué',
              paid_ai_calls: 'Appel AI autorisé',
              title_card: 'Paramétrage AI',
            },
            champ_titles_mobile: {
              mobile: 'Mobile',
              authentication_token_validity:
                "Validité token d'authentification",
              signature_token_validity: 'Validité token de signature',
              webservice_restAPI_key: 'Clé API Webservice REST',
              state: 'Etat',
              code: 'Code',
              clientid: 'ClientID',
              modified_date: 'Date de modification',
            },
            champ_titles_iban: {
              ibanCom: 'IBAN.COM',
              state: 'Etat',
              email: 'Adresse',
              client: 'API Key',
            },
            champ_titles_security: {
              title_button_active_transaction: 'Activer Transaction',
              local_authentication: 'Authentification locale',
              state: 'Etat',
              sisid: 'SIS ID',
              complex: 'Complexe',
              minimum_length: 'Longueur minimale',
              minimum_length_description: 'Longueur minimale  du mot de passe',
              validity_period: 'Durée de validité',
              validity_period_description: 'Durée de validité du mot de passe',
              stored_number: 'Nombre mémorisés',
              stored_number_description: 'Nombre de mots de passe mémorisés',
              test_number: "Nombre d'essais (0-pas de blocage)",
              test_number_description:
                "Nombre d'essais de mots de passe avant blocage",
              linkedin_authentication: 'Authentification linkedin',
              openidconnect: 'Authentification OpenIDConnect',
              identifier:
                'Identifiant fourni dans la console développeur de LinkedIn',
              secret_code:
                'Code secret fourni dans la console développeur de LinkedIn',
              urlauth_description:
                'URLAuth fourni dans la console développeur LinkedIn',
              urltoken_description:
                'URLToken fourni dans la console développeur LinkedIn',
              urlconfig_Allowed_Domain:
                'Liste des noms de domaines autorisés (séparés par des points-virgules)',
              Label_urlconfig_Allowed_Domain: 'Noms de domaines autorisés',
              urlconfig_description: 'URL de configuration OpenIDConnect',
              attributupn: "Attribut contenat l'UPN",
              number_requested_batch: 'Nombre de mots de passe mémorisés',
              last_date: 'Date dernière transaction',
              docusign: 'Signature électronique document',
              legisway: 'Legisway',
              trustpair: 'Trustpair',
            },
            champ_titles_signature: {
              signature_mode: 'Mode de signature',
            },
            modalkeysapi: {
              title: "Ajout d'une clé API",
              state: 'Etat',
              code: 'Code',
              clientid: 'ClientID',
              clientid_description: "Identifiant de l'application cliente",
              clientsecret: 'ClientSecret',
              clientsecret_description:
                'Code secret fourni dans la console ADFS',
              attribut_upn: 'Attribut UPN',
              scope: 'Scope',
              third: 'Tiers',
              treasury: 'Trésorerie',
              import_file: 'Import de fichiers',
              number_requested_batch: 'Nb demandes par batch',
              service: 'Service',
            },
            doc_sign: {
              integration_key: "Clé d'intégration",
              secret_key: 'Clé secrète',
              userId: 'ID utilisateur',
              private_key: 'Clé privée',
              integration_key_desc:
                "Clé d'intégration fournie par la plateforme de signature électronique",
              secret_key_desc:
                'Clé secrète fournie par la plateforme de signature électronique',
              userId_desc:
                'ID utilisateur fourni par la plateforme de signature électronique',
            },
            trustpair: {
              api_token: "Clé d'API",
              api_env: 'Environnement',
              api_type: "Type d'API",
            },
            common_fields: {
              initialisation_date: 'Date initialisation transaction',
              oneshot: 'Execution unique',
              launch_job: 'Lancer Transaction',
            },
          },
          table: {
            title: 'Configuration générale',
            columns: {
              elements: 'éléments',
              foureyes_setup: 'Paramétrage4 Yeux',
              group_setting: 'Paramétrage groupe',
              mobile_setting: 'Paramétrage mobile',
              security_settings: 'Paramétrage sécurité',
              signature: 'Signature',
              search: 'Rechercher une section, un libellé...',
            },
          },
        },
        bank_holiday: {
          title: {
            list_title: 'Liste de dates fériées',
            edit_title: 'Modification de la date fériée {{code}}',
            view_title: 'Fiche de la date fériée {{code}}',
            new_title: "Creation d'une nouvelle date fériée",
          },
          champ_titles: {
            date: 'Date fériée',
            specific_date: 'Jour férié pour une année spécifique',
          },
        },
        quality: {
          title: {
            list_title: 'Liste qualité',
            edit_title: "Modification d'une qualité {{code}}",
            view_title: "Fiche d'une qualité {{code}}",
            new_title: "Creation d'une nouvelle qualité",
            fiche_title: "Fiche d'une qualité",
          },
          champ_document: {
            title: 'Liste des libellés',
            label: 'Libellé',
            langue: 'Langue',
          },
          modal_add_langue: {
            title_add: "Ajout d'un libellé",
            title_edit: "Fiche d'un libellé",
            error_English: 'Langue Anglais déjà ajouté',
            error_Fr: 'Langue Français déjà ajouté',
            error_Lang: 'Langue déjà existe',
          },
        },
        power_ebam: {
          table: {
            title: 'Liste des Descriptions de pouvoirs',
            column: {},
          },
          fiche: {
            title: "Création d'un nouveau pouvoir eBAM",
            title_edit: "Modification d'un pouvoir eBAM {{name}}",
            table_ebam: {
              column: {
                title: 'Codes eBAM',
                code: 'Code',
                num_code: 'Code eBAM',
                description: 'Description',
                title_modal: 'Sélectionner un code eBAM',
                label_lang: 'Langue',
                description_attach: 'Description du code famille',
                descri: '',
              },
            },
          },
        },
        ebam: {
          liste: 'Liste des Code eBAM',
          fiche: {
            title: 'Fiche du Code eBAM',
            type: 'Type',
            codeNum: 'Code Numérique',
            code: 'Code',
            titleRegroupment: 'Regroupement',
            regroupement: 'Regroupement',
            titleLabelListe: 'Liste des Libellés',
          },
        },
      },
    },
    treasury: {
      remuneration: {
        personnalise_rates_ref: {
          table: {
            title: 'Liste des taux de référence personnalisés',
            personnalise_rates_button: 'Taux personnalisés',
            title_modal_rate: 'Liste des cours',
            message_confirm:
              'La date existe déjà dans le tableau,voulez-vous continuer',
            columns: {
              plancher: 'Plancher',
              name: 'Nom',
              plancher_rates: 'Taux Plancher',
              plafond_rates: 'Taux Plafond',
              plafond: 'Plafond',
            },
            modal: {
              date: 'Date de mise à jour',
              name: 'Nom',
              cours: 'Cours',
              confirmMessage:
                ' Voulez-vous mettre à jour les cours à la date {{date}}. \n Toutes les lignes qui ont une valeur sont soit  créées soit mise à jour',
            },
          },
          fiche: {
            edit_title: 'Fiche du taux de référence personnalisé {{name}}',
            new_title: "Création d'un nouveau taux de référence personnalisé",
            champ_titles: {
              debut_date: 'Date de début',
              finish_date: 'Date de fin',
              rate_type: 'Type de taux',
              value: 'Valeur',
              taux_value: 'Taux Valeur',
              condition: 'Condition Fixing',
              plancher_rates_floor: 'Taux plancher - Floor',
              plafond_rates_cap: 'Taux plafond - Cap',
              plancher_rates: 'Taux Plancher',
              plafond_rates: 'Taux Plafond',
              name: 'Nom',
            },
          },
          cours: {
            title: 'Cours du taux {{name}}',
            titleDrawer: 'Liste',
            visu: 'Contrôle des cours',
            columns: {
              update_timestamp: 'Date de modification',
              rate: 'Cours',
            },
            columnsDrawer: {
              date: 'Date',
              error: 'Erreur',
              aucunErreur: "Aucune erreur n'a été trouvée",
            },
            button: {
              update: 'Mise à jour',
              verify: 'Contrôle des taux ',
            },
            modal: {
              start_date: 'Date de début',
              end_date: 'Date de fin',
              rate: 'Cours',
              title: "Ajout d'un cours",
              update: "Mise à jour d'un cours",
            },
          },
        },
        personnalise_rates: {
          table: {
            title: 'Liste des taux personnalisés',
            button_charg_rate: 'Chargement Cours',
            columns: {
              name: 'Nom',
              rates: 'Taux directeur',
              rate_marge: 'Taux/Marge',
              base_calcul: 'Base Calcul',
              rate_type: 'Type Taux',
              conv: 'Convention',
            },
          },
          fiche: {
            edit_title: 'Fiche du taux personnalisé {{name}}',
            new_title: "Création d'un nouveau taux personnalisé",
            champ_titles: {
              base_calcul: 'Base Calcul',
              conv: 'Convention',
              type: 'Type',
              rate_value: 'Valeur Taux',
              rate_marge: 'Taux/Marge',
              comment: 'Commentaire',
              plancher_rates_floor: 'Taux plancher - Floor',
              plafond_rates_cap: 'Taux plafond - Cap',
              plancher_rates: 'Taux Plancher',
              plafond_rates: 'Taux Plafond',
              name: 'Nom',
              value_floor_rate: 'Taux personnalisé plafond',
              value_rate_cap: 'Taux personnalisé plancher',
            },
            cap_floor_area: 'Cap et Floor sur Taux + Marge',
          },
        },
      },
      quotidienne: {
        forecast: {
          fiche: {
            titles: {
              edit_title: 'Fiche de la prévision {{code}}',
              new_title: "Création d'une nouvelle prévision",
              view_title: 'Fiche du format {{code}}',
              general: 'Général',
              characteristics: 'Caractéristiques',
              date_management: 'Gestion date',
            },
            buttons: {
              back: 'Annuler',
              save: 'Valider',
              create: 'Créer',
              reconciliation: 'Rapprochement',
              realization: 'Forcer la réalisation',
            },
            champ_titles: {
              account: 'Compte',
              label: 'Libellé',
              nature: 'Nature',
              amount: 'Montant {{type}}',
              op_date: 'Date opération',
              value_date: 'Date valeur',
              category: 'Catégorie',
              num_entry: 'Num. Ecriture',
              exo: 'Exonéré de commission de mouvement',
              type: 'Type',
              state: 'Etat',
              first_due: 'Première écheance',
              last_due: 'Dernière échéance',
              next_due: 'Date prochaine échéance',
              sequence: 'Périodicité',
              in_progress: 'Nb de prévisions en cours',
              change: 'débit ou crédit',
            },
            realization: {
              title: 'Fiche Prévision',
              message:
                'Etes-vous sûr de vouloir forcer la réalisation de la prévision',
            },
            rapprochement: {
              title: 'Rapprochement de trésorerie',
            },
            modal: {
              title: 'Rapprochement de trésorerie',
              rappro_prev: 'Prévisions rapprochées',
              rappro_mvt: 'Mouvements rapprochés',
              num_mvt: 'Nombre de mouvements',
              num_prev: 'Nombre de prévisions',
              amount_mvt: 'Montant des mouvements',
              amount_prev: 'Montant des prévisions',
              user: 'Utilisateur',
              date: 'Date',
              number: 'N° de rapprochement',
              title_user: 'Audit',
              creation_date: 'Date Création',
              user_creation: 'User Création',
              date_modification: 'Date Modification',
              user_modification: 'User Modifcation',
              columns: {
                label: 'Libellé',
                ref: 'Référence',
                category: 'Catégorie',
                ope_code: 'Code Opé',
                ope_date: 'Date Opé',
                value_date: 'Date valuer',
                amount: 'Montant',
                curr: 'Dev',
                exo: 'Exo',
                nature: 'Nature',
                entry_number: 'Num Ecriture',
              },
            },
          },
          table: {
            header: {
              title: 'Liste des prévisions',
              mass_update: 'Modification masse',
              prev_generation: 'Générer Prev. temporaire',
              prev_auto: 'Prévision automatique',
              import: 'Importer',
              more_action: 'Autre',
              generation: 'Génération des intradays',
              generation_title: 'Liste des intradays',
              generation_btn: 'Génération des prévisions',
            },
            columns: {
              state: 'Etat',
              account: 'Compte',
              label: 'Libelle',
              num_entries: 'N Ecriture',
              nature: 'Nature',
              category: 'Catégorie',
              exo: 'Exo',
              op_date: "Date d'opération",
              value_date: 'Date de valeur',
              amount: 'Montant',
              currency: 'Devise',
              type: 'Type',
              origin: 'Origine',
              user: 'User',
              update: 'Date de modification',
              creation: 'Création',
              ref: 'Référence',
              id_source: 'ID Fichier Source',
            },
            mass_update: {
              title: 'Modification en masse des prévisions',
              nature: 'Nature',
              type: 'Type',
              value_date: 'Date valeur',
              t2a: 'Passer les prévisions temporaires en active',
              d2a: 'Passer les prévisions supprimées en active',
              all2d: 'Passer les prévisions en état supprimée',
              j1_update: 'Modifier Valeur J+1',
              update: 'Valider',
              close: 'Annuler',
              category: 'Catégory',
            },
            import: {
              title: 'Import des prévisions',
              model: "Modèle d'import",
            },
          },
          automatic: {
            table: {
              header: {
                title: 'Liste des prévisions auto',
                new: 'Nouveau',
              },
              filters: {
                state: '-Etat-',
              },
              columns: {
                state: 'Etat',
                account: 'Code compte',
                label: 'Libellé',
                num_entries: 'N Ecriture',
                nature: 'Nature',
                category: 'Catégorie',
                exo: 'Exo',
                start_date: 'Date début',
                end_date: 'Date fin',
                next_due_date: 'Date échéance',
                amount: 'Montant',
                currency: 'Devise',
                type: 'Type',
                num_forecast: 'N° prévisions en cours',
                user: 'Utilisateur',
                update: 'Modification',
              },
            },
            fiche: {
              titles: {
                edit_title: 'Fiche prévision auto {{code}}',
                new_title: "Création d'une nouvelle prévision auto",
              },
              buttons: {
                generate: 'Générer les prévisions',
              },
              generation: {
                title: 'Génération prévisions',
                message: 'Voulez-vous Régénérer des prévisions',
              },
            },
          },
          temporary_prev_generation: {
            titles: {
              main_title: 'Gestion des prévisions temporaires',
              temporary_forecast: 'Prévisions temporaires',
              forecast_to_keep: 'Prévisions à garder',
              active_forecast: 'Prévisions actives',
              edit_modal: 'Modification Prévisions à garder',
            },
            champ_titles: {
              type: 'Type',
              value_date: 'Date Valeur',
              label: 'Libelle',
            },
            buttons: {
              generate: 'Générer',
            },
            modal: {
              title: 'Liste des prévisions',
              message:
                "Voulez-vous passer en actif toutes les prévisions temporaires n'ayant pas de prévisions actives comparables",
            },
          },
        },
        cashpooling: {
          title: {
            general: 'Cashpooling',
            position_value: 'Positions en Valeur',
            flow_proposal: 'Propositions de flux de trésorerie',
            remove: 'Voulez-vous supprimer le flux',
          },
          select_grp_compte_cashpooling: 'Groupe de compte de cash-pooling',
          select_grp_compte_parametrage: 'Groupe de compte de paramétrage',
          flow_list_placeholder: '-Flux trésorerie par défaut-',
          buttons: {
            validate: 'Valider les propositions',
            new: 'Nouveau',
          },
          columns: {
            account: 'Compte',
            balance: 'Solde Avant',
            balance_after: 'Solde Après',
            value_date: 'Date',
            authorized: 'Autorisé',
            currency: 'Devise',
            date: 'Date',
            amount: 'Montant',
            credit_account: 'Compte crédité',
            debit_account: 'Compte débité',
          },
          modal: {
            title: {
              new_flow: "Création d'un nouveau flux de trésorerie",
              edit_flow: "Modification d'un flux de trésorerie",
            },
            buttons: {
              add: 'Valider',
              close: 'Annuler',
            },
            placeholder: {
              nature: '- Nature -',
              label: 'Libellé automatique si vide',
            },
            champ_titles: {
              debit_account: 'Compte débité',
              credit_account: 'Compte crédité',
              label: 'Libellé',
              current_account: 'Compte courant',
              debit_nature: 'Nature Débit',
              credit_nature: 'Nature Crédit',
              amount: 'Montant',
              value_date: 'Date Valeur',
              error_devise_compte:
                'Veillez selectionner les comptes de mêmes devise.',
            },
          },
        },
        historique: {
          title: {
            general: 'Historique de rapprochement de Trésorerie',
            bank_mvt: 'Mouvements bancaire rapprochés',
            prov: 'Prévisions rapprochées',
            detail_mvt: 'Rapprochement - Detail',
          },
          buttons: {
            show_details: 'Visualisation Détail',
            show_sessions: 'Visualisation Session',
          },
          filters: {
            account: 'Compte',
            rappro_date: 'Date Rapprochement',
            value_date: 'Date Valeur',
            group: 'Groupe',
          },
          columns: {
            account: 'Compte',
            category: 'Cat.',
            date: 'Date Val.',
            label: 'Libellé',
            amount: 'Montant',
          },
          alert: {
            rappro_session: "il n'y a pas de dérapprochement à réaliser",
          },
          modal: {
            title: {
              session_list: 'Liste des sessions',
            },
            columns: {
              date_num: 'Date/Num',
              user: 'User',
              value_date_movement: 'Date Mvt',
              value_date_prev: 'Date Prev',
              category: 'Cat.',
              nature: 'Nature',
              label: 'Libellé',
              amount: 'Montant',
              number: 'Nb',
              nb_mvt: 'Nb mouvement',
              nb_prevision: 'Nb prévision',
            },
            groups: {
              mvts: 'Mouvements à rapprocher',
              prevs: 'Prévisions à rapprocher',
            },
            buttons: {
              visualize: 'Visualiser',
              dereconciliation: 'Derapprocher',
            },
          },
        },
        research: {
          table: {
            header: {
              title: 'Liste des recherches',
              load_search: 'Lancer la recherche',
            },
            filters: {
              account_group: 'Groupes de comptes',
              account: 'Comptes',
              amount_min: 'De',
              amount_max: 'A',
            },
            columns: {
              state: 'Etat',
              account: 'Compte',
              label: 'Libelle',
              reference: 'Référence',
              nature: 'Nature',
              category: 'Catégorie',
              op_date: 'Date opé.',
              value_date: 'Date Valeur',
              amount: 'Montant',
              currency: 'Devise',
              type: 'Type',
              entry_number: 'Num Ecriture',
              nature_code: 'Code Nature',
              integration_date: "Date d'intégration",
            },
            ventilation: {
              title: 'Ventilation',
              nature: 'Nature',
              label: 'Libelle',
              amount: 'Montant',
              total: 'Total',
              gap: 'Ecart',
            },
            mass_update: {
              title: 'Modification en masse',
              message:
                'Souhaitez-vous modifier le code nature et/ou la catégorie des éléments sélectionnés ?',
            },
            visualisation: {
              headers: {
                detail: "Détail de l'opération",
                treasury_rappro: 'Rapprochement trésorerie',
                accounting_rappro: 'Rapprochement comptable',
              },
              columns: {
                compte: 'Compte',
              },
            },
          },
        },
        ventilation: {
          title: {
            general: 'Ventilation de Trésorerie',
          },
          buttons: {
            show_ventilate_manual: 'Ventilation Manuelle',
            show_ventilate_automatic: 'Ventilation Règles',
          },
          columns: {
            account: 'Compte',
            category: 'Catégorie',
            date: 'Date Valeur',
            label: 'Libellé',
            amount: 'Montant',
            compte: 'Compte',
            devise: 'Devise',
          },
          modal: {
            title: {
              general: 'Mouvements à ventiler',
              ventilate: '- Nature -',
              error_nature_not_selected: 'Veuillez choisir un code nature',
            },
            columns: {
              value_date_movement: 'Date Mvt',
              category: 'Cat.',
              nature: 'Nature',
              label: 'Libellé',
              amount: 'Montant',
              number: 'Nb',
            },
            buttons: {
              ventilate: 'Ventiler',
            },
          },
        },
        value: {
          title: {
            general: 'Visualisation de la fiche en valeur',
            state_items: 'Liste des états',
            unfold_nodes: 'Déplier tous les noeuds',
            search_items: 'Recherche',
          },
          buttons: {
            sheet_in_value: 'Fiche en Valeur',
          },
          columns: {
            groups: '-Groupes-',
            company: '- Société -',
            bank: '- Banque -',
            currency: '- Devise -',
            country: '- Pays -',
            state: '-Etats-',
          },
          modal: {
            title: {
              value_sheet: 'Fiche Valeur',
              details: 'Détail de la journée',
            },
            footer: {
              debit: 'Total débit',
              credit: 'Total crédit',
              daily: 'Total journée',
            },
          },
        },
        reconciliation: {
          headers: {
            title: 'Rapprochement de trésorerie',
            details: 'Rapprochement de trésorerie - Détail',
            accounts: 'Comptes',
            viewType: 'Vue',
          },
          inputs: {
            total_movements: 'Total Mouvements',
            gap: 'Ecart',
            total_forecasts: 'Total Prévisions',
            number: 'Nb',
            confirmTxt: 'Un écart existe. Validez-vous le rapprochement',
            confirmTitle: 'Rapprochement',
          },
          cards: {
            movements: 'Mouvements bancaires à rapprocher',
            rappro: 'Rapprochement',
            forecasts: 'Prévisions à rapprocher',
          },
          buttons: {
            manual: 'Lancer règles manuelles',
            next_account: 'Compte suivant',
            montant: 'Montant 1/1',
            montantNN: 'Montant N/N',
            reconcile: 'Rapprocher',
          },
          columns: {
            selected: 'Sel.',
            category: 'Catégorie',
            value_date: 'Date valeur',
            label: 'Libellé',
            amount: 'Montant',
            account: 'Compte',
            state: 'Etat',
            balanced: 'Equilibré',
            unbalanced: 'Non équilibré',
          },
          message: {
            all_treated: 'Tous les comptes ont été traités',
          },
        },
      },
      reporting: {
        analyse: {
          title: 'Analyse des codes natures et catégories',
          filters: {
            groups: 'Groupes',
          },
          buttons: {
            validate: 'Afficher',
          },
          columns: {
            year: 'Année',
            january: 'Janvier',
            february: 'Février',
            march: 'Mars',
            april: 'Avril',
            may: 'Mai',
            june: 'Juin',
            july: 'Juillet',
            august: 'Août',
            september: 'Septembre',
            october: 'Octobre',
            november: 'Novembre',
            december: 'Décembre',
          },
        },
        analyseSolde: {
          title: 'Analyse des Soldes',
          filters: {
            groups: 'Groupes',
            company: 'Sociétés',
            year: 'Années',
          },
          buttons: {
            validate: 'Afficher',
          },
          column: {
            societe: 'Sociétés',
            january: 'Janvier',
            february: 'Février',
            march: 'Mars',
            april: 'Avril',
            may: 'Mai',
            june: 'Juin',
            july: 'Juillet',
            august: 'Août',
            september: 'Septembre',
            october: 'Octobre',
            november: 'Novembre',
            december: 'Décembre',
          },
        },
      },
      settings: {
        natural_code: {
          table: {
            title: 'Liste des codes Nature',
            btn_grp_account: 'Groupe de codes nature',
            columns: {
              code: 'Code',
              name: 'Nom',
              exo: 'Exo',
              sense: 'Sens',
              category: 'Catégorie',
              update_timestamp: 'Date Modification',
            },
          },
          fiche: {
            title: {
              edit_title: 'Fiche du Code Nature {{code}}',
              new_title: "Création d'un nouveau Code Nature",
              organization: 'Organisation',
            },
            champ_titles: {
              type: 'Type',
              code: 'Code',
              name: 'Nom',
              sense: 'Sens',
              level: 'Niveau',
              grouping: 'Regroupement',
              order: 'ordre',
              category: 'Catégorie',
              exo: 'Exonéré de commission de mouvement',
            },
          },
          groupe_code_nature: {
            title: 'Groupes de codes nature',
            title_modal_membre: 'Sélection groupe codes nature',
            sens: 'Sens',
            champs: {
              code: 'Code',
              name: 'Nom',
              date_create: 'Date création',
              comment: 'Commentaire',
              title_fiche: 'Fiche du groupe de codes nature {{code}}',
            },
          },
        },
        account_group: {
          table: {
            title: 'Liste des Groupes de Compte',
            error_devise:
              'Vous avez sélectionné des lignes contenant des devises différentes',
            columns: {
              code: 'Code',
              name: 'Nom',
              state: 'Etat',
              update_timestamp: 'Date Modification',
            },
            buttons: {
              type_new: 'Nouveau Type',
            },
          },
          fiche: {
            title: {
              edit_title: 'Fiche du Groupe de Comptes {{code}}',
              new_title: "Création d'un nouveau Groupe de Comptes",
              new_title_type: "Création d'un nouveau Type de Groupe de Comptes",
              member: 'Liste des membres',
              nb_selected: '(Nombre de membre séléctionné : {{nb}})',
              nbs_selected: '(Nombre de membres séléctionnés : {{nb}})',
              edit_type_title:
                "Modification d'une fiche de type de groupe de comptes - {{code}}",
            },
            champ_titles: {
              type: 'Type',
              code: 'Code',
              name: 'Nom',
              cashpool_level: 'Niveau de cashpooling',
              description: 'Description',
              state: 'Etat',
              sub_type: 'Sous-type',
              devise: "Devise de l'autorisation de decouvert",
              group_decouvert: 'Autorisation de découvert du groupe',
              add_decouvert: 'Montant',
              title_modal_add_decouvert: 'Ajout autorisation de découvert ',
              generation_mode: 'Mode de génération',
              label_virement_society: 'Libellé virement intra-société',
              label_virement_group: 'Libellé virement intra-groupe',
              label_virement_account: 'Libellé virement Compte Courant',
              flow: 'Flux par défaut',
              account_debit_code: 'Code compte débit',
              account_credit_code: 'Code compte crédit',
              account_debit_name: 'Nom Compte Débit',
              account_credit_name: 'Nom Compte Crédit',
            },
            buttons: {
              add_account_group: 'Ajouter un groupe de compte',
            },
            columns: {
              code: 'Code',
              name: 'Nom',
              state: 'Etat',
              code_name: 'Code-Nom',
              iban: 'IBAN',
              company: 'Société',
              rounding: 'Arrondi',
              currency: 'Devise',
              amount: 'Solde cible',
              pivot: 'Pivot',
              member_decouvert: 'Autorisation de découvert',
            },
          },
          modal: {
            title: {
              account: 'Sélection de comptes bancaires',
              account_group: 'Sélection de groupe de comptes',
              update: 'Modification du groupe de compte',
            },
            choice: {
              nope: 'Non',
              yes: 'Oui',
            },
            buttons: {
              add: 'Ajouter',
              close: 'Annuler',
            },
            champ_titles: {
              pivot: 'Pivot',
              amount: 'Seuil',
              arounding: 'Arrondi',
            },
          },
        },
        reports: {
          table: {
            title: 'Liste des Etats de trésorerie',
            columns: {
              code: 'Code',
              name: 'Nom',
              update_timestamp: 'Date Modification',
            },
          },
          fiche: {
            title: {
              edit_title: "Fiche de l'état tréso {{code}}",
              new_title: "Création d'un nouvel Etat",
              member: 'Liste des membres',
              fiche: 'Caractéristiques',
              fiche_zoom: 'Caractéristique Zoom',
              diffusion: 'Diffusion',
            },
            champ_titles: {
              type: 'Type',
              code: 'Code',
              name: 'Nom',
              selection: 'Selection',
              period_type: 'Type Période',
              period: 'Période',
              unit: 'Unité',
              forecast: 'Prévision',
              category: 'Catégorie',
              nature: 'Nature',
              min_amount: 'Montant Min',
              max_amount: 'Montant Max',
              label: 'Libelle',
              mode: 'Mode',
              mail_adress: 'Adresses emails',
              user_smart_tag: 'Smart Tags utilisateurs',
              user_groupsmart_tag: "Smart Tags groupe d'utilisateur",
              detail: 'Détail',
              ecart: 'Ecart',
              elem: 'Elément',
            },
            columns: {
              code: 'Code',
              name: 'Nom',
            },
          },
          modal: {
            title: 'Sélection de membres',
            buttons: {
              add: 'Ajouter',
              close: 'Annuler',
            },
          },
        },
        treasury_rules: {
          table: {
            title: 'Liste des Règles de trésorerie',
            columns: {
              code: 'Code',
              name: 'Nom',
              auto: 'Auto/Manuel',
              ordre: 'Ordre',
              update_timestamp: 'Date Modification',
              state: 'Etat',
              category: 'Catégorie',
              releve: 'Sur Relevé',
              prevision: 'Sur Prevision',
              flux: 'Sur Flux',
            },
          },
          fiche: {
            title: {
              edit_title: 'Fiche du Règle trésorerie {{code}}',
              new_title: "Création d'un nouveau Groupe de Comptes",
              new_title_type: "Création d'un nouveau Type de Groupe de Comptes",
              new_rule_title: "Création d'une nouvelle Règle",
              member: 'Liste des membres',
              criteria_reconciliation: 'Critères Rapprochement',
              member_selection: 'Sélectionner de membres',
            },
            champ_titles: {
              type: 'Type',
              code: 'Code',
              name: 'Nom',
              category: 'Catégorie',
              selection: 'Sélection',
              mode: 'Mode',
              execution_order: "Ordre d'exécution",
              cashpool_level: 'Niveau de cashpooling',
              description: 'Description',
              state: 'Etat',
              deviation_allowed: 'Ecart autorisé',
              rappro_number: 'Rapprochement par Numéro de pièce',
              ecart_autorise: 'Ecart autorisé',
              nature: 'Nature',
              libelle: 'Libellé',
              placeholder_category: 'Saisir le Code Catégorie',
              placeholder_selection: '- Sélection -',
              placeholder_gap: 'Ecart sur montant autorisé',
              placeholder_rule_code: 'Code de la règle',
              placeholder_rule_name: 'Nom de la règle',
              placeholder_montant_autorise: 'Ecart sur montant autorisé',
              placeholder_libelle: 'Contient le libellé',
              applique_releve: 'A appliquer sur les relevés',
              applique_temporaire: 'A appliquer sur les prévisions temporaires',
              applique_flux: 'A appliquer sur les flux',
              flux: 'Flux',
              ventilation: 'Critères Ventilation',
            },
          },
        },
        etablish_externe: {
          table: {
            title: 'Liste des établissement externes',
            button_account_title: 'Comptes bancaires',
            columns: {
              etablish_name: 'Etablissement',
            },
          },
          fiche: {
            title: "Création d'un nouvel établissement externe",
            titleEdit: "Fiche de l'établissement externe {{name}}",
          },
        },
        etablish_externe_compte: {
          table: {
            title: 'Liste des comptes bancaires des établissements externes',
            columns: {
              etablish_name: 'Etablissement',
            },
          },
          fiche: {
            title: "Création d'un nouveau compte externe",
            titleEdit: 'Fiche du compte {{name}}',
          },
        },
      },
      currentAccount: {
        Liste: {
          fiche: {
            titles: {
              edit_title: 'Fiche du compte courant {{code}}',
              new_title: "Création d'un nouveau compte courant",
              view_title: 'Fiche du compte courant',
              characteristics: 'Caractéristiques',
              rate_management: 'Gestion des taux',
              interest_management: 'Gestion des intérêts',
              agiosManagement: 'Gestion des Agios',
              flow_management: 'Flux',
              cashpool: 'CashPool bancaire',
              billing: 'Facturation',
            },
            buttons: {
              back: 'Annuler',
              save: 'Valider',
              create: 'Créer',
            },
            champ_titles: {
              p_company: 'Société mère',
              c_company: 'Société fille',
              type: 'Type',
              name: 'Nom',
              start_date: 'Date début',
              end_date: 'Date fin',
              cashpool_management: 'Gestion du CashPool',
              state: 'Etat',
              currency: 'Devise',
              interest_management: 'Gestion des intérêts',
              value_date: 'Date de valeur',
              p_account: 'Compte société mère',
              c_account: 'Compte société fille',
              credit_note: 'Note de crédit',
              debit_note: 'Note de débit',
              invoice_counter: 'Compteur facture',
              banking_cashpool:
                'Remontée de mouvements bancaires dans le compte courant',
              email: 'Emails',
              inmail_facturation: 'Facturation par email',
              facturation_ref: 'Référence facturation',
            },
            table_rate: {
              title: 'Selection des taux',
              name: 'Nom',
              margin: 'Marge',
              margin_rate: 'Marge/Taux',
              basis: 'Base',
              fix_var: 'Fixe/Var',
              start_date: 'Date début',
              end_date: 'Date fin',
              debit: 'Débit',
              credit: 'Crédit',
            },
            table_account: {
              title: 'Selection de comptes bancaires',
              state: 'Etat',
              name: 'Code-Nom',
              iban: 'IBAN',
              company: 'Société',
              bank: 'Banque',
              category: 'Catégorie',
              label: 'Libellé',
              sense: 'Sens',
              start_date: 'Date début',
            },
            modal_rate: {
              title: 'Modification du lien du taux',
              start_date: 'Date de début',
              end_date: 'Date de fin',
              debtor: 'Taux des intérêts débiteur',
              creditor: 'Taux des intérêts créditeur',
              floor: 'Montant Floor',
              cap: 'Montant Cap.',
            },
            modal_account: {
              title: 'Modification du lien du compte',
              category: 'Catégorie recherchée',
              label: 'Libellé recherché',
              inverse_sign: 'Inverser le sens du mouvement',
              start_date: 'Date de début',
              value_date: 'Choix date',
            },
            info_modal: {
              title: 'Liste des mot-clés',
              label: {
                now: '<DATE>',
                year: '<DATEQUANTIEME>',
                hour1: '<HEURE>',
                hour2: '<HEURE_LONG>',
                p_company: '<CODESOCIETE_MERE>',
                c_company: '<CODESOCIETE_FILLE>',
                name: '<NOM>',
              },
              value: {
                now: 'Date du jour format AAMMJJ',
                year: 'Année sur 2 caractères suivi du quantième',
                hour1: 'Heure au format HHMMSS',
                hour2: 'Heure au format HHMMSSCCC',
                p_company: 'Code de la société mère',
                c_company: 'Code de la société fille',
                name: 'Nom du compte courant',
              },
            },
          },
          table: {
            header: {
              title: 'Liste des comptes courants',
              new_account: 'Nouveau',
              purge: 'Purger',
              confirme_purge:
                'Vous désirez purger les relevés des comptes courants sélectionnés. Attention ! Cette opération est définitive. Voulez-vous continuer',
            },
            filters: {
              state: '-Etat-',
              type: '-Type',
            },
            searchInput: {
              caption: 'Rechercher un compte courant par code, nom ou société',
            },
            columns: {
              state: 'Etat',
              name: 'Nom du compte courant',
              parent_company: 'Société mère',
              child_company: 'Société fille',
              type: 'Type',
              balance: 'Solde',
              currency: 'Devise',
              end_date: 'Date de solde',
              date: 'Date de modification',
              credit_rate: 'Taux crédit',
              debit_rate: 'Taux débit',
              periode: 'Période calcul',
            },
            button: {
              history: 'Historique',
              statement: 'Relevé',
            },
          },
          releve: {
            header: {
              title: 'Visualisation du relevé de compte courant {{name}}',
              addfile: 'Importer',
              modal: "Détail de l'opération",
              import: "Import d'un relevé de compte courant",
            },
            fields: {
              label: "Libellé de l'opération",
              amount: 'Montant',
              valueDate: 'Date de valeur',
            },
          },
          history: {
            header: {
              title: 'Historique du compte courant {{name}}',
            },
            columns: {
              label: 'Libellé',
              start_date: 'Date de début',
              end_date: 'Date de fin',
              amount: 'Montant',
              currency: 'Devise',
            },
            modal: {
              title: "Visualition du calcul d'intérêt",
              start_date: 'Date de début de période',
              num_days: 'Nb jours',
              position: 'Position',
              rate: 'Taux',
              debtor_interest: 'Intérêt débiteur',
              creditor_interest: 'Intérêt créditeur',
            },
          },
        },
        Calculation: {
          table: {
            header: {
              title: 'Calcul des comptes courants',
              calculate: 'Lancer le calcul',
            },
            filters: {
              type: '-Type',
            },
            columns: {
              name: 'Nom du compte courant',
              parent_company: 'Société mère',
              child_company: 'Société fille',
              type: 'Type',
            },
            modal: {
              title: 'Calcul de compte courant',
              month_end_calculation: 'Calcul de fin de mois',
              calculate: 'Calculer',
              close: 'Annuler',
              errorMessage: 'Veillez remplir les dates de début et de fin',
              period: 'Période de calcul',
              last_balance_date: 'Date de dernier solde (pour calcul avancé)',
              last_rate_date: 'Date de dernier taux (pour calcul avancé)',
            },
          },
        },
        Analyse: {
          balance_title: 'Soldes des comptes courants',
          analysis_title: 'Analyse des comptes courants',
          header: {
            balance_date: 'Date solde',
            interest_date: "Période d'intérêts",
          },
          columns: {
            debit: 'Condition Sté Emprunteuse',
            credit: 'Condition Sté Préteuse',
            provision_interest: 'Interêt provision',
            final_interest: 'Interêt définitif',
            current_account: 'Comptes courants',
          },
        },
        AccountRemunerer: {
          table: {
            header: {
              title: 'Liste des comptes rémunérés',
              new_account: 'Nouveau',
            },
            filters: {
              state: '-Etat-',
              type: '-Type',
            },
            searchInput: {
              caption:
                'Rechercher un compte rémunérés par code, nom ou société',
            },
            columns: {
              state: 'Etat',
              name: 'Nom du compte',
              etab: 'Etablissement',
              company: 'Société',
              credit_rate: 'Taux crédit',
              balance: 'Solde',
              currency: 'Devise',
              end_date: 'Date de solde',
              date: 'Date de modification',
            },
            button: {
              history: 'Historique',
              statement: 'Relevé',
            },
          },
          fiche: {
            new_title: 'Fiche d’un compte rémunéré',
            edit_title: 'Fiche d’un compte rémunéré {{code}}',
            titles: {
              characteristics: 'Caractéristiques',
              rate_management: 'Gestion des taux',
              interest_management: 'Gestion des intérêts',
              agiosManagement: 'Gestion des Agios',
              flow_management: 'Flux',
              cashpool: 'CashPool bancaire',
              billing: 'Facturation',
            },
            champ_titles: {
              p_company: 'Etablissement financier',
              c_company: 'Société',
              name: 'Nom',
              start_date: 'Date début',
              end_date: 'Date fin',
              state: 'Etat',
              currency: 'Devise',
              interest_management: 'Gestion des intérêts',
              value_date: 'Date de valeur',
              p_account: 'Compte société mère',
              c_account: 'Compte société fille',
              credit_note: 'Note de crédit',
              debit_note: 'Note de débit',
              invoice_counter: 'Compteur facture',
              banking_cashpool:
                'Remontée de mouvements bancaires dans le compte courant',
              email: 'Emails',
              inmail_facturation: 'Facturation par email',
              facturation_ref: 'Référence facturation',
              interest: 'Intérêts',
              modeCalcul: 'Mode Calcul',
              compteSocieter: 'Compte société',
              remote: 'Remontée de mouvements bancaires dans le compte',
            },
            compl_fields: {
              first_interest_date: 'Date premier intérêt',
              init_stmt_btn: 'Initialiser le relevé',
              init_amount: "Solde d'ouverture",
              confirm_purge:
                'Ce compte contient déjà des relevés de valeurs. \nSouhaitez-vous tous les supprimer ? \n\n Attention : cette action est irréversible.',
            },
          },
          visualisation: {
            title: 'Visualisation du relevé de compte rémunéré {{name}} ',
            columns: {
              label: 'Libellé',
              complementary_label: 'Libellé complémentaire',
              reference: 'Référence',
              tiers: 'Tiers',
              document_number: 'N° Pièce',
              category: 'Catégorie',
              transaction_code: 'Code',
              devise: 'Devise',
              operation_date: "Date d'opération",
              value_date: 'Date de valeur',
              debit: 'Débit',
              credit: 'Crédit',
              currency: 'Devise',
            },
          },
        },
        AccountCapital: {
          table: {
            header: {
              title: 'Liste des Contrats de capitalisation',
              new_account: 'Nouveau',
            },
            filters: {
              state: '-Etat-',
              type: '-Type',
            },
            searchInput: {
              caption:
                'Rechercher un contrat de capitalisation par code, nom ou société',
            },
            columns: {
              state: 'Etat',
              name: 'Nom du Contrat de capitalisation',
              etab: 'Etablissement',
              company: 'Société',
              rate: 'Taux',
              date: 'Date début',
              end_date: 'Date Fin',
              balance: 'Solde',
              currency: 'Devise',
              date_modification: 'Date de modification',
            },
            button: {
              history: 'Historique',
              statement: 'Relevé',
            },
          },
          fiche: {
            new_title: "Fiche d'un  contrat de capitalisation",
            edit_title: 'Fiche d’un contrat de capitalisation {{code}}',
            champ_titles: {
              liq: 'Liquidité',
            },
          },
          visualisation: {
            title: 'Visualisation du relevé de contrat de capitalisation',
          },
        },
      },
      evenement: {
        listes: {
          title: 'Liste des événements',
          fiche: {
            title_fiche: "Fiche de l'évènement {{label}} n° {{number}}",
            title_cache: 'Virements de Cash-Pooling',
            title_compte: 'Intérêts des comptes courants',
            title_echeance: 'Paiement écheance',
            title_placement: 'Placement',
            imprime: 'Imprimer',
            envoi_mail: 'Envoyer par email',
            msg_confirm_mail: "Voulez-vous envoyer l'état par email ",
            champs: {
              type: ' Type',
              sub_type: 'Sous-type',
              etat: 'Etat',
            },
            modal: {
              title: 'Modification du calcul',
              amount: 'Montant',
              date: 'Date',
              batch_warning:
                'IMPORTANT : Le flux est présent dans le parapheur, veuillez le supprimer du lot.',
            },
            culumns: {
              name: 'Nom',
              emetter: 'Emetteur',
              benefic: 'Bénéficiaire',
              amount: 'Montant',
              devise: 'Devise',
              etat: 'Etat',
              date: 'Date',
            },
            generate_entries: 'Génération écritures',
            validate_entries: 'Valider',
            archivage: 'Réaliser',
          },
        },
        liste: {
          table: {
            title: 'Liste des taux de référence personnalisés',
            columns: {
              event_num: 'Num Evnt',
              type: 'Type',
              sub_type: 'Sous-type',
              libelle: 'Libellé',
              nb: 'Nb',
              amount: 'Montant',
              currency: 'Devise',
              state: 'Etat',
              date: 'Date de création',
              login: 'Login',
            },
          },
          fiche: {
            edit_title: 'Fiche du taux de référence personnalisé {{name}}',
            new_title: "Création d'un nouveau taux de référence personnalisé",
            champ_titles: {},
          },
        },
      },
      debt: {
        list: {
          title: {
            credit_line: 'Liste des lignes de crédit',
          },
          columns: {
            name: 'Nom',
            type: 'Type',
            lender_company: 'Société Prêteur',
            borrowing_company: 'Société Emprunteur',
            currency: 'Devise',
            amount: 'Montant',
            available_amount: 'Montant disponible',
            state: 'Etat',
            start_date: 'Date début',
            end_date: 'Date fin',
          },
          buttons: {
            delete: 'Supprimer',
            addTirage: 'Nouveau tirage',
            btn_paiement: 'Paiement des échéances',
          },
        },
        detail: {
          drawer: {
            title: "Détail de l'échéance",
            card_payement: 'Paiement',
            champ_titles: {
              state: 'Etat',
              timeline: 'Echéance',
              start_date: 'Date Début',
              end_date: 'Date Fin',
              payment_date: 'Date Paiement',
              timeline_date: 'Date Echéance',
              capital_amount_paid: 'Montant Capital versé ou remboursé',
              capital: 'Montant Capital',
              interests_amount: 'Montant Intérêt',
              capital_interests: 'Génération',
              flow: 'Flux',
              compte_mere: 'Compte société Mère',
              compte_fils: 'Compte Société Fille',
            },
            buttons: {
              save_continue: 'Valider - Suivant',
            },
          },
          modal: {
            title: 'Nouveau',
            change_date: 'Modifier la date de la première échéance',
            alert:
              "Voulez-vous ajouter une échéance après l'échéance sélectionnée. Toutes les échéances suivantes seront décalées",
            buttons: {
              yes: 'oui',
              no: 'non',
            },
          },
          columns: {
            timeline_number: 'N° Ech.',
            period: 'Période',
            description: 'Description',
            number_day: 'Nb Jour',
            timeline_date: 'Date Echéance',
            payment_date: 'Date Paiement',
            capital: 'Capital',
            k_movement: 'Mouvement K',
            interests: 'Intérêts',
            accumulated_interest: 'Cumul Intérêts',
            remaining_capital: 'Capital Restant',
            due_amount: 'Echéance',
            state: 'Etat',
          },
          title: "Visualisation de l'échéancier {{name}}",
          titleCalculInt: 'Calcul des intérêts',
          msgCalcul: 'Etes-vous sûr de vouloir lancer le calcul des intérêts',
          buttons: {
            add: 'Ajouter',
            calculInteret: 'Calcul Echéances',
            calculEchues: 'Calcul des échéances non échues',
            calculEcheances: 'Calcul de toutes les échéances',
            mes1: 'Etes-vous sûr de vouloir lancer le calcul des échéances Non échues',
            mes2: 'Etes-vous sûr de vouloir lancer le calcul des TOUTES les échéances',
            mes3: 'Etes-vous sûr de vouloir remplacer TOUTES vos échéances par le  fichier selectionné',
            mes4: '{{errorMessage}}\n Souhaitez vous continuer tout de même',
            calcul: 'Exécuter le calcul des intérêts',
          },
        },
        fiche: {
          title: {
            timeline: {
              new: "Création d'une nouvelle échéance",
              edit: 'Fiche du Code {{name}}',
              renew: "Renouvellement de l'objet Dette {{name}}",
            },
            echeance: {
              new: "Création d'une nouvelle échéance",
              edit: '{{name}}',
            },
            credit_line: {
              new: "Création d'une nouvelle ligne de crédit",
              edit: 'Fiche de la ligne de credit {{name}}',
            },
            characteristic: 'Caractéristiques',
            interest_management: 'Gestion des intérêts',
            rate_management: 'Gestion du taux',
            capital_amortization: 'Amortissement du Capital',
            forecast_management: 'Gestion des prévisions',
            mail_alert: 'Alerte Mail',
            readonly: 'Lecture seul',
            doc: 'Documents',
          },
          buttons: {
            add: 'Ajouter',
            validate: 'Valider',
            close: 'Annuler',
            join: 'Joindre',
          },
          modal: {
            title: {
              rate: 'Sélection des Taux',
              edit_rate: 'Modification du lien du taux',
              doc: 'Document',
              confirm_evt: "Voulez-vous générer l'évènement de versement",
              confirm_pymt: 'Voulez-vous payer ces échéances',
            },
            columns: {
              margin: 'Marge/Taux',
              base: 'Base',
              fixe_variable: 'Fixe/Var',
            },
            champ_titles: {
              start_date: 'Date de début',
              end_date: 'Date de fin',
              doc_type: 'Type de document',
              doc_name: 'Nom Document',
              state: 'Etat',
              pdf_doc: 'Document PDF',
            },
          },
          columns: {
            margin: 'Marge',
            date: 'Date',
            doc_name: 'Nom Document',
            doc_type: 'Type Document',
            state: 'Etat',
            visualization: 'Visuslaisation',
          },
          champ_titles: {
            type: 'Type',
            name: 'Nom',
            start_date: 'Date Début',
            end_date: 'Date Fin',
            first_maturity_date: 'Date 1ere Echéance',
            amount: 'Montant',
            rate: 'Taux',
            break: 'Rompu',
            interests: 'Intérêts',
            period: 'Génération',
            debit_nature: 'Nature débit',
            credit_nature: 'Nature crédit',
            commission: 'Commission',
            borrowing_company: 'Société emprunteur',
            lender_company: 'Société prêteur',
            state: 'Etat',
            currency: 'Devise',
            flow: 'Flux',
            child_account: 'Compte Société Fille',
            parent_account: 'Compte société Mère',
            emails: 'Emails',
            liquidity: 'Liquidité',
            without_amort: 'Sans amortissement',
            with_amort: 'Avec amortissement',
            interest_calculation_mode: "Méthode de calcul d'intérêt",
          },
          placeholder: {
            flow: '<Paiement hors flux Opencash>',
          },
          alert: {
            break_change:
              "La première date d'échéance sera automatiquement définie en fonction du nouveau rompu choisi",
          },
        },
        payement: {
          payed: 'Payer les échéances',
          icne: 'Calcul des ICNE',
          titleSelectDate: 'Selection de la date',
          date: 'Date :',
          column: {
            tirage_name: 'Tirage',
            credit_line_name: 'Ligne de credit',
            num: 'N°',
            periode: 'Période',
            nbrJ: 'Nb Jour',
            dateEch: 'Date Echéancier',
            dateP: 'Date Paiement',
            capital: 'Capital',
            echeance: 'Echéance',
            interet: 'Intérêts',
            mouvement: 'Mouvement K',
            capitalRest: 'Capital Restant',
            cumulRes: 'Cumul Restant',
            cumulInt: 'Cumul Intérêts',
            status: 'Etat',
          },
        },
        emprunt: {
          titlecreation: "Création d'une nouvelle emprunt",
          edit: "Fiche d'un emprunt  {{name}}",
          title: 'Liste des Emprunts',
          newTirage: 'Nouvel échéancier',
          capital: 'Capital',
        },
        placement: {
          compteTitre: {
            title: 'Liste des comptes titres ',
            lender_company: 'Etablissement financier ',
            borrowing_company: 'Société ',
            valeur: 'Valeur',
            titleDrawer: "Ajout d'une nouvelle Valeur",
            titleEdit: "Modification d'une nouvelle Valeur",
            visualisation: {
              title: 'Visualisation du rélévé de compte titre {{name}}',
              column: {
                label: 'Libellé',
                quantite: 'Quantité',
                date_v: 'Date de valeur',
                cours: 'Cours/Cours achat moyens',
                amount: 'Montant',
                position: 'Position',
                value: '+/- Value',
                devise: 'Devise',
              },
              drawer: {
                title: "Création d'un nouveau mouvement",
                edit: "Modification d'un mouvement ",
                achat: 'Achat',
                vente: 'Vente',
                dateOperation: "Date d'opération",
                dateValeur: 'Date de valeur',
                prix: 'Prix',
                messQuantite: 'Veuillez saisir le montant ou la quantité.',
                quantite: 'Quantité',
                montantT: 'Montant total',
                erreur_msg: 'Quantité en stock disponible : {{quantiteMax}}',
              },
            },
          },
          fiche: {
            title: 'Fiche du Compte titre',
            payementManagement: 'Gestion des Paiements',
            etabFinance: 'Etablissement financier',
            emprunteur: 'Société ',
            compteEtablissement: 'Compte établissement',
            compteSocieté: 'Compte société',
          },
          compteTerme: {
            title: 'Liste des comptes à terme ',
            ficheTitle: 'Fiche du comptes à terme',
            payment: 'Paiement',
            timeline: 'Gestion échéance',
            generate_event: 'Générer Evènement',
            message: 'Voulez-vous générer les évènements',
            renew: 'Renouveler',
          },
        },
        consultation: {
          title: 'Consultation des échéances',
          titlePlct: 'Consultation des placements',
          column: {
            timeline_name: 'Échéancier',
            company_code: 'Société',
            start_date: 'Début',
            end_date: 'Fin',
            counterpart: 'Contrepartie',
            society: 'Société',
            market_room: 'Salle de marché',
            intermediare: 'Intermédiaire',
            directing_rate: 'Taux',
            rate_margin: 'Marge',
            calculation_base: 'Base',
            rate_type: 'Type Taux',
            f_capital: 'Frequence capital',
            depreciation_type: 'Type amortissement',
            f_interest: 'Frequence intérêt',
            nominal: 'Nominal',
            amount: 'Montant',
            next_due_date: 'Prochaine échéance',
            interest: 'Intérêt',
            icne: 'Intérêts courus',
            depreciated_capital: 'Capital amorti',
            period: 'Période',
            price: 'Cours achat',
            quantity: 'Quantité',
            value: '+/- Latente',
            last_rate: 'Cours actuel',
            nbJr: 'N° jours',
            nbJrICNE: 'Nb jour courus',
            nbJrCome: 'Nb Jour à venir',
            nbJrICNECome: 'Intérêts à venir',
            periode: 'Période calcul',
            nbJour: 'Nb jour',
            date_interet: 'Date Intérêt',
          },
        },
        analyse_plct: {
          title: 'Analyse des placements',
          period_1: 'Période de référence 1',
          period_2: 'Période de référence 2',
          column: {
            return: 'Rendement',
            net_change: 'Mouvements nets',
            period_1: 'Période 1',
            period_2: 'Période 2',
          },
        },
        value_gestion: {
          table: {
            title: 'Liste des valeurs',
            button_chargement_cours: 'Chargement Cours',
            columns: {
              status: 'Etat',
              type: 'Type',
              code: 'Code ISN',
              mnemonic: 'Mnémonique',
              lastrate: 'Dernier Cours',
              ratedate: 'Date Cours',
              favorite: 'Favoris',
            },
          },
          fiche: {
            title_new: "Ajout d'une nouvelle valeur",
            title_edit: "Fiche d'une nouvelle valeur : {{code}}",
            first_card_title: 'Général',
            code_isin: 'Code ISIN',
            code_nemonic: 'Mnémonique',
            name: 'Nom',
            second_card_title: 'Caractéristique',
            type: 'Type',
            place_cotation: 'Place de Cotation',
            third_tilte: 'Audit',
            date_creation: 'Date Création',
            date_modif: 'Date Modification ',
          },
          visualise: {
            table: {
              title: 'Cours de la valeur',
              rate: 'Cours',
              date: 'Date Cours',
            },
            modal: {
              title: "Ajout d'un cours",
            },
          },
          chargement: {
            table: {
              title: 'Liste des valeurs',
              column: {
                rate: 'Cours',
                date: 'Date de Modification',
                code: 'Code',
                type: 'Type',
                name: 'Nom',
              },
            },
            modal: {
              title: "Ajout d'un cours",
              date: 'Date de mise à jour ',
            },
          },
        },
        analyse_dept: {
          title: 'Analyse Dette',
          placement_etab: 'Dette par  établissement financiers',
          repartition_type: 'Répartition par type',
          placement_societe: 'Dette par société',
        },
      },
      Budgets: {
        scenario: {
          list: {
            title: 'Liste des scénarios budgets',
            culumn: {
              etat: 'Etat',
              code: 'Code',
              name: 'Nom',
              type: 'Type',
              period: 'Période',
              user: 'User',
              date_modif: 'Date de modification',
            },
          },
          fiche: {
            titleNew: "Création d'un nouveau scénario",
            editTitle: "Fiche d'un scenario {{code}}",
            title_code_list: 'Liste des codes natures',
            title_category_list: 'Liste des codes catégories',
            code_natureAll_placehoder: '- Tous les Codes Nature -',
            code_categoryAll_placehoder: '- Tous les Codes Catégories -',
            message_confirme_purge_budget:
              'Voulez-vous supprimer toutes les données « Budget » de votre sénario  ',
            message_confirme_purge_realisé:
              'Voulez-vous supprimer toutes les données « Réalisé » de votre sénario  ',
            purge_budget: 'Purge Budget',
            purge_realisé: 'Purge Réalisé',
            import_budget: 'Importer',
            champs: {
              etat: 'Etat',
              code: 'Code',
              descri: 'Description',
              caracteristic: 'Caractéristiques',
              annee: 'Année',
              type: 'Type séléction',
              type_code: 'Type code',
              periode: 'Periode',
              month: 'Mois de Début',
              filtre_code: 'Filtre sur code',
            },
            message_validation:
              'Les conditions ont été modifiées. Les périodes vont être supprimées. Désirez-vous continuer ',
          },
          visualise: {
            title: 'Visualisation du scénario',
            type_placeholder: '- Type -',
            period_placeholder: '- Période -',
            code_nature_placehoder: '- Code Nature -',
            applique: 'Appliquer',
            action: {
              import_annuel: 'Importer données années précédentes',
              import: 'Importer Excel',
              action: 'Action',
              recherche: 'Rechercher par an',
            },
            modal_import: {
              title: 'Importer données années précédentes',
              annee: 'Année',
            },
          },
        },
        analyste: {
          title: 'Analyse Budget',
          titleDrawer:
            'Scénario: Budget {{year}} - {{ name }} {{label}} {{year}}',
          devise: 'Devise',
          scenario: '- Scénario -',
          total_treso: 'Total Trésorerie',
          total_depense: 'Total Dépenses',
          total_recette: 'Total Récette',
          culumn: {
            nature: 'Nature',
            label: 'Libelle',
            devise: 'Devise',
            montant_bud: 'Montant budget',
            montant_realiser: 'Montant réalisé',
            montant_prev: 'Montant prévisions',
            avancement_realiser: 'Avancement réalisé',
            avancement_realiserPrev: 'Avancement réalisé et prévisions',
          },
        },
      },
    },
    document: {
      document: {
        document_signataire: {
          title: 'Liste des collèges documents',
          fiche: {
            title: "Création d'un nouveau collège de document",
            edit_title: "Modification d'un collège de document",
          },
        },
        authority_signataire: {
          title: 'Liste des pouvoirs documents',
          fiche: {
            title: "Création d'un nouveau pouvoir de signature document",
            edit_title: "Modification d'un pouvoir de signature document",
          },
        },
        generation_document: {
          title: 'Génération Pouvoir',
          btn_generate: 'Générer',
          bank_placeholder: '- Banque -',
          gliss_placeholder: '- Faites glisser ici pour grouper -',
          flux_filter: '- Document -',
          pouvoir_filter: '- Pouvoir -',
          mandateUser_filter: '- Mandants physiques -',
          mandateCompany_filter: '- Mandants morales -',
          direct_mandate: 'Mandant direct',
          fiche: {
            bank: 'Banque',
            iban: 'IBAN',
            devise: 'Devise',
            pouvoir_bancaire: 'Pouvoir Bancaire',
            date_modif: 'Date de modification',
            flow_name: 'Flux',
          },
        },
        validation_document: {
          title: 'Liste des Pouvoirs',
          btn_imprime: 'Imprimer',
          btn_sendsignatory: 'Envoi signataires',
          btn_signature: 'Valider',
          btn_attribut: 'Attribuer',
          btn_carton: 'Cartons de signatures',
          btn_identity: 'Pièces identités',
          message_confirm_attibute: 'Voulez vous vraiment attribuer ce compte',
          column: {
            num: 'N°',
            state: 'Etat',
            account: 'Compte',
            society: 'Société',
            pouvoir: 'Pouvoir',
            currency: 'Devise',
            login: 'Login',
            date: 'Date',
            signatories: 'Signataire',
            bank: 'Banque',
            code: 'Code compte ',
            flow: 'Flux',
          },
          audit_validation: {
            date: 'Date',
            login: 'Login',
            action: 'Action',
          },
          actions: {
            upload: 'Charger document signé',
          },
        },
        sign_document: {
          title: 'Liste des signatures documents',
        },
        gestion_document: {
          table: {
            title: 'Liste des Signataires',
            tilte_send_mail_bank: 'Envoi email Banquier',
            tilte_send_mail_signataire: 'Envoi email Signataire',
            head_filtre_placeholder: '- Tous les collèges -',
            email_bank: 'Email',
            icon_mail_bank: 'Envoyer email à banque',
            icon_mail_signataire: 'Envoyer email à signataire',
            culumn: {
              state: 'Etat',
              login: 'Login',
              name: 'Nom',
              lastname: 'Prénom',
              mail: 'Email',
              numphone: 'N° mobile',
              date: 'Date de Validité',
              cn: 'CNI',
              passport: 'Passeport',
              signature: 'Signature',
              date_birth: 'Date de naissance',
              country_birth: 'Pays de naissance',
              place_birth: 'Lieu de naissance',
              nationality: 'Nationalité',
              num_cin: 'Numéro CIN',
              date_cin: 'Date validation',
              civility: 'Civilité',
              function: 'Fonction',
            },
          },
        },
        histo_document: {
          title: 'Liste des historiques documents',
          date_sign: 'Date Signature',
          date_envoi: 'Date Envoi Banque',
          date_recep: 'Date Réception',
          date_retour: 'Date Retour Banque',
          button_action: {
            title: 'Action',
            envoi: 'Envoi banque',
            retour: 'Validation banque',
            recep: 'Réception banque',
            refus: 'Refus banque',
          },
          send_bank_modal: {
            email: 'Emails',
            bank: 'Banque',
            subject: 'Objet',
            send: 'Envoyer',
          },
        },
        document_authority: {
          titles: {
            by_account: {
              generation: 'Génération documents comptes',
              validation: 'Liste de documents comptes',
            },
            by_company: {
              generation: 'Génération documents sociétés',
              validation: 'Liste de documents sociétés',
            },
          },
        },
        mandant: {
          title: 'Liste des Mandants',
          filter: {
            societe: 'Sociétés',
            societe_mandat: 'Sociétés Mandant',
            mandant_pers: 'Mandant Personnes physique',
            direct_mandant: 'Mandant direct',
          },
          column: {
            state: 'Etat',
            code: 'Code',
            name: 'Nom',
            pays: 'Pays',
            ordre: 'Ordre',
            type_lien: 'Type Lien Mandant',
            name_mandat: 'Nom Mandant',
            type_mandant: 'Type Mandant',
            fonction: 'Fonction',
            date_start: 'Date début',
            date_end: 'Date fin',
            action: 'Actions',
          },
        },
      },
    },
    user: {
      profile: {
        dashboard_modal: {
          account: 'Mon Compte',
          logout: 'Déconnexion',
          change_log: 'Changelog',
          settings: 'Paramétrage',
        },
        title: 'Mon Compte',
        buttons: {
          save: 'Valider',
          blocked_device: "Bloquer l'appareil",
          authorized_device: "Autoriser l'appareil",
          change: 'Changer le mot de passe',
          qrCode: 'Activer la 2FA',
          edit_qrCode: 'Consulter/Modifier',
          disable_qrCode: 'Désactiver la 2FA',
          totpTxt:
            "Scannez le code QR via une application d'authentification, puis tapez le code à 6 chiffres.",
        },
        tabs: {
          title: {
            informations: 'Mes informations',
            password: 'Mot de passe',
            entities: 'Mes entités',
            connected_devices: 'Mes appareils connectés',
            download: 'Téléchargement',
            card_title_download: 'Téléchargement OpenCash Parapheur',
            card_title_download_pouvoir: 'Téléchargement OpenCash Pouvoir',
            button_name: 'Télécharger',
          },
          champ_titles: {
            login: 'Login',
            email: 'Email',
            last_name: 'Nom',
            first_name: 'Prénom',
            phone_number: 'Téléphone',
            fax: 'Fax',
            mobile_number: 'Mobile',
            receive_email: 'Réception email',
            language: 'Langue',
            new_password: 'Nouveau mot de passe',
            current_password: 'Mot de passe actuel',
            confirm_password: 'Confirmer mot de passe',
            otp_type: 'Type',
          },
          columns: {
            code: 'Code',
            name: 'Nom',
            defined: 'Définir en favori',
          },
        },
      },
    },
    composant: {
      modal_select_filiale: {
        title: 'Sélection de la filiale pour la création',
        code: 'Code',
        nom: 'Nom',
        left_title: 'Signataires seul',
        middle_title: 'Signataires double',
        right_title: 'Mobiles',
        other_title: '',
      },
      details_operation: {
        title: "Détail de l'operation {{name}}",
        libelle: "Libellé de l'opération",
        libelle_complementaire: 'Libellé complémentaire',
        motif: 'Motif',
        montant: 'Montant',
        exempted: 'Exonéré',
        date_operation: "Date de l'opération",
        date_valeur: 'Date de valeur',
        reference: 'Référence',
        endtoend: 'Référence de client à client',
        category: 'Catégorie',
        code_operation: 'Code opération',
        nom_payeur: 'Nom du payeur',
        id_payeur: 'Id du payeur',
        nom_payeur_final: 'Nom du payeur final',
        nom_beneficiaire: 'Nom du bénéficiaire',
        id_beneficiaire: 'Id du bénéficiaire',
        nom_beneficiaire_final: 'Nom du bénéficiaire final',
        id_beneficiaire_final: 'Id du bénéficiaire final',
        reference_remise: 'Référence de la remise',
        reference_transaction: 'Référence de la transaction',
        montant_origine: "Montant d'origine",
        taux_change: 'Taux de change',
        compte_beneficiaire: 'Compte bénéficiaire',
        compte_debiteur: 'Compte débiteur',
        num_ecriture: 'N° Pièce',
        nature_paiement: 'Nature de paiement',
        rum: 'RUM',
        libelle_retour: 'Libellé retour',
      },
      reconciliation: {
        rappro_mvt: 'Mouvements rapprochés',
        rappro_prev: 'Prévisions rapprochées',
        rappro_entry: 'Ecritures rapprochées',
        columns: {
          label: 'Libellé',
          category: 'Catégorie',
          nature: 'Nature',
          value_date: 'Date valeur',
          flux: 'Flux Comptable',
          op_date: 'Date Opération',
          amount: 'Montant',
          currency: 'Devise',
          compte: 'Compte',
        },
        footerRows: {
          num_mvt: 'Nombre de mouvements',
          amount_mvt: 'Montant des mouvements',
          num_prev: 'Nombre de prévisions',
          amount_prev: 'Montant des prévisions',
          num_entries: "Nombre d'écritures",
          amount_entries: 'Montant des écritures',
        },
        user: 'Utilisateur',
        date: 'Date',
        reconciliation_num: 'N° de Rapprochement',
        nature_code: 'Code Nature',
      },
      modal_structured_adress: {
        title: "Génération d'adresse structurée",
        placeholder: 'Saisissez l’adresse ici',
        cancel: 'Annuler',
        send: 'Générer',
        generate: 'Générer l’adresse structurée',
      },
    },
    risk: {
      operationChange: {
        Liste: {
          table: {
            title: 'Liste des opérations de change',
            paid: 'Payée',
            message_confirm_deal: 'Voulez-vous valider ce deal {{code}}',
            message_confirm_denouer: 'Voulez-vous dénouer le deal {{code}}',
            message_confirm_soulte:
              'Voulez-vous payer la soulte du deal {{code}} ',
            audit_action: 'Liste des actions réalisées',
            calendar: 'Calendrier',
            or: 'OU',
            and: 'ET',
            tree: 'Arbre',
            list: 'Liste',
            culumn: {
              event: 'Evénement',
              state: 'Etat',
              code_deal: 'Référence externe',
              date_spot: 'Date Spot',
              compte_dept: 'Compte débité',
              amount1: 'Montant 1',
              availableAmount: 'Montant restant Devise 1',
              dev1: 'Devise 1',
              account_credt: 'Compte crédité',
              amount2: 'Montant 2',
              dev2: 'Devise 2',
              cotation: 'Cotation',
              soult: 'Soulte devise 2',
              accountdev1: 'Compte Devise 1',
              accountdev2: 'Compte Devise 2',
              sens: 'Sens',
              taux1: 'Spot',
              taux2: 'Term',
              py_terme: 'Points de Terme',
              lib: 'Libellé',
              date_opera: "Date d'opération",
              date_term: "Date d'échéance",
              value_date: 'Date de valeur',
              balance_date: "Date d'échéance",
              accrual_date: 'Date de tombée',
              business_code: 'Code affaire',
              update_timestamp: 'Date Modification',
              create_timestamp: 'Date Création',
              log: 'Login',
              society: 'Société',
              account1: 'Compte 1',
              account2: 'Compte 2',
              b2b: 'B2B',
              b2baccount1: 'Compte B2B 1',
              b2baccount2: 'Compte B2B 2',
              counterparty: 'Contrepartie',
              type: 'Type',
              origin: 'Origine',
              code: 'Contrat',
            },
            actions: {
              visualise: 'Visualiser',
              anticipation: 'Anticiper',
              denouement: 'Dénouer',
              proro: 'Proroger',
              paid_soult: 'Paiement Soulte',
              print_contract: 'Confirmation',
            },
          },
          fiche: {
            titles: {
              edit_title: "Fiche d'opération change {{code}}",
              new_title: "Création d'un nouveau opération change",
              view_title: 'Fiche du compte courant',
            },
            champs: {
              state: 'Etat',
              code_deal: 'Référence externe',
              business_code: 'Code affaire',
              date_spot: 'Date Spot',
              compte_dept: 'Compte débité',
              amount1: 'Montant 1',
              dev1: 'Devise 1',
              date_term: "Date d'échéance",
              account_credt: 'Compte crédité',
              amount2: 'Montant 2',
              dev2: 'Devise 2',
              sens: 'Sens',
              taux1: 'Cours spot',
              taux2: 'Cours term',
              py_terme: 'Points de Terme',
              lib: 'Libellé',
              log: 'Login',
              description: 'Description',
              type: 'Type',
              date_opera: "Date de l'opération",
              comment: 'Commentaire',
              balance: 'Balance',
              paiement: 'Mode de paiement',
              template: 'Template',
            },
            buttons: {
              back: 'Annuler',
              save: 'Valider',
              create: 'Créer',
            },
          },
          drawer_denoue: {
            title: 'Validation du deal {{code}}',
            title_maket_room: 'Flux vers salle de marché ',
            title_company: 'Flux vers société',
            title_intermediaire_company: 'Flux vers intermediaire',
            champs: {
              flow: 'Flux',
              account_company: 'Compte société',
              room_market: 'Compte salle marché',
              account_company2: 'Compte holding',
              room_market2: 'Compte société',
              label: 'Libellé',
              nature_debit: 'Nature Débit',
              nature_credit: 'Nature Crédit',
              amount: 'Montant',
              value_date: 'Date Valeur',
              account_intermediary: 'Compte intermédiaire',
            },
          },
          drawer_soult: {
            title: 'Modification soulte',
          },
        },
      },
      cotationChange: {
        Liste: {
          table: {
            title: 'Liste des contrats',
            culumn: {
              state: 'Etat',
              market_room: 'Salle de marché',
              company: 'Société',
              company_intermediaire: 'Société intermediaire',
              date_start: 'Date début',
              date_end: 'Date fin',
              date_edit: 'Date de modification',
            },
          },
          fiche: {
            title: "Création d'un contrat",
            edit_title: 'Fiche du contrat {{code}}',
            champs: {
              name: 'Name',
              market_room: 'Salle de marché',
              code: 'Code',
            },
          },
        },
      },
    },
  },
}

